// WHO Child Growth Standards (0-5 Years) and WHO Growth Reference (5-19 Years)
// Generated automatically from official LMS parameters.

export const WHO_WEIGHT_GIRLS = [
    {
        "month": 0,
        "sdMinus3": 2.0,
        "sdMinus2": 2.4,
        "sdMinus1": 2.8,
        "median": 3.2,
        "sdPlus1": 3.7,
        "sdPlus2": 4.2,
        "sdPlus3": 4.8
    },
    {
        "month": 1,
        "sdMinus3": 2.7,
        "sdMinus2": 3.2,
        "sdMinus1": 3.6,
        "median": 4.2,
        "sdPlus1": 4.8,
        "sdPlus2": 5.5,
        "sdPlus3": 6.2
    },
    {
        "month": 2,
        "sdMinus3": 3.4,
        "sdMinus2": 3.9,
        "sdMinus1": 4.5,
        "median": 5.1,
        "sdPlus1": 5.8,
        "sdPlus2": 6.6,
        "sdPlus3": 7.5
    },
    {
        "month": 3,
        "sdMinus3": 4.0,
        "sdMinus2": 4.5,
        "sdMinus1": 5.2,
        "median": 5.8,
        "sdPlus1": 6.6,
        "sdPlus2": 7.5,
        "sdPlus3": 8.5
    },
    {
        "month": 4,
        "sdMinus3": 4.4,
        "sdMinus2": 5.0,
        "sdMinus1": 5.7,
        "median": 6.4,
        "sdPlus1": 7.3,
        "sdPlus2": 8.2,
        "sdPlus3": 9.3
    },
    {
        "month": 5,
        "sdMinus3": 4.8,
        "sdMinus2": 5.4,
        "sdMinus1": 6.1,
        "median": 6.9,
        "sdPlus1": 7.8,
        "sdPlus2": 8.8,
        "sdPlus3": 10.0
    },
    {
        "month": 6,
        "sdMinus3": 5.1,
        "sdMinus2": 5.7,
        "sdMinus1": 6.5,
        "median": 7.3,
        "sdPlus1": 8.2,
        "sdPlus2": 9.3,
        "sdPlus3": 10.6
    },
    {
        "month": 7,
        "sdMinus3": 5.3,
        "sdMinus2": 6.0,
        "sdMinus1": 6.8,
        "median": 7.6,
        "sdPlus1": 8.6,
        "sdPlus2": 9.8,
        "sdPlus3": 11.1
    },
    {
        "month": 8,
        "sdMinus3": 5.6,
        "sdMinus2": 6.3,
        "sdMinus1": 7.0,
        "median": 7.9,
        "sdPlus1": 9.0,
        "sdPlus2": 10.2,
        "sdPlus3": 11.6
    },
    {
        "month": 9,
        "sdMinus3": 5.8,
        "sdMinus2": 6.5,
        "sdMinus1": 7.3,
        "median": 8.2,
        "sdPlus1": 9.3,
        "sdPlus2": 10.5,
        "sdPlus3": 12.0
    },
    {
        "month": 10,
        "sdMinus3": 5.9,
        "sdMinus2": 6.7,
        "sdMinus1": 7.5,
        "median": 8.5,
        "sdPlus1": 9.6,
        "sdPlus2": 10.9,
        "sdPlus3": 12.4
    },
    {
        "month": 11,
        "sdMinus3": 6.1,
        "sdMinus2": 6.9,
        "sdMinus1": 7.7,
        "median": 8.7,
        "sdPlus1": 9.9,
        "sdPlus2": 11.2,
        "sdPlus3": 12.8
    },
    {
        "month": 12,
        "sdMinus3": 6.3,
        "sdMinus2": 7.0,
        "sdMinus1": 7.9,
        "median": 8.9,
        "sdPlus1": 10.1,
        "sdPlus2": 11.5,
        "sdPlus3": 13.1
    },
    {
        "month": 13,
        "sdMinus3": 6.4,
        "sdMinus2": 7.2,
        "sdMinus1": 8.1,
        "median": 9.2,
        "sdPlus1": 10.4,
        "sdPlus2": 11.8,
        "sdPlus3": 13.5
    },
    {
        "month": 14,
        "sdMinus3": 6.6,
        "sdMinus2": 7.4,
        "sdMinus1": 8.3,
        "median": 9.4,
        "sdPlus1": 10.6,
        "sdPlus2": 12.1,
        "sdPlus3": 13.8
    },
    {
        "month": 15,
        "sdMinus3": 6.7,
        "sdMinus2": 7.6,
        "sdMinus1": 8.5,
        "median": 9.6,
        "sdPlus1": 10.9,
        "sdPlus2": 12.4,
        "sdPlus3": 14.1
    },
    {
        "month": 16,
        "sdMinus3": 6.9,
        "sdMinus2": 7.7,
        "sdMinus1": 8.7,
        "median": 9.8,
        "sdPlus1": 11.1,
        "sdPlus2": 12.6,
        "sdPlus3": 14.5
    },
    {
        "month": 17,
        "sdMinus3": 7.0,
        "sdMinus2": 7.9,
        "sdMinus1": 8.9,
        "median": 10.0,
        "sdPlus1": 11.4,
        "sdPlus2": 12.9,
        "sdPlus3": 14.8
    },
    {
        "month": 18,
        "sdMinus3": 7.2,
        "sdMinus2": 8.1,
        "sdMinus1": 9.1,
        "median": 10.2,
        "sdPlus1": 11.6,
        "sdPlus2": 13.2,
        "sdPlus3": 15.1
    },
    {
        "month": 19,
        "sdMinus3": 7.3,
        "sdMinus2": 8.2,
        "sdMinus1": 9.2,
        "median": 10.4,
        "sdPlus1": 11.8,
        "sdPlus2": 13.5,
        "sdPlus3": 15.4
    },
    {
        "month": 20,
        "sdMinus3": 7.5,
        "sdMinus2": 8.4,
        "sdMinus1": 9.4,
        "median": 10.6,
        "sdPlus1": 12.1,
        "sdPlus2": 13.7,
        "sdPlus3": 15.7
    },
    {
        "month": 21,
        "sdMinus3": 7.6,
        "sdMinus2": 8.6,
        "sdMinus1": 9.6,
        "median": 10.9,
        "sdPlus1": 12.3,
        "sdPlus2": 14.0,
        "sdPlus3": 16.0
    },
    {
        "month": 22,
        "sdMinus3": 7.8,
        "sdMinus2": 8.7,
        "sdMinus1": 9.8,
        "median": 11.1,
        "sdPlus1": 12.5,
        "sdPlus2": 14.3,
        "sdPlus3": 16.4
    },
    {
        "month": 23,
        "sdMinus3": 7.9,
        "sdMinus2": 8.9,
        "sdMinus1": 10.0,
        "median": 11.3,
        "sdPlus1": 12.8,
        "sdPlus2": 14.6,
        "sdPlus3": 16.7
    },
    {
        "month": 24,
        "sdMinus3": 8.1,
        "sdMinus2": 9.0,
        "sdMinus1": 10.2,
        "median": 11.5,
        "sdPlus1": 13.0,
        "sdPlus2": 14.8,
        "sdPlus3": 17.0
    },
    {
        "month": 25,
        "sdMinus3": 8.2,
        "sdMinus2": 9.2,
        "sdMinus1": 10.3,
        "median": 11.7,
        "sdPlus1": 13.3,
        "sdPlus2": 15.1,
        "sdPlus3": 17.3
    },
    {
        "month": 26,
        "sdMinus3": 8.4,
        "sdMinus2": 9.4,
        "sdMinus1": 10.5,
        "median": 11.9,
        "sdPlus1": 13.5,
        "sdPlus2": 15.4,
        "sdPlus3": 17.7
    },
    {
        "month": 27,
        "sdMinus3": 8.5,
        "sdMinus2": 9.5,
        "sdMinus1": 10.7,
        "median": 12.1,
        "sdPlus1": 13.7,
        "sdPlus2": 15.7,
        "sdPlus3": 18.0
    },
    {
        "month": 28,
        "sdMinus3": 8.6,
        "sdMinus2": 9.7,
        "sdMinus1": 10.9,
        "median": 12.3,
        "sdPlus1": 14.0,
        "sdPlus2": 16.0,
        "sdPlus3": 18.3
    },
    {
        "month": 29,
        "sdMinus3": 8.8,
        "sdMinus2": 9.8,
        "sdMinus1": 11.1,
        "median": 12.5,
        "sdPlus1": 14.2,
        "sdPlus2": 16.2,
        "sdPlus3": 18.7
    },
    {
        "month": 30,
        "sdMinus3": 8.9,
        "sdMinus2": 10.0,
        "sdMinus1": 11.2,
        "median": 12.7,
        "sdPlus1": 14.4,
        "sdPlus2": 16.5,
        "sdPlus3": 19.0
    },
    {
        "month": 31,
        "sdMinus3": 9.0,
        "sdMinus2": 10.1,
        "sdMinus1": 11.4,
        "median": 12.9,
        "sdPlus1": 14.7,
        "sdPlus2": 16.8,
        "sdPlus3": 19.3
    },
    {
        "month": 32,
        "sdMinus3": 9.1,
        "sdMinus2": 10.3,
        "sdMinus1": 11.6,
        "median": 13.1,
        "sdPlus1": 14.9,
        "sdPlus2": 17.1,
        "sdPlus3": 19.6
    },
    {
        "month": 33,
        "sdMinus3": 9.3,
        "sdMinus2": 10.4,
        "sdMinus1": 11.7,
        "median": 13.3,
        "sdPlus1": 15.1,
        "sdPlus2": 17.3,
        "sdPlus3": 20.0
    },
    {
        "month": 34,
        "sdMinus3": 9.4,
        "sdMinus2": 10.5,
        "sdMinus1": 11.9,
        "median": 13.5,
        "sdPlus1": 15.4,
        "sdPlus2": 17.6,
        "sdPlus3": 20.3
    },
    {
        "month": 35,
        "sdMinus3": 9.5,
        "sdMinus2": 10.7,
        "sdMinus1": 12.0,
        "median": 13.7,
        "sdPlus1": 15.6,
        "sdPlus2": 17.9,
        "sdPlus3": 20.6
    },
    {
        "month": 36,
        "sdMinus3": 9.6,
        "sdMinus2": 10.8,
        "sdMinus1": 12.2,
        "median": 13.9,
        "sdPlus1": 15.8,
        "sdPlus2": 18.1,
        "sdPlus3": 20.9
    },
    {
        "month": 37,
        "sdMinus3": 9.7,
        "sdMinus2": 10.9,
        "sdMinus1": 12.4,
        "median": 14.0,
        "sdPlus1": 16.0,
        "sdPlus2": 18.4,
        "sdPlus3": 21.3
    },
    {
        "month": 38,
        "sdMinus3": 9.8,
        "sdMinus2": 11.1,
        "sdMinus1": 12.5,
        "median": 14.2,
        "sdPlus1": 16.3,
        "sdPlus2": 18.7,
        "sdPlus3": 21.6
    },
    {
        "month": 39,
        "sdMinus3": 9.9,
        "sdMinus2": 11.2,
        "sdMinus1": 12.7,
        "median": 14.4,
        "sdPlus1": 16.5,
        "sdPlus2": 19.0,
        "sdPlus3": 22.0
    },
    {
        "month": 40,
        "sdMinus3": 10.1,
        "sdMinus2": 11.3,
        "sdMinus1": 12.8,
        "median": 14.6,
        "sdPlus1": 16.7,
        "sdPlus2": 19.2,
        "sdPlus3": 22.3
    },
    {
        "month": 41,
        "sdMinus3": 10.2,
        "sdMinus2": 11.5,
        "sdMinus1": 13.0,
        "median": 14.8,
        "sdPlus1": 16.9,
        "sdPlus2": 19.5,
        "sdPlus3": 22.7
    },
    {
        "month": 42,
        "sdMinus3": 10.3,
        "sdMinus2": 11.6,
        "sdMinus1": 13.1,
        "median": 15.0,
        "sdPlus1": 17.2,
        "sdPlus2": 19.8,
        "sdPlus3": 23.0
    },
    {
        "month": 43,
        "sdMinus3": 10.4,
        "sdMinus2": 11.7,
        "sdMinus1": 13.3,
        "median": 15.2,
        "sdPlus1": 17.4,
        "sdPlus2": 20.1,
        "sdPlus3": 23.4
    },
    {
        "month": 44,
        "sdMinus3": 10.5,
        "sdMinus2": 11.8,
        "sdMinus1": 13.4,
        "median": 15.3,
        "sdPlus1": 17.6,
        "sdPlus2": 20.4,
        "sdPlus3": 23.7
    },
    {
        "month": 45,
        "sdMinus3": 10.6,
        "sdMinus2": 12.0,
        "sdMinus1": 13.6,
        "median": 15.5,
        "sdPlus1": 17.8,
        "sdPlus2": 20.7,
        "sdPlus3": 24.1
    },
    {
        "month": 46,
        "sdMinus3": 10.7,
        "sdMinus2": 12.1,
        "sdMinus1": 13.7,
        "median": 15.7,
        "sdPlus1": 18.1,
        "sdPlus2": 20.9,
        "sdPlus3": 24.5
    },
    {
        "month": 47,
        "sdMinus3": 10.8,
        "sdMinus2": 12.2,
        "sdMinus1": 13.9,
        "median": 15.9,
        "sdPlus1": 18.3,
        "sdPlus2": 21.2,
        "sdPlus3": 24.8
    },
    {
        "month": 48,
        "sdMinus3": 10.9,
        "sdMinus2": 12.3,
        "sdMinus1": 14.0,
        "median": 16.1,
        "sdPlus1": 18.5,
        "sdPlus2": 21.5,
        "sdPlus3": 25.2
    },
    {
        "month": 49,
        "sdMinus3": 11.0,
        "sdMinus2": 12.4,
        "sdMinus1": 14.2,
        "median": 16.3,
        "sdPlus1": 18.8,
        "sdPlus2": 21.8,
        "sdPlus3": 25.5
    },
    {
        "month": 50,
        "sdMinus3": 11.1,
        "sdMinus2": 12.6,
        "sdMinus1": 14.3,
        "median": 16.4,
        "sdPlus1": 19.0,
        "sdPlus2": 22.1,
        "sdPlus3": 25.9
    },
    {
        "month": 51,
        "sdMinus3": 11.2,
        "sdMinus2": 12.7,
        "sdMinus1": 14.5,
        "median": 16.6,
        "sdPlus1": 19.2,
        "sdPlus2": 22.4,
        "sdPlus3": 26.3
    },
    {
        "month": 52,
        "sdMinus3": 11.3,
        "sdMinus2": 12.8,
        "sdMinus1": 14.6,
        "median": 16.8,
        "sdPlus1": 19.4,
        "sdPlus2": 22.6,
        "sdPlus3": 26.6
    },
    {
        "month": 53,
        "sdMinus3": 11.4,
        "sdMinus2": 12.9,
        "sdMinus1": 14.8,
        "median": 17.0,
        "sdPlus1": 19.7,
        "sdPlus2": 22.9,
        "sdPlus3": 27.0
    },
    {
        "month": 54,
        "sdMinus3": 11.5,
        "sdMinus2": 13.0,
        "sdMinus1": 14.9,
        "median": 17.2,
        "sdPlus1": 19.9,
        "sdPlus2": 23.2,
        "sdPlus3": 27.4
    },
    {
        "month": 55,
        "sdMinus3": 11.6,
        "sdMinus2": 13.2,
        "sdMinus1": 15.1,
        "median": 17.3,
        "sdPlus1": 20.1,
        "sdPlus2": 23.5,
        "sdPlus3": 27.7
    },
    {
        "month": 56,
        "sdMinus3": 11.7,
        "sdMinus2": 13.3,
        "sdMinus1": 15.2,
        "median": 17.5,
        "sdPlus1": 20.3,
        "sdPlus2": 23.8,
        "sdPlus3": 28.1
    },
    {
        "month": 57,
        "sdMinus3": 11.8,
        "sdMinus2": 13.4,
        "sdMinus1": 15.3,
        "median": 17.7,
        "sdPlus1": 20.6,
        "sdPlus2": 24.1,
        "sdPlus3": 28.5
    },
    {
        "month": 58,
        "sdMinus3": 11.9,
        "sdMinus2": 13.5,
        "sdMinus1": 15.5,
        "median": 17.9,
        "sdPlus1": 20.8,
        "sdPlus2": 24.4,
        "sdPlus3": 28.8
    },
    {
        "month": 59,
        "sdMinus3": 12.0,
        "sdMinus2": 13.6,
        "sdMinus1": 15.6,
        "median": 18.0,
        "sdPlus1": 21.0,
        "sdPlus2": 24.6,
        "sdPlus3": 29.2
    },
    {
        "month": 60,
        "sdMinus3": 12.1,
        "sdMinus2": 13.7,
        "sdMinus1": 15.8,
        "median": 18.2,
        "sdPlus1": 21.2,
        "sdPlus2": 24.9,
        "sdPlus3": 29.5
    }
];

export const WHO_WEIGHT_BOYS = [
    {
        "month": 0,
        "sdMinus3": 2.1,
        "sdMinus2": 2.5,
        "sdMinus1": 2.9,
        "median": 3.3,
        "sdPlus1": 3.9,
        "sdPlus2": 4.4,
        "sdPlus3": 5.0
    },
    {
        "month": 1,
        "sdMinus3": 2.9,
        "sdMinus2": 3.4,
        "sdMinus1": 3.9,
        "median": 4.5,
        "sdPlus1": 5.1,
        "sdPlus2": 5.8,
        "sdPlus3": 6.6
    },
    {
        "month": 2,
        "sdMinus3": 3.8,
        "sdMinus2": 4.3,
        "sdMinus1": 4.9,
        "median": 5.6,
        "sdPlus1": 6.3,
        "sdPlus2": 7.1,
        "sdPlus3": 8.0
    },
    {
        "month": 3,
        "sdMinus3": 4.4,
        "sdMinus2": 5.0,
        "sdMinus1": 5.7,
        "median": 6.4,
        "sdPlus1": 7.2,
        "sdPlus2": 8.0,
        "sdPlus3": 9.0
    },
    {
        "month": 4,
        "sdMinus3": 4.9,
        "sdMinus2": 5.6,
        "sdMinus1": 6.2,
        "median": 7.0,
        "sdPlus1": 7.8,
        "sdPlus2": 8.7,
        "sdPlus3": 9.7
    },
    {
        "month": 5,
        "sdMinus3": 5.3,
        "sdMinus2": 6.0,
        "sdMinus1": 6.7,
        "median": 7.5,
        "sdPlus1": 8.4,
        "sdPlus2": 9.3,
        "sdPlus3": 10.4
    },
    {
        "month": 6,
        "sdMinus3": 5.7,
        "sdMinus2": 6.4,
        "sdMinus1": 7.1,
        "median": 7.9,
        "sdPlus1": 8.8,
        "sdPlus2": 9.8,
        "sdPlus3": 10.9
    },
    {
        "month": 7,
        "sdMinus3": 5.9,
        "sdMinus2": 6.7,
        "sdMinus1": 7.4,
        "median": 8.3,
        "sdPlus1": 9.2,
        "sdPlus2": 10.3,
        "sdPlus3": 11.4
    },
    {
        "month": 8,
        "sdMinus3": 6.2,
        "sdMinus2": 6.9,
        "sdMinus1": 7.7,
        "median": 8.6,
        "sdPlus1": 9.6,
        "sdPlus2": 10.7,
        "sdPlus3": 11.9
    },
    {
        "month": 9,
        "sdMinus3": 6.4,
        "sdMinus2": 7.1,
        "sdMinus1": 8.0,
        "median": 8.9,
        "sdPlus1": 9.9,
        "sdPlus2": 11.0,
        "sdPlus3": 12.3
    },
    {
        "month": 10,
        "sdMinus3": 6.6,
        "sdMinus2": 7.4,
        "sdMinus1": 8.2,
        "median": 9.2,
        "sdPlus1": 10.2,
        "sdPlus2": 11.4,
        "sdPlus3": 12.7
    },
    {
        "month": 11,
        "sdMinus3": 6.8,
        "sdMinus2": 7.6,
        "sdMinus1": 8.4,
        "median": 9.4,
        "sdPlus1": 10.5,
        "sdPlus2": 11.7,
        "sdPlus3": 13.0
    },
    {
        "month": 12,
        "sdMinus3": 6.9,
        "sdMinus2": 7.7,
        "sdMinus1": 8.6,
        "median": 9.6,
        "sdPlus1": 10.8,
        "sdPlus2": 12.0,
        "sdPlus3": 13.3
    },
    {
        "month": 13,
        "sdMinus3": 7.1,
        "sdMinus2": 7.9,
        "sdMinus1": 8.8,
        "median": 9.9,
        "sdPlus1": 11.0,
        "sdPlus2": 12.3,
        "sdPlus3": 13.7
    },
    {
        "month": 14,
        "sdMinus3": 7.2,
        "sdMinus2": 8.1,
        "sdMinus1": 9.0,
        "median": 10.1,
        "sdPlus1": 11.3,
        "sdPlus2": 12.6,
        "sdPlus3": 14.0
    },
    {
        "month": 15,
        "sdMinus3": 7.4,
        "sdMinus2": 8.3,
        "sdMinus1": 9.2,
        "median": 10.3,
        "sdPlus1": 11.5,
        "sdPlus2": 12.8,
        "sdPlus3": 14.3
    },
    {
        "month": 16,
        "sdMinus3": 7.5,
        "sdMinus2": 8.4,
        "sdMinus1": 9.4,
        "median": 10.5,
        "sdPlus1": 11.7,
        "sdPlus2": 13.1,
        "sdPlus3": 14.6
    },
    {
        "month": 17,
        "sdMinus3": 7.7,
        "sdMinus2": 8.6,
        "sdMinus1": 9.6,
        "median": 10.7,
        "sdPlus1": 12.0,
        "sdPlus2": 13.4,
        "sdPlus3": 14.9
    },
    {
        "month": 18,
        "sdMinus3": 7.8,
        "sdMinus2": 8.8,
        "sdMinus1": 9.8,
        "median": 10.9,
        "sdPlus1": 12.2,
        "sdPlus2": 13.7,
        "sdPlus3": 15.3
    },
    {
        "month": 19,
        "sdMinus3": 8.0,
        "sdMinus2": 8.9,
        "sdMinus1": 10.0,
        "median": 11.1,
        "sdPlus1": 12.5,
        "sdPlus2": 13.9,
        "sdPlus3": 15.6
    },
    {
        "month": 20,
        "sdMinus3": 8.1,
        "sdMinus2": 9.1,
        "sdMinus1": 10.1,
        "median": 11.3,
        "sdPlus1": 12.7,
        "sdPlus2": 14.2,
        "sdPlus3": 15.9
    },
    {
        "month": 21,
        "sdMinus3": 8.2,
        "sdMinus2": 9.2,
        "sdMinus1": 10.3,
        "median": 11.5,
        "sdPlus1": 12.9,
        "sdPlus2": 14.5,
        "sdPlus3": 16.2
    },
    {
        "month": 22,
        "sdMinus3": 8.4,
        "sdMinus2": 9.4,
        "sdMinus1": 10.5,
        "median": 11.8,
        "sdPlus1": 13.2,
        "sdPlus2": 14.7,
        "sdPlus3": 16.5
    },
    {
        "month": 23,
        "sdMinus3": 8.5,
        "sdMinus2": 9.5,
        "sdMinus1": 10.7,
        "median": 12.0,
        "sdPlus1": 13.4,
        "sdPlus2": 15.0,
        "sdPlus3": 16.8
    },
    {
        "month": 24,
        "sdMinus3": 8.6,
        "sdMinus2": 9.7,
        "sdMinus1": 10.8,
        "median": 12.2,
        "sdPlus1": 13.6,
        "sdPlus2": 15.3,
        "sdPlus3": 17.1
    },
    {
        "month": 25,
        "sdMinus3": 8.8,
        "sdMinus2": 9.8,
        "sdMinus1": 11.0,
        "median": 12.4,
        "sdPlus1": 13.9,
        "sdPlus2": 15.5,
        "sdPlus3": 17.5
    },
    {
        "month": 26,
        "sdMinus3": 8.9,
        "sdMinus2": 10.0,
        "sdMinus1": 11.2,
        "median": 12.5,
        "sdPlus1": 14.1,
        "sdPlus2": 15.8,
        "sdPlus3": 17.8
    },
    {
        "month": 27,
        "sdMinus3": 9.0,
        "sdMinus2": 10.1,
        "sdMinus1": 11.3,
        "median": 12.7,
        "sdPlus1": 14.3,
        "sdPlus2": 16.1,
        "sdPlus3": 18.1
    },
    {
        "month": 28,
        "sdMinus3": 9.1,
        "sdMinus2": 10.2,
        "sdMinus1": 11.5,
        "median": 12.9,
        "sdPlus1": 14.5,
        "sdPlus2": 16.3,
        "sdPlus3": 18.4
    },
    {
        "month": 29,
        "sdMinus3": 9.2,
        "sdMinus2": 10.4,
        "sdMinus1": 11.7,
        "median": 13.1,
        "sdPlus1": 14.8,
        "sdPlus2": 16.6,
        "sdPlus3": 18.7
    },
    {
        "month": 30,
        "sdMinus3": 9.4,
        "sdMinus2": 10.5,
        "sdMinus1": 11.8,
        "median": 13.3,
        "sdPlus1": 15.0,
        "sdPlus2": 16.9,
        "sdPlus3": 19.0
    },
    {
        "month": 31,
        "sdMinus3": 9.5,
        "sdMinus2": 10.7,
        "sdMinus1": 12.0,
        "median": 13.5,
        "sdPlus1": 15.2,
        "sdPlus2": 17.1,
        "sdPlus3": 19.3
    },
    {
        "month": 32,
        "sdMinus3": 9.6,
        "sdMinus2": 10.8,
        "sdMinus1": 12.1,
        "median": 13.7,
        "sdPlus1": 15.4,
        "sdPlus2": 17.4,
        "sdPlus3": 19.6
    },
    {
        "month": 33,
        "sdMinus3": 9.7,
        "sdMinus2": 10.9,
        "sdMinus1": 12.3,
        "median": 13.8,
        "sdPlus1": 15.6,
        "sdPlus2": 17.6,
        "sdPlus3": 19.9
    },
    {
        "month": 34,
        "sdMinus3": 9.8,
        "sdMinus2": 11.0,
        "sdMinus1": 12.4,
        "median": 14.0,
        "sdPlus1": 15.8,
        "sdPlus2": 17.8,
        "sdPlus3": 20.2
    },
    {
        "month": 35,
        "sdMinus3": 9.9,
        "sdMinus2": 11.2,
        "sdMinus1": 12.6,
        "median": 14.2,
        "sdPlus1": 16.0,
        "sdPlus2": 18.1,
        "sdPlus3": 20.4
    },
    {
        "month": 36,
        "sdMinus3": 10.0,
        "sdMinus2": 11.3,
        "sdMinus1": 12.7,
        "median": 14.3,
        "sdPlus1": 16.2,
        "sdPlus2": 18.3,
        "sdPlus3": 20.7
    },
    {
        "month": 37,
        "sdMinus3": 10.1,
        "sdMinus2": 11.4,
        "sdMinus1": 12.9,
        "median": 14.5,
        "sdPlus1": 16.4,
        "sdPlus2": 18.6,
        "sdPlus3": 21.0
    },
    {
        "month": 38,
        "sdMinus3": 10.2,
        "sdMinus2": 11.5,
        "sdMinus1": 13.0,
        "median": 14.7,
        "sdPlus1": 16.6,
        "sdPlus2": 18.8,
        "sdPlus3": 21.3
    },
    {
        "month": 39,
        "sdMinus3": 10.3,
        "sdMinus2": 11.6,
        "sdMinus1": 13.1,
        "median": 14.8,
        "sdPlus1": 16.8,
        "sdPlus2": 19.0,
        "sdPlus3": 21.6
    },
    {
        "month": 40,
        "sdMinus3": 10.4,
        "sdMinus2": 11.8,
        "sdMinus1": 13.3,
        "median": 15.0,
        "sdPlus1": 17.0,
        "sdPlus2": 19.3,
        "sdPlus3": 21.9
    },
    {
        "month": 41,
        "sdMinus3": 10.5,
        "sdMinus2": 11.9,
        "sdMinus1": 13.4,
        "median": 15.2,
        "sdPlus1": 17.2,
        "sdPlus2": 19.5,
        "sdPlus3": 22.1
    },
    {
        "month": 42,
        "sdMinus3": 10.6,
        "sdMinus2": 12.0,
        "sdMinus1": 13.6,
        "median": 15.3,
        "sdPlus1": 17.4,
        "sdPlus2": 19.7,
        "sdPlus3": 22.4
    },
    {
        "month": 43,
        "sdMinus3": 10.7,
        "sdMinus2": 12.1,
        "sdMinus1": 13.7,
        "median": 15.5,
        "sdPlus1": 17.6,
        "sdPlus2": 20.0,
        "sdPlus3": 22.7
    },
    {
        "month": 44,
        "sdMinus3": 10.8,
        "sdMinus2": 12.2,
        "sdMinus1": 13.8,
        "median": 15.7,
        "sdPlus1": 17.8,
        "sdPlus2": 20.2,
        "sdPlus3": 23.0
    },
    {
        "month": 45,
        "sdMinus3": 10.9,
        "sdMinus2": 12.4,
        "sdMinus1": 14.0,
        "median": 15.8,
        "sdPlus1": 18.0,
        "sdPlus2": 20.5,
        "sdPlus3": 23.3
    },
    {
        "month": 46,
        "sdMinus3": 11.0,
        "sdMinus2": 12.5,
        "sdMinus1": 14.1,
        "median": 16.0,
        "sdPlus1": 18.2,
        "sdPlus2": 20.7,
        "sdPlus3": 23.6
    },
    {
        "month": 47,
        "sdMinus3": 11.1,
        "sdMinus2": 12.6,
        "sdMinus1": 14.3,
        "median": 16.2,
        "sdPlus1": 18.4,
        "sdPlus2": 20.9,
        "sdPlus3": 23.9
    },
    {
        "month": 48,
        "sdMinus3": 11.2,
        "sdMinus2": 12.7,
        "sdMinus1": 14.4,
        "median": 16.3,
        "sdPlus1": 18.6,
        "sdPlus2": 21.2,
        "sdPlus3": 24.2
    },
    {
        "month": 49,
        "sdMinus3": 11.3,
        "sdMinus2": 12.8,
        "sdMinus1": 14.5,
        "median": 16.5,
        "sdPlus1": 18.8,
        "sdPlus2": 21.4,
        "sdPlus3": 24.5
    },
    {
        "month": 50,
        "sdMinus3": 11.4,
        "sdMinus2": 12.9,
        "sdMinus1": 14.7,
        "median": 16.7,
        "sdPlus1": 19.0,
        "sdPlus2": 21.7,
        "sdPlus3": 24.8
    },
    {
        "month": 51,
        "sdMinus3": 11.5,
        "sdMinus2": 13.1,
        "sdMinus1": 14.8,
        "median": 16.8,
        "sdPlus1": 19.2,
        "sdPlus2": 21.9,
        "sdPlus3": 25.1
    },
    {
        "month": 52,
        "sdMinus3": 11.6,
        "sdMinus2": 13.2,
        "sdMinus1": 15.0,
        "median": 17.0,
        "sdPlus1": 19.4,
        "sdPlus2": 22.2,
        "sdPlus3": 25.4
    },
    {
        "month": 53,
        "sdMinus3": 11.7,
        "sdMinus2": 13.3,
        "sdMinus1": 15.1,
        "median": 17.2,
        "sdPlus1": 19.6,
        "sdPlus2": 22.4,
        "sdPlus3": 25.7
    },
    {
        "month": 54,
        "sdMinus3": 11.8,
        "sdMinus2": 13.4,
        "sdMinus1": 15.2,
        "median": 17.3,
        "sdPlus1": 19.8,
        "sdPlus2": 22.7,
        "sdPlus3": 26.0
    },
    {
        "month": 55,
        "sdMinus3": 11.9,
        "sdMinus2": 13.5,
        "sdMinus1": 15.4,
        "median": 17.5,
        "sdPlus1": 20.0,
        "sdPlus2": 22.9,
        "sdPlus3": 26.3
    },
    {
        "month": 56,
        "sdMinus3": 12.0,
        "sdMinus2": 13.6,
        "sdMinus1": 15.5,
        "median": 17.7,
        "sdPlus1": 20.2,
        "sdPlus2": 23.2,
        "sdPlus3": 26.6
    },
    {
        "month": 57,
        "sdMinus3": 12.1,
        "sdMinus2": 13.7,
        "sdMinus1": 15.6,
        "median": 17.8,
        "sdPlus1": 20.4,
        "sdPlus2": 23.4,
        "sdPlus3": 26.9
    },
    {
        "month": 58,
        "sdMinus3": 12.2,
        "sdMinus2": 13.8,
        "sdMinus1": 15.8,
        "median": 18.0,
        "sdPlus1": 20.6,
        "sdPlus2": 23.7,
        "sdPlus3": 27.2
    },
    {
        "month": 59,
        "sdMinus3": 12.3,
        "sdMinus2": 14.0,
        "sdMinus1": 15.9,
        "median": 18.2,
        "sdPlus1": 20.8,
        "sdPlus2": 23.9,
        "sdPlus3": 27.6
    },
    {
        "month": 60,
        "sdMinus3": 12.4,
        "sdMinus2": 14.1,
        "sdMinus1": 16.0,
        "median": 18.3,
        "sdPlus1": 21.0,
        "sdPlus2": 24.2,
        "sdPlus3": 27.9
    }
];

export const WHO_LENGTH_GIRLS_0_24 = [
    {
        "month": 0,
        "sdMinus3": 43.6,
        "sdMinus2": 45.4,
        "sdMinus1": 47.3,
        "median": 49.1,
        "sdPlus1": 51.0,
        "sdPlus2": 52.9,
        "sdPlus3": 54.7
    },
    {
        "month": 1,
        "sdMinus3": 47.8,
        "sdMinus2": 49.8,
        "sdMinus1": 51.7,
        "median": 53.7,
        "sdPlus1": 55.6,
        "sdPlus2": 57.6,
        "sdPlus3": 59.5
    },
    {
        "month": 2,
        "sdMinus3": 51.0,
        "sdMinus2": 53.0,
        "sdMinus1": 55.0,
        "median": 57.1,
        "sdPlus1": 59.1,
        "sdPlus2": 61.1,
        "sdPlus3": 63.2
    },
    {
        "month": 3,
        "sdMinus3": 53.5,
        "sdMinus2": 55.6,
        "sdMinus1": 57.7,
        "median": 59.8,
        "sdPlus1": 61.9,
        "sdPlus2": 64.0,
        "sdPlus3": 66.1
    },
    {
        "month": 4,
        "sdMinus3": 55.6,
        "sdMinus2": 57.8,
        "sdMinus1": 59.9,
        "median": 62.1,
        "sdPlus1": 64.3,
        "sdPlus2": 66.4,
        "sdPlus3": 68.6
    },
    {
        "month": 5,
        "sdMinus3": 57.4,
        "sdMinus2": 59.6,
        "sdMinus1": 61.8,
        "median": 64.0,
        "sdPlus1": 66.2,
        "sdPlus2": 68.5,
        "sdPlus3": 70.7
    },
    {
        "month": 6,
        "sdMinus3": 58.9,
        "sdMinus2": 61.2,
        "sdMinus1": 63.5,
        "median": 65.7,
        "sdPlus1": 68.0,
        "sdPlus2": 70.3,
        "sdPlus3": 72.5
    },
    {
        "month": 7,
        "sdMinus3": 60.3,
        "sdMinus2": 62.7,
        "sdMinus1": 65.0,
        "median": 67.3,
        "sdPlus1": 69.6,
        "sdPlus2": 71.9,
        "sdPlus3": 74.2
    },
    {
        "month": 8,
        "sdMinus3": 61.7,
        "sdMinus2": 64.0,
        "sdMinus1": 66.4,
        "median": 68.7,
        "sdPlus1": 71.1,
        "sdPlus2": 73.5,
        "sdPlus3": 75.8
    },
    {
        "month": 9,
        "sdMinus3": 62.9,
        "sdMinus2": 65.3,
        "sdMinus1": 67.7,
        "median": 70.1,
        "sdPlus1": 72.6,
        "sdPlus2": 75.0,
        "sdPlus3": 77.4
    },
    {
        "month": 10,
        "sdMinus3": 64.1,
        "sdMinus2": 66.5,
        "sdMinus1": 69.0,
        "median": 71.5,
        "sdPlus1": 73.9,
        "sdPlus2": 76.4,
        "sdPlus3": 78.9
    },
    {
        "month": 11,
        "sdMinus3": 65.2,
        "sdMinus2": 67.7,
        "sdMinus1": 70.3,
        "median": 72.8,
        "sdPlus1": 75.3,
        "sdPlus2": 77.8,
        "sdPlus3": 80.3
    },
    {
        "month": 12,
        "sdMinus3": 66.3,
        "sdMinus2": 68.9,
        "sdMinus1": 71.4,
        "median": 74.0,
        "sdPlus1": 76.6,
        "sdPlus2": 79.2,
        "sdPlus3": 81.7
    },
    {
        "month": 13,
        "sdMinus3": 67.3,
        "sdMinus2": 70.0,
        "sdMinus1": 72.6,
        "median": 75.2,
        "sdPlus1": 77.8,
        "sdPlus2": 80.5,
        "sdPlus3": 83.1
    },
    {
        "month": 14,
        "sdMinus3": 68.3,
        "sdMinus2": 71.0,
        "sdMinus1": 73.7,
        "median": 76.4,
        "sdPlus1": 79.1,
        "sdPlus2": 81.7,
        "sdPlus3": 84.4
    },
    {
        "month": 15,
        "sdMinus3": 69.3,
        "sdMinus2": 72.0,
        "sdMinus1": 74.8,
        "median": 77.5,
        "sdPlus1": 80.2,
        "sdPlus2": 83.0,
        "sdPlus3": 85.7
    },
    {
        "month": 16,
        "sdMinus3": 70.2,
        "sdMinus2": 73.0,
        "sdMinus1": 75.8,
        "median": 78.6,
        "sdPlus1": 81.4,
        "sdPlus2": 84.2,
        "sdPlus3": 87.0
    },
    {
        "month": 17,
        "sdMinus3": 71.1,
        "sdMinus2": 74.0,
        "sdMinus1": 76.8,
        "median": 79.7,
        "sdPlus1": 82.5,
        "sdPlus2": 85.4,
        "sdPlus3": 88.2
    },
    {
        "month": 18,
        "sdMinus3": 72.0,
        "sdMinus2": 74.9,
        "sdMinus1": 77.8,
        "median": 80.7,
        "sdPlus1": 83.6,
        "sdPlus2": 86.5,
        "sdPlus3": 89.4
    },
    {
        "month": 19,
        "sdMinus3": 72.8,
        "sdMinus2": 75.8,
        "sdMinus1": 78.8,
        "median": 81.7,
        "sdPlus1": 84.7,
        "sdPlus2": 87.6,
        "sdPlus3": 90.6
    },
    {
        "month": 20,
        "sdMinus3": 73.7,
        "sdMinus2": 76.7,
        "sdMinus1": 79.7,
        "median": 82.7,
        "sdPlus1": 85.7,
        "sdPlus2": 88.7,
        "sdPlus3": 91.7
    },
    {
        "month": 21,
        "sdMinus3": 74.5,
        "sdMinus2": 77.5,
        "sdMinus1": 80.6,
        "median": 83.7,
        "sdPlus1": 86.7,
        "sdPlus2": 89.8,
        "sdPlus3": 92.9
    },
    {
        "month": 22,
        "sdMinus3": 75.2,
        "sdMinus2": 78.4,
        "sdMinus1": 81.5,
        "median": 84.6,
        "sdPlus1": 87.7,
        "sdPlus2": 90.8,
        "sdPlus3": 94.0
    },
    {
        "month": 23,
        "sdMinus3": 76.0,
        "sdMinus2": 79.2,
        "sdMinus1": 82.3,
        "median": 85.5,
        "sdPlus1": 88.7,
        "sdPlus2": 91.9,
        "sdPlus3": 95.0
    },
    {
        "month": 24,
        "sdMinus3": 76.7,
        "sdMinus2": 80.0,
        "sdMinus1": 83.2,
        "median": 86.4,
        "sdPlus1": 89.6,
        "sdPlus2": 92.9,
        "sdPlus3": 96.1
    },
    {
        "month": 24,
        "sdMinus3": 76.0,
        "sdMinus2": 79.3,
        "sdMinus1": 82.5,
        "median": 85.7,
        "sdPlus1": 88.9,
        "sdPlus2": 92.2,
        "sdPlus3": 95.4
    }
];

export const WHO_LENGTH_BOYS_0_24 = [
    {
        "month": 0,
        "sdMinus3": 44.2,
        "sdMinus2": 46.1,
        "sdMinus1": 48.0,
        "median": 49.9,
        "sdPlus1": 51.8,
        "sdPlus2": 53.7,
        "sdPlus3": 55.6
    },
    {
        "month": 1,
        "sdMinus3": 48.9,
        "sdMinus2": 50.8,
        "sdMinus1": 52.8,
        "median": 54.7,
        "sdPlus1": 56.7,
        "sdPlus2": 58.6,
        "sdPlus3": 60.6
    },
    {
        "month": 2,
        "sdMinus3": 52.4,
        "sdMinus2": 54.4,
        "sdMinus1": 56.4,
        "median": 58.4,
        "sdPlus1": 60.4,
        "sdPlus2": 62.4,
        "sdPlus3": 64.4
    },
    {
        "month": 3,
        "sdMinus3": 55.3,
        "sdMinus2": 57.3,
        "sdMinus1": 59.4,
        "median": 61.4,
        "sdPlus1": 63.5,
        "sdPlus2": 65.5,
        "sdPlus3": 67.6
    },
    {
        "month": 4,
        "sdMinus3": 57.6,
        "sdMinus2": 59.7,
        "sdMinus1": 61.8,
        "median": 63.9,
        "sdPlus1": 66.0,
        "sdPlus2": 68.0,
        "sdPlus3": 70.1
    },
    {
        "month": 5,
        "sdMinus3": 59.6,
        "sdMinus2": 61.7,
        "sdMinus1": 63.8,
        "median": 65.9,
        "sdPlus1": 68.0,
        "sdPlus2": 70.1,
        "sdPlus3": 72.2
    },
    {
        "month": 6,
        "sdMinus3": 61.2,
        "sdMinus2": 63.3,
        "sdMinus1": 65.5,
        "median": 67.6,
        "sdPlus1": 69.8,
        "sdPlus2": 71.9,
        "sdPlus3": 74.0
    },
    {
        "month": 7,
        "sdMinus3": 62.7,
        "sdMinus2": 64.8,
        "sdMinus1": 67.0,
        "median": 69.2,
        "sdPlus1": 71.3,
        "sdPlus2": 73.5,
        "sdPlus3": 75.7
    },
    {
        "month": 8,
        "sdMinus3": 64.0,
        "sdMinus2": 66.2,
        "sdMinus1": 68.4,
        "median": 70.6,
        "sdPlus1": 72.8,
        "sdPlus2": 75.0,
        "sdPlus3": 77.2
    },
    {
        "month": 9,
        "sdMinus3": 65.2,
        "sdMinus2": 67.5,
        "sdMinus1": 69.7,
        "median": 72.0,
        "sdPlus1": 74.2,
        "sdPlus2": 76.5,
        "sdPlus3": 78.7
    },
    {
        "month": 10,
        "sdMinus3": 66.4,
        "sdMinus2": 68.7,
        "sdMinus1": 71.0,
        "median": 73.3,
        "sdPlus1": 75.6,
        "sdPlus2": 77.9,
        "sdPlus3": 80.1
    },
    {
        "month": 11,
        "sdMinus3": 67.6,
        "sdMinus2": 69.9,
        "sdMinus1": 72.2,
        "median": 74.5,
        "sdPlus1": 76.9,
        "sdPlus2": 79.2,
        "sdPlus3": 81.5
    },
    {
        "month": 12,
        "sdMinus3": 68.6,
        "sdMinus2": 71.0,
        "sdMinus1": 73.4,
        "median": 75.7,
        "sdPlus1": 78.1,
        "sdPlus2": 80.5,
        "sdPlus3": 82.9
    },
    {
        "month": 13,
        "sdMinus3": 69.6,
        "sdMinus2": 72.1,
        "sdMinus1": 74.5,
        "median": 76.9,
        "sdPlus1": 79.3,
        "sdPlus2": 81.8,
        "sdPlus3": 84.2
    },
    {
        "month": 14,
        "sdMinus3": 70.6,
        "sdMinus2": 73.1,
        "sdMinus1": 75.6,
        "median": 78.0,
        "sdPlus1": 80.5,
        "sdPlus2": 83.0,
        "sdPlus3": 85.5
    },
    {
        "month": 15,
        "sdMinus3": 71.6,
        "sdMinus2": 74.1,
        "sdMinus1": 76.6,
        "median": 79.1,
        "sdPlus1": 81.7,
        "sdPlus2": 84.2,
        "sdPlus3": 86.7
    },
    {
        "month": 16,
        "sdMinus3": 72.5,
        "sdMinus2": 75.0,
        "sdMinus1": 77.6,
        "median": 80.2,
        "sdPlus1": 82.8,
        "sdPlus2": 85.4,
        "sdPlus3": 88.0
    },
    {
        "month": 17,
        "sdMinus3": 73.3,
        "sdMinus2": 76.0,
        "sdMinus1": 78.6,
        "median": 81.2,
        "sdPlus1": 83.9,
        "sdPlus2": 86.5,
        "sdPlus3": 89.2
    },
    {
        "month": 18,
        "sdMinus3": 74.2,
        "sdMinus2": 76.9,
        "sdMinus1": 79.6,
        "median": 82.3,
        "sdPlus1": 85.0,
        "sdPlus2": 87.7,
        "sdPlus3": 90.4
    },
    {
        "month": 19,
        "sdMinus3": 75.0,
        "sdMinus2": 77.7,
        "sdMinus1": 80.5,
        "median": 83.2,
        "sdPlus1": 86.0,
        "sdPlus2": 88.8,
        "sdPlus3": 91.5
    },
    {
        "month": 20,
        "sdMinus3": 75.8,
        "sdMinus2": 78.6,
        "sdMinus1": 81.4,
        "median": 84.2,
        "sdPlus1": 87.0,
        "sdPlus2": 89.8,
        "sdPlus3": 92.6
    },
    {
        "month": 21,
        "sdMinus3": 76.5,
        "sdMinus2": 79.4,
        "sdMinus1": 82.3,
        "median": 85.1,
        "sdPlus1": 88.0,
        "sdPlus2": 90.9,
        "sdPlus3": 93.8
    },
    {
        "month": 22,
        "sdMinus3": 77.2,
        "sdMinus2": 80.2,
        "sdMinus1": 83.1,
        "median": 86.0,
        "sdPlus1": 89.0,
        "sdPlus2": 91.9,
        "sdPlus3": 94.9
    },
    {
        "month": 23,
        "sdMinus3": 78.0,
        "sdMinus2": 81.0,
        "sdMinus1": 83.9,
        "median": 86.9,
        "sdPlus1": 89.9,
        "sdPlus2": 92.9,
        "sdPlus3": 95.9
    },
    {
        "month": 24,
        "sdMinus3": 78.7,
        "sdMinus2": 81.7,
        "sdMinus1": 84.8,
        "median": 87.8,
        "sdPlus1": 90.9,
        "sdPlus2": 93.9,
        "sdPlus3": 97.0
    },
    {
        "month": 24,
        "sdMinus3": 78.0,
        "sdMinus2": 81.0,
        "sdMinus1": 84.1,
        "median": 87.1,
        "sdPlus1": 90.2,
        "sdPlus2": 93.2,
        "sdPlus3": 96.3
    }
];

export const WHO_WEIGHT_LENGTH_GIRLS = [
    {
        "length": 45.0,
        "sdMinus3": 1.9,
        "sdMinus2": 2.1,
        "sdMinus1": 2.3,
        "median": 2.5,
        "sdPlus1": 2.7,
        "sdPlus2": 3.0,
        "sdPlus3": 3.3
    },
    {
        "length": 45.5,
        "sdMinus3": 2.0,
        "sdMinus2": 2.1,
        "sdMinus1": 2.3,
        "median": 2.5,
        "sdPlus1": 2.8,
        "sdPlus2": 3.1,
        "sdPlus3": 3.4
    },
    {
        "length": 46.0,
        "sdMinus3": 2.0,
        "sdMinus2": 2.2,
        "sdMinus1": 2.4,
        "median": 2.6,
        "sdPlus1": 2.9,
        "sdPlus2": 3.2,
        "sdPlus3": 3.5
    },
    {
        "length": 46.5,
        "sdMinus3": 2.1,
        "sdMinus2": 2.3,
        "sdMinus1": 2.5,
        "median": 2.7,
        "sdPlus1": 3.0,
        "sdPlus2": 3.3,
        "sdPlus3": 3.6
    },
    {
        "length": 47.0,
        "sdMinus3": 2.2,
        "sdMinus2": 2.4,
        "sdMinus1": 2.6,
        "median": 2.8,
        "sdPlus1": 3.1,
        "sdPlus2": 3.4,
        "sdPlus3": 3.7
    },
    {
        "length": 47.5,
        "sdMinus3": 2.2,
        "sdMinus2": 2.4,
        "sdMinus1": 2.6,
        "median": 2.9,
        "sdPlus1": 3.2,
        "sdPlus2": 3.5,
        "sdPlus3": 3.8
    },
    {
        "length": 48.0,
        "sdMinus3": 2.3,
        "sdMinus2": 2.5,
        "sdMinus1": 2.7,
        "median": 3.0,
        "sdPlus1": 3.3,
        "sdPlus2": 3.6,
        "sdPlus3": 4.0
    },
    {
        "length": 48.5,
        "sdMinus3": 2.4,
        "sdMinus2": 2.6,
        "sdMinus1": 2.8,
        "median": 3.1,
        "sdPlus1": 3.4,
        "sdPlus2": 3.7,
        "sdPlus3": 4.1
    },
    {
        "length": 49.0,
        "sdMinus3": 2.4,
        "sdMinus2": 2.6,
        "sdMinus1": 2.9,
        "median": 3.2,
        "sdPlus1": 3.5,
        "sdPlus2": 3.8,
        "sdPlus3": 4.2
    },
    {
        "length": 49.5,
        "sdMinus3": 2.5,
        "sdMinus2": 2.7,
        "sdMinus1": 3.0,
        "median": 3.3,
        "sdPlus1": 3.6,
        "sdPlus2": 3.9,
        "sdPlus3": 4.3
    },
    {
        "length": 50.0,
        "sdMinus3": 2.6,
        "sdMinus2": 2.8,
        "sdMinus1": 3.1,
        "median": 3.4,
        "sdPlus1": 3.7,
        "sdPlus2": 4.0,
        "sdPlus3": 4.5
    },
    {
        "length": 50.5,
        "sdMinus3": 2.7,
        "sdMinus2": 2.9,
        "sdMinus1": 3.2,
        "median": 3.5,
        "sdPlus1": 3.8,
        "sdPlus2": 4.2,
        "sdPlus3": 4.6
    },
    {
        "length": 51.0,
        "sdMinus3": 2.8,
        "sdMinus2": 3.0,
        "sdMinus1": 3.3,
        "median": 3.6,
        "sdPlus1": 3.9,
        "sdPlus2": 4.3,
        "sdPlus3": 4.8
    },
    {
        "length": 51.5,
        "sdMinus3": 2.8,
        "sdMinus2": 3.1,
        "sdMinus1": 3.4,
        "median": 3.7,
        "sdPlus1": 4.0,
        "sdPlus2": 4.4,
        "sdPlus3": 4.9
    },
    {
        "length": 52.0,
        "sdMinus3": 2.9,
        "sdMinus2": 3.2,
        "sdMinus1": 3.5,
        "median": 3.8,
        "sdPlus1": 4.2,
        "sdPlus2": 4.6,
        "sdPlus3": 5.1
    },
    {
        "length": 52.5,
        "sdMinus3": 3.0,
        "sdMinus2": 3.3,
        "sdMinus1": 3.6,
        "median": 3.9,
        "sdPlus1": 4.3,
        "sdPlus2": 4.7,
        "sdPlus3": 5.2
    },
    {
        "length": 53.0,
        "sdMinus3": 3.1,
        "sdMinus2": 3.4,
        "sdMinus1": 3.7,
        "median": 4.0,
        "sdPlus1": 4.4,
        "sdPlus2": 4.9,
        "sdPlus3": 5.4
    },
    {
        "length": 53.5,
        "sdMinus3": 3.2,
        "sdMinus2": 3.5,
        "sdMinus1": 3.8,
        "median": 4.2,
        "sdPlus1": 4.6,
        "sdPlus2": 5.0,
        "sdPlus3": 5.5
    },
    {
        "length": 54.0,
        "sdMinus3": 3.3,
        "sdMinus2": 3.6,
        "sdMinus1": 3.9,
        "median": 4.3,
        "sdPlus1": 4.7,
        "sdPlus2": 5.2,
        "sdPlus3": 5.7
    },
    {
        "length": 54.5,
        "sdMinus3": 3.4,
        "sdMinus2": 3.7,
        "sdMinus1": 4.0,
        "median": 4.4,
        "sdPlus1": 4.8,
        "sdPlus2": 5.3,
        "sdPlus3": 5.9
    },
    {
        "length": 55.0,
        "sdMinus3": 3.5,
        "sdMinus2": 3.8,
        "sdMinus1": 4.2,
        "median": 4.5,
        "sdPlus1": 5.0,
        "sdPlus2": 5.5,
        "sdPlus3": 6.1
    },
    {
        "length": 55.5,
        "sdMinus3": 3.6,
        "sdMinus2": 3.9,
        "sdMinus1": 4.3,
        "median": 4.7,
        "sdPlus1": 5.1,
        "sdPlus2": 5.7,
        "sdPlus3": 6.3
    },
    {
        "length": 56.0,
        "sdMinus3": 3.7,
        "sdMinus2": 4.0,
        "sdMinus1": 4.4,
        "median": 4.8,
        "sdPlus1": 5.3,
        "sdPlus2": 5.8,
        "sdPlus3": 6.4
    },
    {
        "length": 56.5,
        "sdMinus3": 3.8,
        "sdMinus2": 4.1,
        "sdMinus1": 4.5,
        "median": 5.0,
        "sdPlus1": 5.4,
        "sdPlus2": 6.0,
        "sdPlus3": 6.6
    },
    {
        "length": 57.0,
        "sdMinus3": 3.9,
        "sdMinus2": 4.3,
        "sdMinus1": 4.6,
        "median": 5.1,
        "sdPlus1": 5.6,
        "sdPlus2": 6.1,
        "sdPlus3": 6.8
    },
    {
        "length": 57.5,
        "sdMinus3": 4.0,
        "sdMinus2": 4.4,
        "sdMinus1": 4.8,
        "median": 5.2,
        "sdPlus1": 5.7,
        "sdPlus2": 6.3,
        "sdPlus3": 7.0
    },
    {
        "length": 58.0,
        "sdMinus3": 4.1,
        "sdMinus2": 4.5,
        "sdMinus1": 4.9,
        "median": 5.4,
        "sdPlus1": 5.9,
        "sdPlus2": 6.5,
        "sdPlus3": 7.1
    },
    {
        "length": 58.5,
        "sdMinus3": 4.2,
        "sdMinus2": 4.6,
        "sdMinus1": 5.0,
        "median": 5.5,
        "sdPlus1": 6.0,
        "sdPlus2": 6.6,
        "sdPlus3": 7.3
    },
    {
        "length": 59.0,
        "sdMinus3": 4.3,
        "sdMinus2": 4.7,
        "sdMinus1": 5.1,
        "median": 5.6,
        "sdPlus1": 6.2,
        "sdPlus2": 6.8,
        "sdPlus3": 7.5
    },
    {
        "length": 59.5,
        "sdMinus3": 4.4,
        "sdMinus2": 4.8,
        "sdMinus1": 5.3,
        "median": 5.7,
        "sdPlus1": 6.3,
        "sdPlus2": 6.9,
        "sdPlus3": 7.7
    },
    {
        "length": 60.0,
        "sdMinus3": 4.5,
        "sdMinus2": 4.9,
        "sdMinus1": 5.4,
        "median": 5.9,
        "sdPlus1": 6.4,
        "sdPlus2": 7.1,
        "sdPlus3": 7.8
    },
    {
        "length": 60.5,
        "sdMinus3": 4.6,
        "sdMinus2": 5.0,
        "sdMinus1": 5.5,
        "median": 6.0,
        "sdPlus1": 6.6,
        "sdPlus2": 7.3,
        "sdPlus3": 8.0
    },
    {
        "length": 61.0,
        "sdMinus3": 4.7,
        "sdMinus2": 5.1,
        "sdMinus1": 5.6,
        "median": 6.1,
        "sdPlus1": 6.7,
        "sdPlus2": 7.4,
        "sdPlus3": 8.2
    },
    {
        "length": 61.5,
        "sdMinus3": 4.8,
        "sdMinus2": 5.2,
        "sdMinus1": 5.7,
        "median": 6.3,
        "sdPlus1": 6.9,
        "sdPlus2": 7.6,
        "sdPlus3": 8.4
    },
    {
        "length": 62.0,
        "sdMinus3": 4.9,
        "sdMinus2": 5.3,
        "sdMinus1": 5.8,
        "median": 6.4,
        "sdPlus1": 7.0,
        "sdPlus2": 7.7,
        "sdPlus3": 8.5
    },
    {
        "length": 62.5,
        "sdMinus3": 5.0,
        "sdMinus2": 5.4,
        "sdMinus1": 5.9,
        "median": 6.5,
        "sdPlus1": 7.1,
        "sdPlus2": 7.8,
        "sdPlus3": 8.7
    },
    {
        "length": 63.0,
        "sdMinus3": 5.1,
        "sdMinus2": 5.5,
        "sdMinus1": 6.0,
        "median": 6.6,
        "sdPlus1": 7.3,
        "sdPlus2": 8.0,
        "sdPlus3": 8.8
    },
    {
        "length": 63.5,
        "sdMinus3": 5.2,
        "sdMinus2": 5.6,
        "sdMinus1": 6.2,
        "median": 6.7,
        "sdPlus1": 7.4,
        "sdPlus2": 8.1,
        "sdPlus3": 9.0
    },
    {
        "length": 64.0,
        "sdMinus3": 5.3,
        "sdMinus2": 5.7,
        "sdMinus1": 6.3,
        "median": 6.9,
        "sdPlus1": 7.5,
        "sdPlus2": 8.3,
        "sdPlus3": 9.1
    },
    {
        "length": 64.5,
        "sdMinus3": 5.4,
        "sdMinus2": 5.8,
        "sdMinus1": 6.4,
        "median": 7.0,
        "sdPlus1": 7.6,
        "sdPlus2": 8.4,
        "sdPlus3": 9.3
    },
    {
        "length": 65.0,
        "sdMinus3": 5.5,
        "sdMinus2": 5.9,
        "sdMinus1": 6.5,
        "median": 7.1,
        "sdPlus1": 7.8,
        "sdPlus2": 8.6,
        "sdPlus3": 9.5
    },
    {
        "length": 65.5,
        "sdMinus3": 5.5,
        "sdMinus2": 6.0,
        "sdMinus1": 6.6,
        "median": 7.2,
        "sdPlus1": 7.9,
        "sdPlus2": 8.7,
        "sdPlus3": 9.6
    },
    {
        "length": 66.0,
        "sdMinus3": 5.6,
        "sdMinus2": 6.1,
        "sdMinus1": 6.7,
        "median": 7.3,
        "sdPlus1": 8.0,
        "sdPlus2": 8.8,
        "sdPlus3": 9.8
    },
    {
        "length": 66.5,
        "sdMinus3": 5.7,
        "sdMinus2": 6.2,
        "sdMinus1": 6.8,
        "median": 7.4,
        "sdPlus1": 8.1,
        "sdPlus2": 9.0,
        "sdPlus3": 9.9
    },
    {
        "length": 67.0,
        "sdMinus3": 5.8,
        "sdMinus2": 6.3,
        "sdMinus1": 6.9,
        "median": 7.5,
        "sdPlus1": 8.3,
        "sdPlus2": 9.1,
        "sdPlus3": 10.0
    },
    {
        "length": 67.5,
        "sdMinus3": 5.9,
        "sdMinus2": 6.4,
        "sdMinus1": 7.0,
        "median": 7.6,
        "sdPlus1": 8.4,
        "sdPlus2": 9.2,
        "sdPlus3": 10.2
    },
    {
        "length": 68.0,
        "sdMinus3": 6.0,
        "sdMinus2": 6.5,
        "sdMinus1": 7.1,
        "median": 7.7,
        "sdPlus1": 8.5,
        "sdPlus2": 9.4,
        "sdPlus3": 10.3
    },
    {
        "length": 68.5,
        "sdMinus3": 6.1,
        "sdMinus2": 6.6,
        "sdMinus1": 7.2,
        "median": 7.9,
        "sdPlus1": 8.6,
        "sdPlus2": 9.5,
        "sdPlus3": 10.5
    },
    {
        "length": 69.0,
        "sdMinus3": 6.1,
        "sdMinus2": 6.7,
        "sdMinus1": 7.3,
        "median": 8.0,
        "sdPlus1": 8.7,
        "sdPlus2": 9.6,
        "sdPlus3": 10.6
    },
    {
        "length": 69.5,
        "sdMinus3": 6.2,
        "sdMinus2": 6.8,
        "sdMinus1": 7.4,
        "median": 8.1,
        "sdPlus1": 8.8,
        "sdPlus2": 9.7,
        "sdPlus3": 10.7
    },
    {
        "length": 70.0,
        "sdMinus3": 6.3,
        "sdMinus2": 6.9,
        "sdMinus1": 7.5,
        "median": 8.2,
        "sdPlus1": 9.0,
        "sdPlus2": 9.9,
        "sdPlus3": 10.9
    },
    {
        "length": 70.5,
        "sdMinus3": 6.4,
        "sdMinus2": 6.9,
        "sdMinus1": 7.6,
        "median": 8.3,
        "sdPlus1": 9.1,
        "sdPlus2": 10.0,
        "sdPlus3": 11.0
    },
    {
        "length": 71.0,
        "sdMinus3": 6.5,
        "sdMinus2": 7.0,
        "sdMinus1": 7.7,
        "median": 8.4,
        "sdPlus1": 9.2,
        "sdPlus2": 10.1,
        "sdPlus3": 11.1
    },
    {
        "length": 71.5,
        "sdMinus3": 6.5,
        "sdMinus2": 7.1,
        "sdMinus1": 7.7,
        "median": 8.5,
        "sdPlus1": 9.3,
        "sdPlus2": 10.2,
        "sdPlus3": 11.3
    },
    {
        "length": 72.0,
        "sdMinus3": 6.6,
        "sdMinus2": 7.2,
        "sdMinus1": 7.8,
        "median": 8.6,
        "sdPlus1": 9.4,
        "sdPlus2": 10.3,
        "sdPlus3": 11.4
    },
    {
        "length": 72.5,
        "sdMinus3": 6.7,
        "sdMinus2": 7.3,
        "sdMinus1": 7.9,
        "median": 8.7,
        "sdPlus1": 9.5,
        "sdPlus2": 10.5,
        "sdPlus3": 11.5
    },
    {
        "length": 73.0,
        "sdMinus3": 6.8,
        "sdMinus2": 7.4,
        "sdMinus1": 8.0,
        "median": 8.8,
        "sdPlus1": 9.6,
        "sdPlus2": 10.6,
        "sdPlus3": 11.7
    },
    {
        "length": 73.5,
        "sdMinus3": 6.9,
        "sdMinus2": 7.4,
        "sdMinus1": 8.1,
        "median": 8.9,
        "sdPlus1": 9.7,
        "sdPlus2": 10.7,
        "sdPlus3": 11.8
    },
    {
        "length": 74.0,
        "sdMinus3": 6.9,
        "sdMinus2": 7.5,
        "sdMinus1": 8.2,
        "median": 9.0,
        "sdPlus1": 9.8,
        "sdPlus2": 10.8,
        "sdPlus3": 11.9
    },
    {
        "length": 74.5,
        "sdMinus3": 7.0,
        "sdMinus2": 7.6,
        "sdMinus1": 8.3,
        "median": 9.1,
        "sdPlus1": 9.9,
        "sdPlus2": 10.9,
        "sdPlus3": 12.0
    },
    {
        "length": 75.0,
        "sdMinus3": 7.1,
        "sdMinus2": 7.7,
        "sdMinus1": 8.4,
        "median": 9.1,
        "sdPlus1": 10.0,
        "sdPlus2": 11.0,
        "sdPlus3": 12.2
    },
    {
        "length": 75.5,
        "sdMinus3": 7.1,
        "sdMinus2": 7.8,
        "sdMinus1": 8.5,
        "median": 9.2,
        "sdPlus1": 10.1,
        "sdPlus2": 11.1,
        "sdPlus3": 12.3
    },
    {
        "length": 76.0,
        "sdMinus3": 7.2,
        "sdMinus2": 7.8,
        "sdMinus1": 8.5,
        "median": 9.3,
        "sdPlus1": 10.2,
        "sdPlus2": 11.2,
        "sdPlus3": 12.4
    },
    {
        "length": 76.5,
        "sdMinus3": 7.3,
        "sdMinus2": 7.9,
        "sdMinus1": 8.6,
        "median": 9.4,
        "sdPlus1": 10.3,
        "sdPlus2": 11.4,
        "sdPlus3": 12.5
    },
    {
        "length": 77.0,
        "sdMinus3": 7.4,
        "sdMinus2": 8.0,
        "sdMinus1": 8.7,
        "median": 9.5,
        "sdPlus1": 10.4,
        "sdPlus2": 11.5,
        "sdPlus3": 12.6
    },
    {
        "length": 77.5,
        "sdMinus3": 7.4,
        "sdMinus2": 8.1,
        "sdMinus1": 8.8,
        "median": 9.6,
        "sdPlus1": 10.5,
        "sdPlus2": 11.6,
        "sdPlus3": 12.8
    },
    {
        "length": 78.0,
        "sdMinus3": 7.5,
        "sdMinus2": 8.2,
        "sdMinus1": 8.9,
        "median": 9.7,
        "sdPlus1": 10.6,
        "sdPlus2": 11.7,
        "sdPlus3": 12.9
    },
    {
        "length": 78.5,
        "sdMinus3": 7.6,
        "sdMinus2": 8.2,
        "sdMinus1": 9.0,
        "median": 9.8,
        "sdPlus1": 10.7,
        "sdPlus2": 11.8,
        "sdPlus3": 13.0
    },
    {
        "length": 79.0,
        "sdMinus3": 7.7,
        "sdMinus2": 8.3,
        "sdMinus1": 9.1,
        "median": 9.9,
        "sdPlus1": 10.8,
        "sdPlus2": 11.9,
        "sdPlus3": 13.1
    },
    {
        "length": 79.5,
        "sdMinus3": 7.7,
        "sdMinus2": 8.4,
        "sdMinus1": 9.1,
        "median": 10.0,
        "sdPlus1": 10.9,
        "sdPlus2": 12.0,
        "sdPlus3": 13.3
    },
    {
        "length": 80.0,
        "sdMinus3": 7.8,
        "sdMinus2": 8.5,
        "sdMinus1": 9.2,
        "median": 10.1,
        "sdPlus1": 11.0,
        "sdPlus2": 12.1,
        "sdPlus3": 13.4
    },
    {
        "length": 80.5,
        "sdMinus3": 7.9,
        "sdMinus2": 8.6,
        "sdMinus1": 9.3,
        "median": 10.2,
        "sdPlus1": 11.2,
        "sdPlus2": 12.3,
        "sdPlus3": 13.5
    },
    {
        "length": 81.0,
        "sdMinus3": 8.0,
        "sdMinus2": 8.7,
        "sdMinus1": 9.4,
        "median": 10.3,
        "sdPlus1": 11.3,
        "sdPlus2": 12.4,
        "sdPlus3": 13.7
    },
    {
        "length": 81.5,
        "sdMinus3": 8.1,
        "sdMinus2": 8.8,
        "sdMinus1": 9.5,
        "median": 10.4,
        "sdPlus1": 11.4,
        "sdPlus2": 12.5,
        "sdPlus3": 13.8
    },
    {
        "length": 82.0,
        "sdMinus3": 8.1,
        "sdMinus2": 8.8,
        "sdMinus1": 9.6,
        "median": 10.5,
        "sdPlus1": 11.5,
        "sdPlus2": 12.6,
        "sdPlus3": 13.9
    },
    {
        "length": 82.5,
        "sdMinus3": 8.2,
        "sdMinus2": 8.9,
        "sdMinus1": 9.7,
        "median": 10.6,
        "sdPlus1": 11.6,
        "sdPlus2": 12.8,
        "sdPlus3": 14.1
    },
    {
        "length": 83.0,
        "sdMinus3": 8.3,
        "sdMinus2": 9.0,
        "sdMinus1": 9.8,
        "median": 10.7,
        "sdPlus1": 11.8,
        "sdPlus2": 12.9,
        "sdPlus3": 14.2
    },
    {
        "length": 83.5,
        "sdMinus3": 8.4,
        "sdMinus2": 9.1,
        "sdMinus1": 9.9,
        "median": 10.9,
        "sdPlus1": 11.9,
        "sdPlus2": 13.1,
        "sdPlus3": 14.4
    },
    {
        "length": 84.0,
        "sdMinus3": 8.5,
        "sdMinus2": 9.2,
        "sdMinus1": 10.1,
        "median": 11.0,
        "sdPlus1": 12.0,
        "sdPlus2": 13.2,
        "sdPlus3": 14.5
    },
    {
        "length": 84.5,
        "sdMinus3": 8.6,
        "sdMinus2": 9.3,
        "sdMinus1": 10.2,
        "median": 11.1,
        "sdPlus1": 12.1,
        "sdPlus2": 13.3,
        "sdPlus3": 14.7
    },
    {
        "length": 85.0,
        "sdMinus3": 8.7,
        "sdMinus2": 9.4,
        "sdMinus1": 10.3,
        "median": 11.2,
        "sdPlus1": 12.3,
        "sdPlus2": 13.5,
        "sdPlus3": 14.9
    },
    {
        "length": 85.5,
        "sdMinus3": 8.8,
        "sdMinus2": 9.5,
        "sdMinus1": 10.4,
        "median": 11.3,
        "sdPlus1": 12.4,
        "sdPlus2": 13.6,
        "sdPlus3": 15.0
    },
    {
        "length": 86.0,
        "sdMinus3": 8.9,
        "sdMinus2": 9.7,
        "sdMinus1": 10.5,
        "median": 11.5,
        "sdPlus1": 12.6,
        "sdPlus2": 13.8,
        "sdPlus3": 15.2
    },
    {
        "length": 86.5,
        "sdMinus3": 9.0,
        "sdMinus2": 9.8,
        "sdMinus1": 10.6,
        "median": 11.6,
        "sdPlus1": 12.7,
        "sdPlus2": 13.9,
        "sdPlus3": 15.4
    },
    {
        "length": 87.0,
        "sdMinus3": 9.1,
        "sdMinus2": 9.9,
        "sdMinus1": 10.7,
        "median": 11.7,
        "sdPlus1": 12.8,
        "sdPlus2": 14.1,
        "sdPlus3": 15.5
    },
    {
        "length": 87.5,
        "sdMinus3": 9.2,
        "sdMinus2": 10.0,
        "sdMinus1": 10.9,
        "median": 11.8,
        "sdPlus1": 13.0,
        "sdPlus2": 14.2,
        "sdPlus3": 15.7
    },
    {
        "length": 88.0,
        "sdMinus3": 9.3,
        "sdMinus2": 10.1,
        "sdMinus1": 11.0,
        "median": 12.0,
        "sdPlus1": 13.1,
        "sdPlus2": 14.4,
        "sdPlus3": 15.9
    },
    {
        "length": 88.5,
        "sdMinus3": 9.4,
        "sdMinus2": 10.2,
        "sdMinus1": 11.1,
        "median": 12.1,
        "sdPlus1": 13.2,
        "sdPlus2": 14.5,
        "sdPlus3": 16.0
    },
    {
        "length": 89.0,
        "sdMinus3": 9.5,
        "sdMinus2": 10.3,
        "sdMinus1": 11.2,
        "median": 12.2,
        "sdPlus1": 13.4,
        "sdPlus2": 14.7,
        "sdPlus3": 16.2
    },
    {
        "length": 89.5,
        "sdMinus3": 9.6,
        "sdMinus2": 10.4,
        "sdMinus1": 11.3,
        "median": 12.3,
        "sdPlus1": 13.5,
        "sdPlus2": 14.8,
        "sdPlus3": 16.4
    },
    {
        "length": 90.0,
        "sdMinus3": 9.7,
        "sdMinus2": 10.5,
        "sdMinus1": 11.4,
        "median": 12.5,
        "sdPlus1": 13.7,
        "sdPlus2": 15.0,
        "sdPlus3": 16.5
    },
    {
        "length": 90.5,
        "sdMinus3": 9.8,
        "sdMinus2": 10.6,
        "sdMinus1": 11.5,
        "median": 12.6,
        "sdPlus1": 13.8,
        "sdPlus2": 15.1,
        "sdPlus3": 16.7
    },
    {
        "length": 91.0,
        "sdMinus3": 9.9,
        "sdMinus2": 10.7,
        "sdMinus1": 11.7,
        "median": 12.7,
        "sdPlus1": 13.9,
        "sdPlus2": 15.3,
        "sdPlus3": 16.9
    },
    {
        "length": 91.5,
        "sdMinus3": 10.0,
        "sdMinus2": 10.8,
        "sdMinus1": 11.8,
        "median": 12.8,
        "sdPlus1": 14.1,
        "sdPlus2": 15.5,
        "sdPlus3": 17.0
    },
    {
        "length": 92.0,
        "sdMinus3": 10.1,
        "sdMinus2": 10.9,
        "sdMinus1": 11.9,
        "median": 13.0,
        "sdPlus1": 14.2,
        "sdPlus2": 15.6,
        "sdPlus3": 17.2
    },
    {
        "length": 92.5,
        "sdMinus3": 10.1,
        "sdMinus2": 11.0,
        "sdMinus1": 12.0,
        "median": 13.1,
        "sdPlus1": 14.3,
        "sdPlus2": 15.8,
        "sdPlus3": 17.4
    },
    {
        "length": 93.0,
        "sdMinus3": 10.2,
        "sdMinus2": 11.1,
        "sdMinus1": 12.1,
        "median": 13.2,
        "sdPlus1": 14.5,
        "sdPlus2": 15.9,
        "sdPlus3": 17.5
    },
    {
        "length": 93.5,
        "sdMinus3": 10.3,
        "sdMinus2": 11.2,
        "sdMinus1": 12.2,
        "median": 13.3,
        "sdPlus1": 14.6,
        "sdPlus2": 16.1,
        "sdPlus3": 17.7
    },
    {
        "length": 94.0,
        "sdMinus3": 10.4,
        "sdMinus2": 11.3,
        "sdMinus1": 12.3,
        "median": 13.5,
        "sdPlus1": 14.7,
        "sdPlus2": 16.2,
        "sdPlus3": 17.9
    },
    {
        "length": 94.5,
        "sdMinus3": 10.5,
        "sdMinus2": 11.4,
        "sdMinus1": 12.4,
        "median": 13.6,
        "sdPlus1": 14.9,
        "sdPlus2": 16.4,
        "sdPlus3": 18.0
    },
    {
        "length": 95.0,
        "sdMinus3": 10.6,
        "sdMinus2": 11.5,
        "sdMinus1": 12.6,
        "median": 13.7,
        "sdPlus1": 15.0,
        "sdPlus2": 16.5,
        "sdPlus3": 18.2
    },
    {
        "length": 95.5,
        "sdMinus3": 10.7,
        "sdMinus2": 11.6,
        "sdMinus1": 12.7,
        "median": 13.8,
        "sdPlus1": 15.2,
        "sdPlus2": 16.7,
        "sdPlus3": 18.4
    },
    {
        "length": 96.0,
        "sdMinus3": 10.8,
        "sdMinus2": 11.7,
        "sdMinus1": 12.8,
        "median": 14.0,
        "sdPlus1": 15.3,
        "sdPlus2": 16.8,
        "sdPlus3": 18.6
    },
    {
        "length": 96.5,
        "sdMinus3": 10.9,
        "sdMinus2": 11.8,
        "sdMinus1": 12.9,
        "median": 14.1,
        "sdPlus1": 15.4,
        "sdPlus2": 17.0,
        "sdPlus3": 18.7
    },
    {
        "length": 97.0,
        "sdMinus3": 11.0,
        "sdMinus2": 12.0,
        "sdMinus1": 13.0,
        "median": 14.2,
        "sdPlus1": 15.6,
        "sdPlus2": 17.1,
        "sdPlus3": 18.9
    },
    {
        "length": 97.5,
        "sdMinus3": 11.1,
        "sdMinus2": 12.1,
        "sdMinus1": 13.1,
        "median": 14.4,
        "sdPlus1": 15.7,
        "sdPlus2": 17.3,
        "sdPlus3": 19.1
    },
    {
        "length": 98.0,
        "sdMinus3": 11.2,
        "sdMinus2": 12.2,
        "sdMinus1": 13.3,
        "median": 14.5,
        "sdPlus1": 15.9,
        "sdPlus2": 17.5,
        "sdPlus3": 19.3
    },
    {
        "length": 98.5,
        "sdMinus3": 11.3,
        "sdMinus2": 12.3,
        "sdMinus1": 13.4,
        "median": 14.6,
        "sdPlus1": 16.0,
        "sdPlus2": 17.6,
        "sdPlus3": 19.5
    },
    {
        "length": 99.0,
        "sdMinus3": 11.4,
        "sdMinus2": 12.4,
        "sdMinus1": 13.5,
        "median": 14.8,
        "sdPlus1": 16.2,
        "sdPlus2": 17.8,
        "sdPlus3": 19.6
    },
    {
        "length": 99.5,
        "sdMinus3": 11.5,
        "sdMinus2": 12.5,
        "sdMinus1": 13.6,
        "median": 14.9,
        "sdPlus1": 16.3,
        "sdPlus2": 18.0,
        "sdPlus3": 19.8
    },
    {
        "length": 100.0,
        "sdMinus3": 11.6,
        "sdMinus2": 12.6,
        "sdMinus1": 13.7,
        "median": 15.0,
        "sdPlus1": 16.5,
        "sdPlus2": 18.1,
        "sdPlus3": 20.0
    },
    {
        "length": 100.5,
        "sdMinus3": 11.7,
        "sdMinus2": 12.7,
        "sdMinus1": 13.9,
        "median": 15.2,
        "sdPlus1": 16.6,
        "sdPlus2": 18.3,
        "sdPlus3": 20.2
    },
    {
        "length": 101.0,
        "sdMinus3": 11.8,
        "sdMinus2": 12.8,
        "sdMinus1": 14.0,
        "median": 15.3,
        "sdPlus1": 16.8,
        "sdPlus2": 18.5,
        "sdPlus3": 20.4
    },
    {
        "length": 101.5,
        "sdMinus3": 11.9,
        "sdMinus2": 13.0,
        "sdMinus1": 14.1,
        "median": 15.5,
        "sdPlus1": 17.0,
        "sdPlus2": 18.7,
        "sdPlus3": 20.6
    },
    {
        "length": 102.0,
        "sdMinus3": 12.0,
        "sdMinus2": 13.1,
        "sdMinus1": 14.3,
        "median": 15.6,
        "sdPlus1": 17.1,
        "sdPlus2": 18.9,
        "sdPlus3": 20.8
    },
    {
        "length": 102.5,
        "sdMinus3": 12.1,
        "sdMinus2": 13.2,
        "sdMinus1": 14.4,
        "median": 15.8,
        "sdPlus1": 17.3,
        "sdPlus2": 19.0,
        "sdPlus3": 21.0
    },
    {
        "length": 103.0,
        "sdMinus3": 12.3,
        "sdMinus2": 13.3,
        "sdMinus1": 14.5,
        "median": 15.9,
        "sdPlus1": 17.5,
        "sdPlus2": 19.2,
        "sdPlus3": 21.3
    },
    {
        "length": 103.5,
        "sdMinus3": 12.4,
        "sdMinus2": 13.5,
        "sdMinus1": 14.7,
        "median": 16.1,
        "sdPlus1": 17.6,
        "sdPlus2": 19.4,
        "sdPlus3": 21.5
    },
    {
        "length": 104.0,
        "sdMinus3": 12.5,
        "sdMinus2": 13.6,
        "sdMinus1": 14.8,
        "median": 16.2,
        "sdPlus1": 17.8,
        "sdPlus2": 19.6,
        "sdPlus3": 21.7
    },
    {
        "length": 104.5,
        "sdMinus3": 12.6,
        "sdMinus2": 13.7,
        "sdMinus1": 15.0,
        "median": 16.4,
        "sdPlus1": 18.0,
        "sdPlus2": 19.8,
        "sdPlus3": 21.9
    },
    {
        "length": 105.0,
        "sdMinus3": 12.7,
        "sdMinus2": 13.8,
        "sdMinus1": 15.1,
        "median": 16.5,
        "sdPlus1": 18.2,
        "sdPlus2": 20.0,
        "sdPlus3": 22.2
    },
    {
        "length": 105.5,
        "sdMinus3": 12.8,
        "sdMinus2": 14.0,
        "sdMinus1": 15.3,
        "median": 16.7,
        "sdPlus1": 18.4,
        "sdPlus2": 20.2,
        "sdPlus3": 22.4
    },
    {
        "length": 106.0,
        "sdMinus3": 13.0,
        "sdMinus2": 14.1,
        "sdMinus1": 15.4,
        "median": 16.9,
        "sdPlus1": 18.5,
        "sdPlus2": 20.5,
        "sdPlus3": 22.6
    },
    {
        "length": 106.5,
        "sdMinus3": 13.1,
        "sdMinus2": 14.3,
        "sdMinus1": 15.6,
        "median": 17.1,
        "sdPlus1": 18.7,
        "sdPlus2": 20.7,
        "sdPlus3": 22.9
    },
    {
        "length": 107.0,
        "sdMinus3": 13.2,
        "sdMinus2": 14.4,
        "sdMinus1": 15.7,
        "median": 17.2,
        "sdPlus1": 18.9,
        "sdPlus2": 20.9,
        "sdPlus3": 23.1
    },
    {
        "length": 107.5,
        "sdMinus3": 13.3,
        "sdMinus2": 14.5,
        "sdMinus1": 15.9,
        "median": 17.4,
        "sdPlus1": 19.1,
        "sdPlus2": 21.1,
        "sdPlus3": 23.4
    },
    {
        "length": 108.0,
        "sdMinus3": 13.5,
        "sdMinus2": 14.7,
        "sdMinus1": 16.0,
        "median": 17.6,
        "sdPlus1": 19.3,
        "sdPlus2": 21.3,
        "sdPlus3": 23.6
    },
    {
        "length": 108.5,
        "sdMinus3": 13.6,
        "sdMinus2": 14.8,
        "sdMinus1": 16.2,
        "median": 17.8,
        "sdPlus1": 19.5,
        "sdPlus2": 21.6,
        "sdPlus3": 23.9
    },
    {
        "length": 109.0,
        "sdMinus3": 13.7,
        "sdMinus2": 15.0,
        "sdMinus1": 16.4,
        "median": 18.0,
        "sdPlus1": 19.7,
        "sdPlus2": 21.8,
        "sdPlus3": 24.2
    },
    {
        "length": 109.5,
        "sdMinus3": 13.9,
        "sdMinus2": 15.1,
        "sdMinus1": 16.5,
        "median": 18.1,
        "sdPlus1": 20.0,
        "sdPlus2": 22.0,
        "sdPlus3": 24.4
    },
    {
        "length": 110.0,
        "sdMinus3": 14.0,
        "sdMinus2": 15.3,
        "sdMinus1": 16.7,
        "median": 18.3,
        "sdPlus1": 20.2,
        "sdPlus2": 22.3,
        "sdPlus3": 24.7
    }
];

export const WHO_WEIGHT_LENGTH_BOYS = [
    {
        "length": 45.0,
        "sdMinus3": 1.9,
        "sdMinus2": 2.0,
        "sdMinus1": 2.2,
        "median": 2.4,
        "sdPlus1": 2.7,
        "sdPlus2": 3.0,
        "sdPlus3": 3.3
    },
    {
        "length": 45.5,
        "sdMinus3": 1.9,
        "sdMinus2": 2.1,
        "sdMinus1": 2.3,
        "median": 2.5,
        "sdPlus1": 2.8,
        "sdPlus2": 3.1,
        "sdPlus3": 3.4
    },
    {
        "length": 46.0,
        "sdMinus3": 2.0,
        "sdMinus2": 2.2,
        "sdMinus1": 2.4,
        "median": 2.6,
        "sdPlus1": 2.9,
        "sdPlus2": 3.1,
        "sdPlus3": 3.5
    },
    {
        "length": 46.5,
        "sdMinus3": 2.1,
        "sdMinus2": 2.3,
        "sdMinus1": 2.5,
        "median": 2.7,
        "sdPlus1": 3.0,
        "sdPlus2": 3.2,
        "sdPlus3": 3.6
    },
    {
        "length": 47.0,
        "sdMinus3": 2.1,
        "sdMinus2": 2.3,
        "sdMinus1": 2.5,
        "median": 2.8,
        "sdPlus1": 3.0,
        "sdPlus2": 3.3,
        "sdPlus3": 3.7
    },
    {
        "length": 47.5,
        "sdMinus3": 2.2,
        "sdMinus2": 2.4,
        "sdMinus1": 2.6,
        "median": 2.9,
        "sdPlus1": 3.1,
        "sdPlus2": 3.4,
        "sdPlus3": 3.8
    },
    {
        "length": 48.0,
        "sdMinus3": 2.3,
        "sdMinus2": 2.5,
        "sdMinus1": 2.7,
        "median": 2.9,
        "sdPlus1": 3.2,
        "sdPlus2": 3.6,
        "sdPlus3": 3.9
    },
    {
        "length": 48.5,
        "sdMinus3": 2.3,
        "sdMinus2": 2.6,
        "sdMinus1": 2.8,
        "median": 3.0,
        "sdPlus1": 3.3,
        "sdPlus2": 3.7,
        "sdPlus3": 4.0
    },
    {
        "length": 49.0,
        "sdMinus3": 2.4,
        "sdMinus2": 2.6,
        "sdMinus1": 2.9,
        "median": 3.1,
        "sdPlus1": 3.4,
        "sdPlus2": 3.8,
        "sdPlus3": 4.2
    },
    {
        "length": 49.5,
        "sdMinus3": 2.5,
        "sdMinus2": 2.7,
        "sdMinus1": 3.0,
        "median": 3.2,
        "sdPlus1": 3.5,
        "sdPlus2": 3.9,
        "sdPlus3": 4.3
    },
    {
        "length": 50.0,
        "sdMinus3": 2.6,
        "sdMinus2": 2.8,
        "sdMinus1": 3.0,
        "median": 3.3,
        "sdPlus1": 3.6,
        "sdPlus2": 4.0,
        "sdPlus3": 4.4
    },
    {
        "length": 50.5,
        "sdMinus3": 2.7,
        "sdMinus2": 2.9,
        "sdMinus1": 3.1,
        "median": 3.4,
        "sdPlus1": 3.8,
        "sdPlus2": 4.1,
        "sdPlus3": 4.5
    },
    {
        "length": 51.0,
        "sdMinus3": 2.7,
        "sdMinus2": 3.0,
        "sdMinus1": 3.2,
        "median": 3.5,
        "sdPlus1": 3.9,
        "sdPlus2": 4.2,
        "sdPlus3": 4.7
    },
    {
        "length": 51.5,
        "sdMinus3": 2.8,
        "sdMinus2": 3.1,
        "sdMinus1": 3.3,
        "median": 3.6,
        "sdPlus1": 4.0,
        "sdPlus2": 4.4,
        "sdPlus3": 4.8
    },
    {
        "length": 52.0,
        "sdMinus3": 2.9,
        "sdMinus2": 3.2,
        "sdMinus1": 3.5,
        "median": 3.8,
        "sdPlus1": 4.1,
        "sdPlus2": 4.5,
        "sdPlus3": 5.0
    },
    {
        "length": 52.5,
        "sdMinus3": 3.0,
        "sdMinus2": 3.3,
        "sdMinus1": 3.6,
        "median": 3.9,
        "sdPlus1": 4.2,
        "sdPlus2": 4.6,
        "sdPlus3": 5.1
    },
    {
        "length": 53.0,
        "sdMinus3": 3.1,
        "sdMinus2": 3.4,
        "sdMinus1": 3.7,
        "median": 4.0,
        "sdPlus1": 4.4,
        "sdPlus2": 4.8,
        "sdPlus3": 5.3
    },
    {
        "length": 53.5,
        "sdMinus3": 3.2,
        "sdMinus2": 3.5,
        "sdMinus1": 3.8,
        "median": 4.1,
        "sdPlus1": 4.5,
        "sdPlus2": 4.9,
        "sdPlus3": 5.4
    },
    {
        "length": 54.0,
        "sdMinus3": 3.3,
        "sdMinus2": 3.6,
        "sdMinus1": 3.9,
        "median": 4.3,
        "sdPlus1": 4.7,
        "sdPlus2": 5.1,
        "sdPlus3": 5.6
    },
    {
        "length": 54.5,
        "sdMinus3": 3.4,
        "sdMinus2": 3.7,
        "sdMinus1": 4.0,
        "median": 4.4,
        "sdPlus1": 4.8,
        "sdPlus2": 5.3,
        "sdPlus3": 5.8
    },
    {
        "length": 55.0,
        "sdMinus3": 3.6,
        "sdMinus2": 3.8,
        "sdMinus1": 4.2,
        "median": 4.5,
        "sdPlus1": 5.0,
        "sdPlus2": 5.4,
        "sdPlus3": 6.0
    },
    {
        "length": 55.5,
        "sdMinus3": 3.7,
        "sdMinus2": 4.0,
        "sdMinus1": 4.3,
        "median": 4.7,
        "sdPlus1": 5.1,
        "sdPlus2": 5.6,
        "sdPlus3": 6.1
    },
    {
        "length": 56.0,
        "sdMinus3": 3.8,
        "sdMinus2": 4.1,
        "sdMinus1": 4.4,
        "median": 4.8,
        "sdPlus1": 5.3,
        "sdPlus2": 5.8,
        "sdPlus3": 6.3
    },
    {
        "length": 56.5,
        "sdMinus3": 3.9,
        "sdMinus2": 4.2,
        "sdMinus1": 4.6,
        "median": 5.0,
        "sdPlus1": 5.4,
        "sdPlus2": 5.9,
        "sdPlus3": 6.5
    },
    {
        "length": 57.0,
        "sdMinus3": 4.0,
        "sdMinus2": 4.3,
        "sdMinus1": 4.7,
        "median": 5.1,
        "sdPlus1": 5.6,
        "sdPlus2": 6.1,
        "sdPlus3": 6.7
    },
    {
        "length": 57.5,
        "sdMinus3": 4.1,
        "sdMinus2": 4.5,
        "sdMinus1": 4.9,
        "median": 5.3,
        "sdPlus1": 5.7,
        "sdPlus2": 6.3,
        "sdPlus3": 6.9
    },
    {
        "length": 58.0,
        "sdMinus3": 4.3,
        "sdMinus2": 4.6,
        "sdMinus1": 5.0,
        "median": 5.4,
        "sdPlus1": 5.9,
        "sdPlus2": 6.4,
        "sdPlus3": 7.1
    },
    {
        "length": 58.5,
        "sdMinus3": 4.4,
        "sdMinus2": 4.7,
        "sdMinus1": 5.1,
        "median": 5.6,
        "sdPlus1": 6.1,
        "sdPlus2": 6.6,
        "sdPlus3": 7.2
    },
    {
        "length": 59.0,
        "sdMinus3": 4.5,
        "sdMinus2": 4.8,
        "sdMinus1": 5.3,
        "median": 5.7,
        "sdPlus1": 6.2,
        "sdPlus2": 6.8,
        "sdPlus3": 7.4
    },
    {
        "length": 59.5,
        "sdMinus3": 4.6,
        "sdMinus2": 5.0,
        "sdMinus1": 5.4,
        "median": 5.9,
        "sdPlus1": 6.4,
        "sdPlus2": 7.0,
        "sdPlus3": 7.6
    },
    {
        "length": 60.0,
        "sdMinus3": 4.7,
        "sdMinus2": 5.1,
        "sdMinus1": 5.5,
        "median": 6.0,
        "sdPlus1": 6.5,
        "sdPlus2": 7.1,
        "sdPlus3": 7.8
    },
    {
        "length": 60.5,
        "sdMinus3": 4.8,
        "sdMinus2": 5.2,
        "sdMinus1": 5.6,
        "median": 6.1,
        "sdPlus1": 6.7,
        "sdPlus2": 7.3,
        "sdPlus3": 8.0
    },
    {
        "length": 61.0,
        "sdMinus3": 4.9,
        "sdMinus2": 5.3,
        "sdMinus1": 5.8,
        "median": 6.3,
        "sdPlus1": 6.8,
        "sdPlus2": 7.4,
        "sdPlus3": 8.1
    },
    {
        "length": 61.5,
        "sdMinus3": 5.0,
        "sdMinus2": 5.4,
        "sdMinus1": 5.9,
        "median": 6.4,
        "sdPlus1": 7.0,
        "sdPlus2": 7.6,
        "sdPlus3": 8.3
    },
    {
        "length": 62.0,
        "sdMinus3": 5.1,
        "sdMinus2": 5.6,
        "sdMinus1": 6.0,
        "median": 6.5,
        "sdPlus1": 7.1,
        "sdPlus2": 7.7,
        "sdPlus3": 8.5
    },
    {
        "length": 62.5,
        "sdMinus3": 5.2,
        "sdMinus2": 5.7,
        "sdMinus1": 6.1,
        "median": 6.7,
        "sdPlus1": 7.2,
        "sdPlus2": 7.9,
        "sdPlus3": 8.6
    },
    {
        "length": 63.0,
        "sdMinus3": 5.3,
        "sdMinus2": 5.8,
        "sdMinus1": 6.2,
        "median": 6.8,
        "sdPlus1": 7.4,
        "sdPlus2": 8.0,
        "sdPlus3": 8.8
    },
    {
        "length": 63.5,
        "sdMinus3": 5.4,
        "sdMinus2": 5.9,
        "sdMinus1": 6.4,
        "median": 6.9,
        "sdPlus1": 7.5,
        "sdPlus2": 8.2,
        "sdPlus3": 8.9
    },
    {
        "length": 64.0,
        "sdMinus3": 5.5,
        "sdMinus2": 6.0,
        "sdMinus1": 6.5,
        "median": 7.0,
        "sdPlus1": 7.6,
        "sdPlus2": 8.3,
        "sdPlus3": 9.1
    },
    {
        "length": 64.5,
        "sdMinus3": 5.6,
        "sdMinus2": 6.1,
        "sdMinus1": 6.6,
        "median": 7.1,
        "sdPlus1": 7.8,
        "sdPlus2": 8.5,
        "sdPlus3": 9.3
    },
    {
        "length": 65.0,
        "sdMinus3": 5.7,
        "sdMinus2": 6.2,
        "sdMinus1": 6.7,
        "median": 7.3,
        "sdPlus1": 7.9,
        "sdPlus2": 8.6,
        "sdPlus3": 9.4
    },
    {
        "length": 65.5,
        "sdMinus3": 5.8,
        "sdMinus2": 6.3,
        "sdMinus1": 6.8,
        "median": 7.4,
        "sdPlus1": 8.0,
        "sdPlus2": 8.7,
        "sdPlus3": 9.6
    },
    {
        "length": 66.0,
        "sdMinus3": 5.9,
        "sdMinus2": 6.4,
        "sdMinus1": 6.9,
        "median": 7.5,
        "sdPlus1": 8.2,
        "sdPlus2": 8.9,
        "sdPlus3": 9.7
    },
    {
        "length": 66.5,
        "sdMinus3": 6.0,
        "sdMinus2": 6.5,
        "sdMinus1": 7.0,
        "median": 7.6,
        "sdPlus1": 8.3,
        "sdPlus2": 9.0,
        "sdPlus3": 9.9
    },
    {
        "length": 67.0,
        "sdMinus3": 6.1,
        "sdMinus2": 6.6,
        "sdMinus1": 7.1,
        "median": 7.7,
        "sdPlus1": 8.4,
        "sdPlus2": 9.2,
        "sdPlus3": 10.0
    },
    {
        "length": 67.5,
        "sdMinus3": 6.2,
        "sdMinus2": 6.7,
        "sdMinus1": 7.2,
        "median": 7.9,
        "sdPlus1": 8.5,
        "sdPlus2": 9.3,
        "sdPlus3": 10.2
    },
    {
        "length": 68.0,
        "sdMinus3": 6.3,
        "sdMinus2": 6.8,
        "sdMinus1": 7.3,
        "median": 8.0,
        "sdPlus1": 8.7,
        "sdPlus2": 9.4,
        "sdPlus3": 10.3
    },
    {
        "length": 68.5,
        "sdMinus3": 6.4,
        "sdMinus2": 6.9,
        "sdMinus1": 7.5,
        "median": 8.1,
        "sdPlus1": 8.8,
        "sdPlus2": 9.6,
        "sdPlus3": 10.5
    },
    {
        "length": 69.0,
        "sdMinus3": 6.5,
        "sdMinus2": 7.0,
        "sdMinus1": 7.6,
        "median": 8.2,
        "sdPlus1": 8.9,
        "sdPlus2": 9.7,
        "sdPlus3": 10.6
    },
    {
        "length": 69.5,
        "sdMinus3": 6.6,
        "sdMinus2": 7.1,
        "sdMinus1": 7.7,
        "median": 8.3,
        "sdPlus1": 9.0,
        "sdPlus2": 9.8,
        "sdPlus3": 10.8
    },
    {
        "length": 70.0,
        "sdMinus3": 6.6,
        "sdMinus2": 7.2,
        "sdMinus1": 7.8,
        "median": 8.4,
        "sdPlus1": 9.2,
        "sdPlus2": 10.0,
        "sdPlus3": 10.9
    },
    {
        "length": 70.5,
        "sdMinus3": 6.7,
        "sdMinus2": 7.3,
        "sdMinus1": 7.9,
        "median": 8.5,
        "sdPlus1": 9.3,
        "sdPlus2": 10.1,
        "sdPlus3": 11.1
    },
    {
        "length": 71.0,
        "sdMinus3": 6.8,
        "sdMinus2": 7.4,
        "sdMinus1": 8.0,
        "median": 8.6,
        "sdPlus1": 9.4,
        "sdPlus2": 10.2,
        "sdPlus3": 11.2
    },
    {
        "length": 71.5,
        "sdMinus3": 6.9,
        "sdMinus2": 7.5,
        "sdMinus1": 8.1,
        "median": 8.8,
        "sdPlus1": 9.5,
        "sdPlus2": 10.4,
        "sdPlus3": 11.3
    },
    {
        "length": 72.0,
        "sdMinus3": 7.0,
        "sdMinus2": 7.6,
        "sdMinus1": 8.2,
        "median": 8.9,
        "sdPlus1": 9.6,
        "sdPlus2": 10.5,
        "sdPlus3": 11.5
    },
    {
        "length": 72.5,
        "sdMinus3": 7.1,
        "sdMinus2": 7.6,
        "sdMinus1": 8.3,
        "median": 9.0,
        "sdPlus1": 9.8,
        "sdPlus2": 10.6,
        "sdPlus3": 11.6
    },
    {
        "length": 73.0,
        "sdMinus3": 7.2,
        "sdMinus2": 7.7,
        "sdMinus1": 8.4,
        "median": 9.1,
        "sdPlus1": 9.9,
        "sdPlus2": 10.8,
        "sdPlus3": 11.8
    },
    {
        "length": 73.5,
        "sdMinus3": 7.2,
        "sdMinus2": 7.8,
        "sdMinus1": 8.5,
        "median": 9.2,
        "sdPlus1": 10.0,
        "sdPlus2": 10.9,
        "sdPlus3": 11.9
    },
    {
        "length": 74.0,
        "sdMinus3": 7.3,
        "sdMinus2": 7.9,
        "sdMinus1": 8.6,
        "median": 9.3,
        "sdPlus1": 10.1,
        "sdPlus2": 11.0,
        "sdPlus3": 12.1
    },
    {
        "length": 74.5,
        "sdMinus3": 7.4,
        "sdMinus2": 8.0,
        "sdMinus1": 8.7,
        "median": 9.4,
        "sdPlus1": 10.2,
        "sdPlus2": 11.2,
        "sdPlus3": 12.2
    },
    {
        "length": 75.0,
        "sdMinus3": 7.5,
        "sdMinus2": 8.1,
        "sdMinus1": 8.8,
        "median": 9.5,
        "sdPlus1": 10.3,
        "sdPlus2": 11.3,
        "sdPlus3": 12.3
    },
    {
        "length": 75.5,
        "sdMinus3": 7.6,
        "sdMinus2": 8.2,
        "sdMinus1": 8.8,
        "median": 9.6,
        "sdPlus1": 10.4,
        "sdPlus2": 11.4,
        "sdPlus3": 12.5
    },
    {
        "length": 76.0,
        "sdMinus3": 7.6,
        "sdMinus2": 8.3,
        "sdMinus1": 8.9,
        "median": 9.7,
        "sdPlus1": 10.6,
        "sdPlus2": 11.5,
        "sdPlus3": 12.6
    },
    {
        "length": 76.5,
        "sdMinus3": 7.7,
        "sdMinus2": 8.3,
        "sdMinus1": 9.0,
        "median": 9.8,
        "sdPlus1": 10.7,
        "sdPlus2": 11.6,
        "sdPlus3": 12.7
    },
    {
        "length": 77.0,
        "sdMinus3": 7.8,
        "sdMinus2": 8.4,
        "sdMinus1": 9.1,
        "median": 9.9,
        "sdPlus1": 10.8,
        "sdPlus2": 11.7,
        "sdPlus3": 12.8
    },
    {
        "length": 77.5,
        "sdMinus3": 7.9,
        "sdMinus2": 8.5,
        "sdMinus1": 9.2,
        "median": 10.0,
        "sdPlus1": 10.9,
        "sdPlus2": 11.9,
        "sdPlus3": 13.0
    },
    {
        "length": 78.0,
        "sdMinus3": 7.9,
        "sdMinus2": 8.6,
        "sdMinus1": 9.3,
        "median": 10.1,
        "sdPlus1": 11.0,
        "sdPlus2": 12.0,
        "sdPlus3": 13.1
    },
    {
        "length": 78.5,
        "sdMinus3": 8.0,
        "sdMinus2": 8.7,
        "sdMinus1": 9.4,
        "median": 10.2,
        "sdPlus1": 11.1,
        "sdPlus2": 12.1,
        "sdPlus3": 13.2
    },
    {
        "length": 79.0,
        "sdMinus3": 8.1,
        "sdMinus2": 8.7,
        "sdMinus1": 9.5,
        "median": 10.3,
        "sdPlus1": 11.2,
        "sdPlus2": 12.2,
        "sdPlus3": 13.3
    },
    {
        "length": 79.5,
        "sdMinus3": 8.2,
        "sdMinus2": 8.8,
        "sdMinus1": 9.5,
        "median": 10.4,
        "sdPlus1": 11.3,
        "sdPlus2": 12.3,
        "sdPlus3": 13.4
    },
    {
        "length": 80.0,
        "sdMinus3": 8.2,
        "sdMinus2": 8.9,
        "sdMinus1": 9.6,
        "median": 10.4,
        "sdPlus1": 11.4,
        "sdPlus2": 12.4,
        "sdPlus3": 13.6
    },
    {
        "length": 80.5,
        "sdMinus3": 8.3,
        "sdMinus2": 9.0,
        "sdMinus1": 9.7,
        "median": 10.5,
        "sdPlus1": 11.5,
        "sdPlus2": 12.5,
        "sdPlus3": 13.7
    },
    {
        "length": 81.0,
        "sdMinus3": 8.4,
        "sdMinus2": 9.1,
        "sdMinus1": 9.8,
        "median": 10.6,
        "sdPlus1": 11.6,
        "sdPlus2": 12.6,
        "sdPlus3": 13.8
    },
    {
        "length": 81.5,
        "sdMinus3": 8.5,
        "sdMinus2": 9.1,
        "sdMinus1": 9.9,
        "median": 10.7,
        "sdPlus1": 11.7,
        "sdPlus2": 12.7,
        "sdPlus3": 13.9
    },
    {
        "length": 82.0,
        "sdMinus3": 8.5,
        "sdMinus2": 9.2,
        "sdMinus1": 10.0,
        "median": 10.8,
        "sdPlus1": 11.8,
        "sdPlus2": 12.8,
        "sdPlus3": 14.0
    },
    {
        "length": 82.5,
        "sdMinus3": 8.6,
        "sdMinus2": 9.3,
        "sdMinus1": 10.1,
        "median": 10.9,
        "sdPlus1": 11.9,
        "sdPlus2": 13.0,
        "sdPlus3": 14.2
    },
    {
        "length": 83.0,
        "sdMinus3": 8.7,
        "sdMinus2": 9.4,
        "sdMinus1": 10.2,
        "median": 11.0,
        "sdPlus1": 12.0,
        "sdPlus2": 13.1,
        "sdPlus3": 14.3
    },
    {
        "length": 83.5,
        "sdMinus3": 8.8,
        "sdMinus2": 9.5,
        "sdMinus1": 10.3,
        "median": 11.2,
        "sdPlus1": 12.1,
        "sdPlus2": 13.2,
        "sdPlus3": 14.4
    },
    {
        "length": 84.0,
        "sdMinus3": 8.9,
        "sdMinus2": 9.6,
        "sdMinus1": 10.4,
        "median": 11.3,
        "sdPlus1": 12.2,
        "sdPlus2": 13.3,
        "sdPlus3": 14.6
    },
    {
        "length": 84.5,
        "sdMinus3": 9.0,
        "sdMinus2": 9.7,
        "sdMinus1": 10.5,
        "median": 11.4,
        "sdPlus1": 12.4,
        "sdPlus2": 13.5,
        "sdPlus3": 14.7
    },
    {
        "length": 85.0,
        "sdMinus3": 9.1,
        "sdMinus2": 9.8,
        "sdMinus1": 10.6,
        "median": 11.5,
        "sdPlus1": 12.5,
        "sdPlus2": 13.6,
        "sdPlus3": 14.9
    },
    {
        "length": 85.5,
        "sdMinus3": 9.2,
        "sdMinus2": 9.9,
        "sdMinus1": 10.7,
        "median": 11.6,
        "sdPlus1": 12.6,
        "sdPlus2": 13.7,
        "sdPlus3": 15.0
    },
    {
        "length": 86.0,
        "sdMinus3": 9.3,
        "sdMinus2": 10.0,
        "sdMinus1": 10.8,
        "median": 11.7,
        "sdPlus1": 12.8,
        "sdPlus2": 13.9,
        "sdPlus3": 15.2
    },
    {
        "length": 86.5,
        "sdMinus3": 9.4,
        "sdMinus2": 10.1,
        "sdMinus1": 11.0,
        "median": 11.9,
        "sdPlus1": 12.9,
        "sdPlus2": 14.0,
        "sdPlus3": 15.3
    },
    {
        "length": 87.0,
        "sdMinus3": 9.5,
        "sdMinus2": 10.2,
        "sdMinus1": 11.1,
        "median": 12.0,
        "sdPlus1": 13.0,
        "sdPlus2": 14.2,
        "sdPlus3": 15.5
    },
    {
        "length": 87.5,
        "sdMinus3": 9.6,
        "sdMinus2": 10.4,
        "sdMinus1": 11.2,
        "median": 12.1,
        "sdPlus1": 13.2,
        "sdPlus2": 14.3,
        "sdPlus3": 15.6
    },
    {
        "length": 88.0,
        "sdMinus3": 9.7,
        "sdMinus2": 10.5,
        "sdMinus1": 11.3,
        "median": 12.2,
        "sdPlus1": 13.3,
        "sdPlus2": 14.5,
        "sdPlus3": 15.8
    },
    {
        "length": 88.5,
        "sdMinus3": 9.8,
        "sdMinus2": 10.6,
        "sdMinus1": 11.4,
        "median": 12.4,
        "sdPlus1": 13.4,
        "sdPlus2": 14.6,
        "sdPlus3": 15.9
    },
    {
        "length": 89.0,
        "sdMinus3": 9.9,
        "sdMinus2": 10.7,
        "sdMinus1": 11.5,
        "median": 12.5,
        "sdPlus1": 13.5,
        "sdPlus2": 14.7,
        "sdPlus3": 16.1
    },
    {
        "length": 89.5,
        "sdMinus3": 10.0,
        "sdMinus2": 10.8,
        "sdMinus1": 11.6,
        "median": 12.6,
        "sdPlus1": 13.7,
        "sdPlus2": 14.9,
        "sdPlus3": 16.2
    },
    {
        "length": 90.0,
        "sdMinus3": 10.1,
        "sdMinus2": 10.9,
        "sdMinus1": 11.8,
        "median": 12.7,
        "sdPlus1": 13.8,
        "sdPlus2": 15.0,
        "sdPlus3": 16.4
    },
    {
        "length": 90.5,
        "sdMinus3": 10.2,
        "sdMinus2": 11.0,
        "sdMinus1": 11.9,
        "median": 12.8,
        "sdPlus1": 13.9,
        "sdPlus2": 15.1,
        "sdPlus3": 16.5
    },
    {
        "length": 91.0,
        "sdMinus3": 10.3,
        "sdMinus2": 11.1,
        "sdMinus1": 12.0,
        "median": 13.0,
        "sdPlus1": 14.1,
        "sdPlus2": 15.3,
        "sdPlus3": 16.7
    },
    {
        "length": 91.5,
        "sdMinus3": 10.4,
        "sdMinus2": 11.2,
        "sdMinus1": 12.1,
        "median": 13.1,
        "sdPlus1": 14.2,
        "sdPlus2": 15.4,
        "sdPlus3": 16.8
    },
    {
        "length": 92.0,
        "sdMinus3": 10.5,
        "sdMinus2": 11.3,
        "sdMinus1": 12.2,
        "median": 13.2,
        "sdPlus1": 14.3,
        "sdPlus2": 15.6,
        "sdPlus3": 17.0
    },
    {
        "length": 92.5,
        "sdMinus3": 10.6,
        "sdMinus2": 11.4,
        "sdMinus1": 12.3,
        "median": 13.3,
        "sdPlus1": 14.4,
        "sdPlus2": 15.7,
        "sdPlus3": 17.1
    },
    {
        "length": 93.0,
        "sdMinus3": 10.7,
        "sdMinus2": 11.5,
        "sdMinus1": 12.4,
        "median": 13.4,
        "sdPlus1": 14.6,
        "sdPlus2": 15.8,
        "sdPlus3": 17.3
    },
    {
        "length": 93.5,
        "sdMinus3": 10.7,
        "sdMinus2": 11.6,
        "sdMinus1": 12.5,
        "median": 13.5,
        "sdPlus1": 14.7,
        "sdPlus2": 16.0,
        "sdPlus3": 17.4
    },
    {
        "length": 94.0,
        "sdMinus3": 10.8,
        "sdMinus2": 11.7,
        "sdMinus1": 12.6,
        "median": 13.7,
        "sdPlus1": 14.8,
        "sdPlus2": 16.1,
        "sdPlus3": 17.6
    },
    {
        "length": 94.5,
        "sdMinus3": 10.9,
        "sdMinus2": 11.8,
        "sdMinus1": 12.7,
        "median": 13.8,
        "sdPlus1": 14.9,
        "sdPlus2": 16.3,
        "sdPlus3": 17.7
    },
    {
        "length": 95.0,
        "sdMinus3": 11.0,
        "sdMinus2": 11.9,
        "sdMinus1": 12.8,
        "median": 13.9,
        "sdPlus1": 15.1,
        "sdPlus2": 16.4,
        "sdPlus3": 17.9
    },
    {
        "length": 95.5,
        "sdMinus3": 11.1,
        "sdMinus2": 12.0,
        "sdMinus1": 12.9,
        "median": 14.0,
        "sdPlus1": 15.2,
        "sdPlus2": 16.5,
        "sdPlus3": 18.0
    },
    {
        "length": 96.0,
        "sdMinus3": 11.2,
        "sdMinus2": 12.1,
        "sdMinus1": 13.1,
        "median": 14.1,
        "sdPlus1": 15.3,
        "sdPlus2": 16.7,
        "sdPlus3": 18.2
    },
    {
        "length": 96.5,
        "sdMinus3": 11.3,
        "sdMinus2": 12.2,
        "sdMinus1": 13.2,
        "median": 14.3,
        "sdPlus1": 15.5,
        "sdPlus2": 16.8,
        "sdPlus3": 18.4
    },
    {
        "length": 97.0,
        "sdMinus3": 11.4,
        "sdMinus2": 12.3,
        "sdMinus1": 13.3,
        "median": 14.4,
        "sdPlus1": 15.6,
        "sdPlus2": 17.0,
        "sdPlus3": 18.5
    },
    {
        "length": 97.5,
        "sdMinus3": 11.5,
        "sdMinus2": 12.4,
        "sdMinus1": 13.4,
        "median": 14.5,
        "sdPlus1": 15.7,
        "sdPlus2": 17.1,
        "sdPlus3": 18.7
    },
    {
        "length": 98.0,
        "sdMinus3": 11.6,
        "sdMinus2": 12.5,
        "sdMinus1": 13.5,
        "median": 14.6,
        "sdPlus1": 15.9,
        "sdPlus2": 17.3,
        "sdPlus3": 18.9
    },
    {
        "length": 98.5,
        "sdMinus3": 11.7,
        "sdMinus2": 12.6,
        "sdMinus1": 13.6,
        "median": 14.8,
        "sdPlus1": 16.0,
        "sdPlus2": 17.5,
        "sdPlus3": 19.1
    },
    {
        "length": 99.0,
        "sdMinus3": 11.8,
        "sdMinus2": 12.7,
        "sdMinus1": 13.7,
        "median": 14.9,
        "sdPlus1": 16.2,
        "sdPlus2": 17.6,
        "sdPlus3": 19.2
    },
    {
        "length": 99.5,
        "sdMinus3": 11.9,
        "sdMinus2": 12.8,
        "sdMinus1": 13.9,
        "median": 15.0,
        "sdPlus1": 16.3,
        "sdPlus2": 17.8,
        "sdPlus3": 19.4
    },
    {
        "length": 100.0,
        "sdMinus3": 12.0,
        "sdMinus2": 12.9,
        "sdMinus1": 14.0,
        "median": 15.2,
        "sdPlus1": 16.5,
        "sdPlus2": 18.0,
        "sdPlus3": 19.6
    },
    {
        "length": 100.5,
        "sdMinus3": 12.1,
        "sdMinus2": 13.0,
        "sdMinus1": 14.1,
        "median": 15.3,
        "sdPlus1": 16.6,
        "sdPlus2": 18.1,
        "sdPlus3": 19.8
    },
    {
        "length": 101.0,
        "sdMinus3": 12.2,
        "sdMinus2": 13.2,
        "sdMinus1": 14.2,
        "median": 15.4,
        "sdPlus1": 16.8,
        "sdPlus2": 18.3,
        "sdPlus3": 20.0
    },
    {
        "length": 101.5,
        "sdMinus3": 12.3,
        "sdMinus2": 13.3,
        "sdMinus1": 14.4,
        "median": 15.6,
        "sdPlus1": 16.9,
        "sdPlus2": 18.5,
        "sdPlus3": 20.2
    },
    {
        "length": 102.0,
        "sdMinus3": 12.4,
        "sdMinus2": 13.4,
        "sdMinus1": 14.5,
        "median": 15.7,
        "sdPlus1": 17.1,
        "sdPlus2": 18.7,
        "sdPlus3": 20.4
    },
    {
        "length": 102.5,
        "sdMinus3": 12.5,
        "sdMinus2": 13.5,
        "sdMinus1": 14.6,
        "median": 15.9,
        "sdPlus1": 17.3,
        "sdPlus2": 18.8,
        "sdPlus3": 20.6
    },
    {
        "length": 103.0,
        "sdMinus3": 12.6,
        "sdMinus2": 13.6,
        "sdMinus1": 14.8,
        "median": 16.0,
        "sdPlus1": 17.4,
        "sdPlus2": 19.0,
        "sdPlus3": 20.8
    },
    {
        "length": 103.5,
        "sdMinus3": 12.7,
        "sdMinus2": 13.7,
        "sdMinus1": 14.9,
        "median": 16.2,
        "sdPlus1": 17.6,
        "sdPlus2": 19.2,
        "sdPlus3": 21.0
    },
    {
        "length": 104.0,
        "sdMinus3": 12.8,
        "sdMinus2": 13.9,
        "sdMinus1": 15.0,
        "median": 16.3,
        "sdPlus1": 17.8,
        "sdPlus2": 19.4,
        "sdPlus3": 21.2
    },
    {
        "length": 104.5,
        "sdMinus3": 12.9,
        "sdMinus2": 14.0,
        "sdMinus1": 15.2,
        "median": 16.5,
        "sdPlus1": 17.9,
        "sdPlus2": 19.6,
        "sdPlus3": 21.5
    },
    {
        "length": 105.0,
        "sdMinus3": 13.0,
        "sdMinus2": 14.1,
        "sdMinus1": 15.3,
        "median": 16.6,
        "sdPlus1": 18.1,
        "sdPlus2": 19.8,
        "sdPlus3": 21.7
    },
    {
        "length": 105.5,
        "sdMinus3": 13.2,
        "sdMinus2": 14.2,
        "sdMinus1": 15.4,
        "median": 16.8,
        "sdPlus1": 18.3,
        "sdPlus2": 20.0,
        "sdPlus3": 21.9
    },
    {
        "length": 106.0,
        "sdMinus3": 13.3,
        "sdMinus2": 14.4,
        "sdMinus1": 15.6,
        "median": 16.9,
        "sdPlus1": 18.5,
        "sdPlus2": 20.2,
        "sdPlus3": 22.1
    },
    {
        "length": 106.5,
        "sdMinus3": 13.4,
        "sdMinus2": 14.5,
        "sdMinus1": 15.7,
        "median": 17.1,
        "sdPlus1": 18.6,
        "sdPlus2": 20.4,
        "sdPlus3": 22.4
    },
    {
        "length": 107.0,
        "sdMinus3": 13.5,
        "sdMinus2": 14.6,
        "sdMinus1": 15.9,
        "median": 17.3,
        "sdPlus1": 18.8,
        "sdPlus2": 20.6,
        "sdPlus3": 22.6
    },
    {
        "length": 107.5,
        "sdMinus3": 13.6,
        "sdMinus2": 14.7,
        "sdMinus1": 16.0,
        "median": 17.4,
        "sdPlus1": 19.0,
        "sdPlus2": 20.8,
        "sdPlus3": 22.8
    },
    {
        "length": 108.0,
        "sdMinus3": 13.7,
        "sdMinus2": 14.9,
        "sdMinus1": 16.2,
        "median": 17.6,
        "sdPlus1": 19.2,
        "sdPlus2": 21.0,
        "sdPlus3": 23.1
    },
    {
        "length": 108.5,
        "sdMinus3": 13.8,
        "sdMinus2": 15.0,
        "sdMinus1": 16.3,
        "median": 17.8,
        "sdPlus1": 19.4,
        "sdPlus2": 21.2,
        "sdPlus3": 23.3
    },
    {
        "length": 109.0,
        "sdMinus3": 14.0,
        "sdMinus2": 15.1,
        "sdMinus1": 16.5,
        "median": 17.9,
        "sdPlus1": 19.6,
        "sdPlus2": 21.4,
        "sdPlus3": 23.6
    },
    {
        "length": 109.5,
        "sdMinus3": 14.1,
        "sdMinus2": 15.3,
        "sdMinus1": 16.6,
        "median": 18.1,
        "sdPlus1": 19.8,
        "sdPlus2": 21.7,
        "sdPlus3": 23.8
    },
    {
        "length": 110.0,
        "sdMinus3": 14.2,
        "sdMinus2": 15.4,
        "sdMinus1": 16.8,
        "median": 18.3,
        "sdPlus1": 20.0,
        "sdPlus2": 21.9,
        "sdPlus3": 24.1
    }
];

export const WHO_HEIGHT_GIRLS_24_60 = [
    {
        "month": 24,
        "sdMinus3": 76.0,
        "sdMinus2": 79.3,
        "sdMinus1": 82.5,
        "median": 85.7,
        "sdPlus1": 88.9,
        "sdPlus2": 92.2,
        "sdPlus3": 95.4
    },
    {
        "month": 25,
        "sdMinus3": 76.8,
        "sdMinus2": 80.0,
        "sdMinus1": 83.3,
        "median": 86.6,
        "sdPlus1": 89.9,
        "sdPlus2": 93.1,
        "sdPlus3": 96.4
    },
    {
        "month": 26,
        "sdMinus3": 77.5,
        "sdMinus2": 80.8,
        "sdMinus1": 84.1,
        "median": 87.4,
        "sdPlus1": 90.8,
        "sdPlus2": 94.1,
        "sdPlus3": 97.4
    },
    {
        "month": 27,
        "sdMinus3": 78.1,
        "sdMinus2": 81.5,
        "sdMinus1": 84.9,
        "median": 88.3,
        "sdPlus1": 91.7,
        "sdPlus2": 95.0,
        "sdPlus3": 98.4
    },
    {
        "month": 28,
        "sdMinus3": 78.8,
        "sdMinus2": 82.2,
        "sdMinus1": 85.7,
        "median": 89.1,
        "sdPlus1": 92.5,
        "sdPlus2": 96.0,
        "sdPlus3": 99.4
    },
    {
        "month": 29,
        "sdMinus3": 79.5,
        "sdMinus2": 82.9,
        "sdMinus1": 86.4,
        "median": 89.9,
        "sdPlus1": 93.4,
        "sdPlus2": 96.9,
        "sdPlus3": 100.3
    },
    {
        "month": 30,
        "sdMinus3": 80.1,
        "sdMinus2": 83.6,
        "sdMinus1": 87.1,
        "median": 90.7,
        "sdPlus1": 94.2,
        "sdPlus2": 97.7,
        "sdPlus3": 101.3
    },
    {
        "month": 31,
        "sdMinus3": 80.7,
        "sdMinus2": 84.3,
        "sdMinus1": 87.9,
        "median": 91.4,
        "sdPlus1": 95.0,
        "sdPlus2": 98.6,
        "sdPlus3": 102.2
    },
    {
        "month": 32,
        "sdMinus3": 81.3,
        "sdMinus2": 84.9,
        "sdMinus1": 88.6,
        "median": 92.2,
        "sdPlus1": 95.8,
        "sdPlus2": 99.4,
        "sdPlus3": 103.1
    },
    {
        "month": 33,
        "sdMinus3": 81.9,
        "sdMinus2": 85.6,
        "sdMinus1": 89.3,
        "median": 92.9,
        "sdPlus1": 96.6,
        "sdPlus2": 100.3,
        "sdPlus3": 103.9
    },
    {
        "month": 34,
        "sdMinus3": 82.5,
        "sdMinus2": 86.2,
        "sdMinus1": 89.9,
        "median": 93.6,
        "sdPlus1": 97.4,
        "sdPlus2": 101.1,
        "sdPlus3": 104.8
    },
    {
        "month": 35,
        "sdMinus3": 83.1,
        "sdMinus2": 86.8,
        "sdMinus1": 90.6,
        "median": 94.4,
        "sdPlus1": 98.1,
        "sdPlus2": 101.9,
        "sdPlus3": 105.6
    },
    {
        "month": 36,
        "sdMinus3": 83.6,
        "sdMinus2": 87.4,
        "sdMinus1": 91.2,
        "median": 95.1,
        "sdPlus1": 98.9,
        "sdPlus2": 102.7,
        "sdPlus3": 106.5
    },
    {
        "month": 37,
        "sdMinus3": 84.2,
        "sdMinus2": 88.0,
        "sdMinus1": 91.9,
        "median": 95.7,
        "sdPlus1": 99.6,
        "sdPlus2": 103.4,
        "sdPlus3": 107.3
    },
    {
        "month": 38,
        "sdMinus3": 84.7,
        "sdMinus2": 88.6,
        "sdMinus1": 92.5,
        "median": 96.4,
        "sdPlus1": 100.3,
        "sdPlus2": 104.2,
        "sdPlus3": 108.1
    },
    {
        "month": 39,
        "sdMinus3": 85.3,
        "sdMinus2": 89.2,
        "sdMinus1": 93.1,
        "median": 97.1,
        "sdPlus1": 101.0,
        "sdPlus2": 105.0,
        "sdPlus3": 108.9
    },
    {
        "month": 40,
        "sdMinus3": 85.8,
        "sdMinus2": 89.8,
        "sdMinus1": 93.8,
        "median": 97.7,
        "sdPlus1": 101.7,
        "sdPlus2": 105.7,
        "sdPlus3": 109.7
    },
    {
        "month": 41,
        "sdMinus3": 86.3,
        "sdMinus2": 90.4,
        "sdMinus1": 94.4,
        "median": 98.4,
        "sdPlus1": 102.4,
        "sdPlus2": 106.4,
        "sdPlus3": 110.5
    },
    {
        "month": 42,
        "sdMinus3": 86.8,
        "sdMinus2": 90.9,
        "sdMinus1": 95.0,
        "median": 99.0,
        "sdPlus1": 103.1,
        "sdPlus2": 107.2,
        "sdPlus3": 111.2
    },
    {
        "month": 43,
        "sdMinus3": 87.4,
        "sdMinus2": 91.5,
        "sdMinus1": 95.6,
        "median": 99.7,
        "sdPlus1": 103.8,
        "sdPlus2": 107.9,
        "sdPlus3": 112.0
    },
    {
        "month": 44,
        "sdMinus3": 87.9,
        "sdMinus2": 92.0,
        "sdMinus1": 96.2,
        "median": 100.3,
        "sdPlus1": 104.5,
        "sdPlus2": 108.6,
        "sdPlus3": 112.7
    },
    {
        "month": 45,
        "sdMinus3": 88.4,
        "sdMinus2": 92.5,
        "sdMinus1": 96.7,
        "median": 100.9,
        "sdPlus1": 105.1,
        "sdPlus2": 109.3,
        "sdPlus3": 113.5
    },
    {
        "month": 46,
        "sdMinus3": 88.9,
        "sdMinus2": 93.1,
        "sdMinus1": 97.3,
        "median": 101.5,
        "sdPlus1": 105.8,
        "sdPlus2": 110.0,
        "sdPlus3": 114.2
    },
    {
        "month": 47,
        "sdMinus3": 89.3,
        "sdMinus2": 93.6,
        "sdMinus1": 97.9,
        "median": 102.1,
        "sdPlus1": 106.4,
        "sdPlus2": 110.7,
        "sdPlus3": 114.9
    },
    {
        "month": 48,
        "sdMinus3": 89.8,
        "sdMinus2": 94.1,
        "sdMinus1": 98.4,
        "median": 102.7,
        "sdPlus1": 107.0,
        "sdPlus2": 111.3,
        "sdPlus3": 115.7
    },
    {
        "month": 49,
        "sdMinus3": 90.3,
        "sdMinus2": 94.6,
        "sdMinus1": 99.0,
        "median": 103.3,
        "sdPlus1": 107.7,
        "sdPlus2": 112.0,
        "sdPlus3": 116.4
    },
    {
        "month": 50,
        "sdMinus3": 90.7,
        "sdMinus2": 95.1,
        "sdMinus1": 99.5,
        "median": 103.9,
        "sdPlus1": 108.3,
        "sdPlus2": 112.7,
        "sdPlus3": 117.1
    },
    {
        "month": 51,
        "sdMinus3": 91.2,
        "sdMinus2": 95.6,
        "sdMinus1": 100.1,
        "median": 104.5,
        "sdPlus1": 108.9,
        "sdPlus2": 113.3,
        "sdPlus3": 117.7
    },
    {
        "month": 52,
        "sdMinus3": 91.7,
        "sdMinus2": 96.1,
        "sdMinus1": 100.6,
        "median": 105.0,
        "sdPlus1": 109.5,
        "sdPlus2": 114.0,
        "sdPlus3": 118.4
    },
    {
        "month": 53,
        "sdMinus3": 92.1,
        "sdMinus2": 96.6,
        "sdMinus1": 101.1,
        "median": 105.6,
        "sdPlus1": 110.1,
        "sdPlus2": 114.6,
        "sdPlus3": 119.1
    },
    {
        "month": 54,
        "sdMinus3": 92.6,
        "sdMinus2": 97.1,
        "sdMinus1": 101.6,
        "median": 106.2,
        "sdPlus1": 110.7,
        "sdPlus2": 115.2,
        "sdPlus3": 119.8
    },
    {
        "month": 55,
        "sdMinus3": 93.0,
        "sdMinus2": 97.6,
        "sdMinus1": 102.2,
        "median": 106.7,
        "sdPlus1": 111.3,
        "sdPlus2": 115.9,
        "sdPlus3": 120.4
    },
    {
        "month": 56,
        "sdMinus3": 93.4,
        "sdMinus2": 98.1,
        "sdMinus1": 102.7,
        "median": 107.3,
        "sdPlus1": 111.9,
        "sdPlus2": 116.5,
        "sdPlus3": 121.1
    },
    {
        "month": 57,
        "sdMinus3": 93.9,
        "sdMinus2": 98.5,
        "sdMinus1": 103.2,
        "median": 107.8,
        "sdPlus1": 112.5,
        "sdPlus2": 117.1,
        "sdPlus3": 121.8
    },
    {
        "month": 58,
        "sdMinus3": 94.3,
        "sdMinus2": 99.0,
        "sdMinus1": 103.7,
        "median": 108.4,
        "sdPlus1": 113.0,
        "sdPlus2": 117.7,
        "sdPlus3": 122.4
    },
    {
        "month": 59,
        "sdMinus3": 94.7,
        "sdMinus2": 99.5,
        "sdMinus1": 104.2,
        "median": 108.9,
        "sdPlus1": 113.6,
        "sdPlus2": 118.3,
        "sdPlus3": 123.1
    },
    {
        "month": 60,
        "sdMinus3": 95.2,
        "sdMinus2": 99.9,
        "sdMinus1": 104.7,
        "median": 109.4,
        "sdPlus1": 114.2,
        "sdPlus2": 118.9,
        "sdPlus3": 123.7
    }
];

export const WHO_HEIGHT_BOYS_24_60 = [
    {
        "month": 24,
        "sdMinus3": 78.0,
        "sdMinus2": 81.0,
        "sdMinus1": 84.1,
        "median": 87.1,
        "sdPlus1": 90.2,
        "sdPlus2": 93.2,
        "sdPlus3": 96.3
    },
    {
        "month": 25,
        "sdMinus3": 78.6,
        "sdMinus2": 81.7,
        "sdMinus1": 84.9,
        "median": 88.0,
        "sdPlus1": 91.1,
        "sdPlus2": 94.2,
        "sdPlus3": 97.3
    },
    {
        "month": 26,
        "sdMinus3": 79.3,
        "sdMinus2": 82.5,
        "sdMinus1": 85.6,
        "median": 88.8,
        "sdPlus1": 92.0,
        "sdPlus2": 95.2,
        "sdPlus3": 98.3
    },
    {
        "month": 27,
        "sdMinus3": 79.9,
        "sdMinus2": 83.1,
        "sdMinus1": 86.4,
        "median": 89.6,
        "sdPlus1": 92.9,
        "sdPlus2": 96.1,
        "sdPlus3": 99.3
    },
    {
        "month": 28,
        "sdMinus3": 80.5,
        "sdMinus2": 83.8,
        "sdMinus1": 87.1,
        "median": 90.4,
        "sdPlus1": 93.7,
        "sdPlus2": 97.0,
        "sdPlus3": 100.3
    },
    {
        "month": 29,
        "sdMinus3": 81.1,
        "sdMinus2": 84.5,
        "sdMinus1": 87.8,
        "median": 91.2,
        "sdPlus1": 94.5,
        "sdPlus2": 97.9,
        "sdPlus3": 101.2
    },
    {
        "month": 30,
        "sdMinus3": 81.7,
        "sdMinus2": 85.1,
        "sdMinus1": 88.5,
        "median": 91.9,
        "sdPlus1": 95.3,
        "sdPlus2": 98.7,
        "sdPlus3": 102.1
    },
    {
        "month": 31,
        "sdMinus3": 82.3,
        "sdMinus2": 85.7,
        "sdMinus1": 89.2,
        "median": 92.7,
        "sdPlus1": 96.1,
        "sdPlus2": 99.6,
        "sdPlus3": 103.0
    },
    {
        "month": 32,
        "sdMinus3": 82.8,
        "sdMinus2": 86.4,
        "sdMinus1": 89.9,
        "median": 93.4,
        "sdPlus1": 96.9,
        "sdPlus2": 100.4,
        "sdPlus3": 103.9
    },
    {
        "month": 33,
        "sdMinus3": 83.4,
        "sdMinus2": 86.9,
        "sdMinus1": 90.5,
        "median": 94.1,
        "sdPlus1": 97.6,
        "sdPlus2": 101.2,
        "sdPlus3": 104.8
    },
    {
        "month": 34,
        "sdMinus3": 83.9,
        "sdMinus2": 87.5,
        "sdMinus1": 91.1,
        "median": 94.8,
        "sdPlus1": 98.4,
        "sdPlus2": 102.0,
        "sdPlus3": 105.6
    },
    {
        "month": 35,
        "sdMinus3": 84.4,
        "sdMinus2": 88.1,
        "sdMinus1": 91.8,
        "median": 95.4,
        "sdPlus1": 99.1,
        "sdPlus2": 102.7,
        "sdPlus3": 106.4
    },
    {
        "month": 36,
        "sdMinus3": 85.0,
        "sdMinus2": 88.7,
        "sdMinus1": 92.4,
        "median": 96.1,
        "sdPlus1": 99.8,
        "sdPlus2": 103.5,
        "sdPlus3": 107.2
    },
    {
        "month": 37,
        "sdMinus3": 85.5,
        "sdMinus2": 89.2,
        "sdMinus1": 93.0,
        "median": 96.7,
        "sdPlus1": 100.5,
        "sdPlus2": 104.2,
        "sdPlus3": 108.0
    },
    {
        "month": 38,
        "sdMinus3": 86.0,
        "sdMinus2": 89.8,
        "sdMinus1": 93.6,
        "median": 97.4,
        "sdPlus1": 101.2,
        "sdPlus2": 105.0,
        "sdPlus3": 108.8
    },
    {
        "month": 39,
        "sdMinus3": 86.5,
        "sdMinus2": 90.3,
        "sdMinus1": 94.2,
        "median": 98.0,
        "sdPlus1": 101.8,
        "sdPlus2": 105.7,
        "sdPlus3": 109.5
    },
    {
        "month": 40,
        "sdMinus3": 87.0,
        "sdMinus2": 90.9,
        "sdMinus1": 94.7,
        "median": 98.6,
        "sdPlus1": 102.5,
        "sdPlus2": 106.4,
        "sdPlus3": 110.3
    },
    {
        "month": 41,
        "sdMinus3": 87.5,
        "sdMinus2": 91.4,
        "sdMinus1": 95.3,
        "median": 99.2,
        "sdPlus1": 103.2,
        "sdPlus2": 107.1,
        "sdPlus3": 111.0
    },
    {
        "month": 42,
        "sdMinus3": 88.0,
        "sdMinus2": 91.9,
        "sdMinus1": 95.9,
        "median": 99.9,
        "sdPlus1": 103.8,
        "sdPlus2": 107.8,
        "sdPlus3": 111.7
    },
    {
        "month": 43,
        "sdMinus3": 88.4,
        "sdMinus2": 92.4,
        "sdMinus1": 96.4,
        "median": 100.4,
        "sdPlus1": 104.5,
        "sdPlus2": 108.5,
        "sdPlus3": 112.5
    },
    {
        "month": 44,
        "sdMinus3": 88.9,
        "sdMinus2": 93.0,
        "sdMinus1": 97.0,
        "median": 101.0,
        "sdPlus1": 105.1,
        "sdPlus2": 109.1,
        "sdPlus3": 113.2
    },
    {
        "month": 45,
        "sdMinus3": 89.4,
        "sdMinus2": 93.5,
        "sdMinus1": 97.5,
        "median": 101.6,
        "sdPlus1": 105.7,
        "sdPlus2": 109.8,
        "sdPlus3": 113.9
    },
    {
        "month": 46,
        "sdMinus3": 89.8,
        "sdMinus2": 94.0,
        "sdMinus1": 98.1,
        "median": 102.2,
        "sdPlus1": 106.3,
        "sdPlus2": 110.4,
        "sdPlus3": 114.6
    },
    {
        "month": 47,
        "sdMinus3": 90.3,
        "sdMinus2": 94.4,
        "sdMinus1": 98.6,
        "median": 102.8,
        "sdPlus1": 106.9,
        "sdPlus2": 111.1,
        "sdPlus3": 115.2
    },
    {
        "month": 48,
        "sdMinus3": 90.7,
        "sdMinus2": 94.9,
        "sdMinus1": 99.1,
        "median": 103.3,
        "sdPlus1": 107.5,
        "sdPlus2": 111.7,
        "sdPlus3": 115.9
    },
    {
        "month": 49,
        "sdMinus3": 91.2,
        "sdMinus2": 95.4,
        "sdMinus1": 99.7,
        "median": 103.9,
        "sdPlus1": 108.1,
        "sdPlus2": 112.4,
        "sdPlus3": 116.6
    },
    {
        "month": 50,
        "sdMinus3": 91.6,
        "sdMinus2": 95.9,
        "sdMinus1": 100.2,
        "median": 104.4,
        "sdPlus1": 108.7,
        "sdPlus2": 113.0,
        "sdPlus3": 117.3
    },
    {
        "month": 51,
        "sdMinus3": 92.1,
        "sdMinus2": 96.4,
        "sdMinus1": 100.7,
        "median": 105.0,
        "sdPlus1": 109.3,
        "sdPlus2": 113.6,
        "sdPlus3": 117.9
    },
    {
        "month": 52,
        "sdMinus3": 92.5,
        "sdMinus2": 96.9,
        "sdMinus1": 101.2,
        "median": 105.6,
        "sdPlus1": 109.9,
        "sdPlus2": 114.2,
        "sdPlus3": 118.6
    },
    {
        "month": 53,
        "sdMinus3": 93.0,
        "sdMinus2": 97.4,
        "sdMinus1": 101.7,
        "median": 106.1,
        "sdPlus1": 110.5,
        "sdPlus2": 114.9,
        "sdPlus3": 119.2
    },
    {
        "month": 54,
        "sdMinus3": 93.4,
        "sdMinus2": 97.8,
        "sdMinus1": 102.3,
        "median": 106.7,
        "sdPlus1": 111.1,
        "sdPlus2": 115.5,
        "sdPlus3": 119.9
    },
    {
        "month": 55,
        "sdMinus3": 93.9,
        "sdMinus2": 98.3,
        "sdMinus1": 102.8,
        "median": 107.2,
        "sdPlus1": 111.7,
        "sdPlus2": 116.1,
        "sdPlus3": 120.6
    },
    {
        "month": 56,
        "sdMinus3": 94.3,
        "sdMinus2": 98.8,
        "sdMinus1": 103.3,
        "median": 107.8,
        "sdPlus1": 112.3,
        "sdPlus2": 116.7,
        "sdPlus3": 121.2
    },
    {
        "month": 57,
        "sdMinus3": 94.7,
        "sdMinus2": 99.3,
        "sdMinus1": 103.8,
        "median": 108.3,
        "sdPlus1": 112.8,
        "sdPlus2": 117.4,
        "sdPlus3": 121.9
    },
    {
        "month": 58,
        "sdMinus3": 95.2,
        "sdMinus2": 99.7,
        "sdMinus1": 104.3,
        "median": 108.9,
        "sdPlus1": 113.4,
        "sdPlus2": 118.0,
        "sdPlus3": 122.6
    },
    {
        "month": 59,
        "sdMinus3": 95.6,
        "sdMinus2": 100.2,
        "sdMinus1": 104.8,
        "median": 109.4,
        "sdPlus1": 114.0,
        "sdPlus2": 118.6,
        "sdPlus3": 123.2
    },
    {
        "month": 60,
        "sdMinus3": 96.1,
        "sdMinus2": 100.7,
        "sdMinus1": 105.3,
        "median": 110.0,
        "sdPlus1": 114.6,
        "sdPlus2": 119.2,
        "sdPlus3": 123.9
    }
];

export const WHO_HEIGHT_GIRLS_5_11 = [
    {
        "month": 60,
        "sdMinus3": 95.2,
        "sdMinus2": 99.9,
        "sdMinus1": 104.7,
        "median": 109.4,
        "sdPlus1": 114.2,
        "sdPlus2": 118.9,
        "sdPlus3": 123.7
    },
    {
        "month": 61,
        "sdMinus3": 95.28,
        "sdMinus2": 100.06,
        "sdMinus1": 104.83,
        "median": 109.6,
        "sdPlus1": 114.37,
        "sdPlus2": 119.15,
        "sdPlus3": 123.92
    },
    {
        "month": 62,
        "sdMinus3": 95.71,
        "sdMinus2": 100.51,
        "sdMinus1": 105.32,
        "median": 110.13,
        "sdPlus1": 114.93,
        "sdPlus2": 119.74,
        "sdPlus3": 124.54
    },
    {
        "month": 63,
        "sdMinus3": 96.13,
        "sdMinus2": 100.97,
        "sdMinus1": 105.81,
        "median": 110.65,
        "sdPlus1": 115.48,
        "sdPlus2": 120.32,
        "sdPlus3": 125.16
    },
    {
        "month": 64,
        "sdMinus3": 96.55,
        "sdMinus2": 101.42,
        "sdMinus1": 106.29,
        "median": 111.16,
        "sdPlus1": 116.03,
        "sdPlus2": 120.9,
        "sdPlus3": 125.77
    },
    {
        "month": 65,
        "sdMinus3": 96.96,
        "sdMinus2": 101.87,
        "sdMinus1": 106.77,
        "median": 111.67,
        "sdPlus1": 116.57,
        "sdPlus2": 121.47,
        "sdPlus3": 126.38
    },
    {
        "month": 66,
        "sdMinus3": 97.37,
        "sdMinus2": 102.31,
        "sdMinus1": 107.24,
        "median": 112.18,
        "sdPlus1": 117.11,
        "sdPlus2": 122.04,
        "sdPlus3": 126.98
    },
    {
        "month": 67,
        "sdMinus3": 97.78,
        "sdMinus2": 102.75,
        "sdMinus1": 107.71,
        "median": 112.68,
        "sdPlus1": 117.64,
        "sdPlus2": 122.61,
        "sdPlus3": 127.57
    },
    {
        "month": 68,
        "sdMinus3": 98.18,
        "sdMinus2": 103.18,
        "sdMinus1": 108.18,
        "median": 113.17,
        "sdPlus1": 118.17,
        "sdPlus2": 123.17,
        "sdPlus3": 128.16
    },
    {
        "month": 69,
        "sdMinus3": 98.58,
        "sdMinus2": 103.61,
        "sdMinus1": 108.64,
        "median": 113.67,
        "sdPlus1": 118.69,
        "sdPlus2": 123.72,
        "sdPlus3": 128.75
    },
    {
        "month": 70,
        "sdMinus3": 98.98,
        "sdMinus2": 104.04,
        "sdMinus1": 109.1,
        "median": 114.16,
        "sdPlus1": 119.21,
        "sdPlus2": 124.27,
        "sdPlus3": 129.33
    },
    {
        "month": 71,
        "sdMinus3": 99.38,
        "sdMinus2": 104.46,
        "sdMinus1": 109.55,
        "median": 114.64,
        "sdPlus1": 119.73,
        "sdPlus2": 124.82,
        "sdPlus3": 129.91
    },
    {
        "month": 72,
        "sdMinus3": 99.77,
        "sdMinus2": 104.89,
        "sdMinus1": 110.0,
        "median": 115.12,
        "sdPlus1": 120.24,
        "sdPlus2": 125.36,
        "sdPlus3": 130.48
    },
    {
        "month": 73,
        "sdMinus3": 100.16,
        "sdMinus2": 105.31,
        "sdMinus1": 110.45,
        "median": 115.6,
        "sdPlus1": 120.75,
        "sdPlus2": 125.9,
        "sdPlus3": 131.05
    },
    {
        "month": 74,
        "sdMinus3": 100.55,
        "sdMinus2": 105.72,
        "sdMinus1": 110.9,
        "median": 116.08,
        "sdPlus1": 121.26,
        "sdPlus2": 126.44,
        "sdPlus3": 131.62
    },
    {
        "month": 75,
        "sdMinus3": 100.93,
        "sdMinus2": 106.14,
        "sdMinus1": 111.35,
        "median": 116.56,
        "sdPlus1": 121.77,
        "sdPlus2": 126.97,
        "sdPlus3": 132.18
    },
    {
        "month": 76,
        "sdMinus3": 101.32,
        "sdMinus2": 106.56,
        "sdMinus1": 111.79,
        "median": 117.03,
        "sdPlus1": 122.27,
        "sdPlus2": 127.51,
        "sdPlus3": 132.74
    },
    {
        "month": 77,
        "sdMinus3": 101.7,
        "sdMinus2": 106.97,
        "sdMinus1": 112.24,
        "median": 117.5,
        "sdPlus1": 122.77,
        "sdPlus2": 128.04,
        "sdPlus3": 133.3
    },
    {
        "month": 78,
        "sdMinus3": 102.09,
        "sdMinus2": 107.38,
        "sdMinus1": 112.68,
        "median": 117.98,
        "sdPlus1": 123.27,
        "sdPlus2": 128.57,
        "sdPlus3": 133.86
    },
    {
        "month": 79,
        "sdMinus3": 102.48,
        "sdMinus2": 107.8,
        "sdMinus1": 113.12,
        "median": 118.45,
        "sdPlus1": 123.77,
        "sdPlus2": 129.1,
        "sdPlus3": 134.42
    },
    {
        "month": 80,
        "sdMinus3": 102.86,
        "sdMinus2": 108.21,
        "sdMinus1": 113.57,
        "median": 118.92,
        "sdPlus1": 124.27,
        "sdPlus2": 129.63,
        "sdPlus3": 134.98
    },
    {
        "month": 81,
        "sdMinus3": 103.25,
        "sdMinus2": 108.63,
        "sdMinus1": 114.01,
        "median": 119.39,
        "sdPlus1": 124.77,
        "sdPlus2": 130.16,
        "sdPlus3": 135.54
    },
    {
        "month": 82,
        "sdMinus3": 103.63,
        "sdMinus2": 109.04,
        "sdMinus1": 114.45,
        "median": 119.86,
        "sdPlus1": 125.28,
        "sdPlus2": 130.69,
        "sdPlus3": 136.1
    },
    {
        "month": 83,
        "sdMinus3": 104.02,
        "sdMinus2": 109.46,
        "sdMinus1": 114.9,
        "median": 120.34,
        "sdPlus1": 125.78,
        "sdPlus2": 131.22,
        "sdPlus3": 136.66
    },
    {
        "month": 84,
        "sdMinus3": 104.41,
        "sdMinus2": 109.88,
        "sdMinus1": 115.34,
        "median": 120.81,
        "sdPlus1": 126.28,
        "sdPlus2": 131.74,
        "sdPlus3": 137.21
    },
    {
        "month": 85,
        "sdMinus3": 104.8,
        "sdMinus2": 110.29,
        "sdMinus1": 115.79,
        "median": 121.28,
        "sdPlus1": 126.78,
        "sdPlus2": 132.28,
        "sdPlus3": 137.77
    },
    {
        "month": 86,
        "sdMinus3": 105.19,
        "sdMinus2": 110.71,
        "sdMinus1": 116.24,
        "median": 121.76,
        "sdPlus1": 127.28,
        "sdPlus2": 132.8,
        "sdPlus3": 138.33
    },
    {
        "month": 87,
        "sdMinus3": 105.58,
        "sdMinus2": 111.13,
        "sdMinus1": 116.68,
        "median": 122.23,
        "sdPlus1": 127.79,
        "sdPlus2": 133.34,
        "sdPlus3": 138.89
    },
    {
        "month": 88,
        "sdMinus3": 105.97,
        "sdMinus2": 111.55,
        "sdMinus1": 117.13,
        "median": 122.71,
        "sdPlus1": 128.29,
        "sdPlus2": 133.87,
        "sdPlus3": 139.45
    },
    {
        "month": 89,
        "sdMinus3": 106.37,
        "sdMinus2": 111.97,
        "sdMinus1": 117.58,
        "median": 123.19,
        "sdPlus1": 128.79,
        "sdPlus2": 134.4,
        "sdPlus3": 140.01
    },
    {
        "month": 90,
        "sdMinus3": 106.76,
        "sdMinus2": 112.4,
        "sdMinus1": 118.03,
        "median": 123.66,
        "sdPlus1": 129.3,
        "sdPlus2": 134.93,
        "sdPlus3": 140.57
    },
    {
        "month": 91,
        "sdMinus3": 107.16,
        "sdMinus2": 112.82,
        "sdMinus1": 118.48,
        "median": 124.14,
        "sdPlus1": 129.81,
        "sdPlus2": 135.47,
        "sdPlus3": 141.13
    },
    {
        "month": 92,
        "sdMinus3": 107.56,
        "sdMinus2": 113.25,
        "sdMinus1": 118.93,
        "median": 124.62,
        "sdPlus1": 130.31,
        "sdPlus2": 136.0,
        "sdPlus3": 141.69
    },
    {
        "month": 93,
        "sdMinus3": 107.96,
        "sdMinus2": 113.67,
        "sdMinus1": 119.39,
        "median": 125.1,
        "sdPlus1": 130.82,
        "sdPlus2": 136.54,
        "sdPlus3": 142.25
    },
    {
        "month": 94,
        "sdMinus3": 108.36,
        "sdMinus2": 114.1,
        "sdMinus1": 119.84,
        "median": 125.59,
        "sdPlus1": 131.33,
        "sdPlus2": 137.07,
        "sdPlus3": 142.82
    },
    {
        "month": 95,
        "sdMinus3": 108.76,
        "sdMinus2": 114.53,
        "sdMinus1": 120.3,
        "median": 126.07,
        "sdPlus1": 131.84,
        "sdPlus2": 137.61,
        "sdPlus3": 143.38
    },
    {
        "month": 96,
        "sdMinus3": 109.16,
        "sdMinus2": 114.96,
        "sdMinus1": 120.76,
        "median": 126.56,
        "sdPlus1": 132.35,
        "sdPlus2": 138.15,
        "sdPlus3": 143.95
    },
    {
        "month": 97,
        "sdMinus3": 109.57,
        "sdMinus2": 115.39,
        "sdMinus1": 121.22,
        "median": 127.04,
        "sdPlus1": 132.87,
        "sdPlus2": 138.69,
        "sdPlus3": 144.52
    },
    {
        "month": 98,
        "sdMinus3": 109.98,
        "sdMinus2": 115.83,
        "sdMinus1": 121.68,
        "median": 127.53,
        "sdPlus1": 133.38,
        "sdPlus2": 139.23,
        "sdPlus3": 145.08
    },
    {
        "month": 99,
        "sdMinus3": 110.39,
        "sdMinus2": 116.27,
        "sdMinus1": 122.14,
        "median": 128.02,
        "sdPlus1": 133.9,
        "sdPlus2": 139.77,
        "sdPlus3": 145.65
    },
    {
        "month": 100,
        "sdMinus3": 110.8,
        "sdMinus2": 116.7,
        "sdMinus1": 122.61,
        "median": 128.51,
        "sdPlus1": 134.41,
        "sdPlus2": 140.32,
        "sdPlus3": 146.22
    },
    {
        "month": 101,
        "sdMinus3": 111.21,
        "sdMinus2": 117.14,
        "sdMinus1": 123.07,
        "median": 129.0,
        "sdPlus1": 134.93,
        "sdPlus2": 140.86,
        "sdPlus3": 146.79
    },
    {
        "month": 102,
        "sdMinus3": 111.63,
        "sdMinus2": 117.58,
        "sdMinus1": 123.54,
        "median": 129.5,
        "sdPlus1": 135.45,
        "sdPlus2": 141.41,
        "sdPlus3": 147.37
    },
    {
        "month": 103,
        "sdMinus3": 112.05,
        "sdMinus2": 118.03,
        "sdMinus1": 124.01,
        "median": 129.99,
        "sdPlus1": 135.98,
        "sdPlus2": 141.96,
        "sdPlus3": 147.94
    },
    {
        "month": 104,
        "sdMinus3": 112.47,
        "sdMinus2": 118.47,
        "sdMinus1": 124.48,
        "median": 130.49,
        "sdPlus1": 136.5,
        "sdPlus2": 142.51,
        "sdPlus3": 148.51
    },
    {
        "month": 105,
        "sdMinus3": 112.89,
        "sdMinus2": 118.92,
        "sdMinus1": 124.95,
        "median": 130.99,
        "sdPlus1": 137.02,
        "sdPlus2": 143.06,
        "sdPlus3": 149.09
    },
    {
        "month": 106,
        "sdMinus3": 113.31,
        "sdMinus2": 119.37,
        "sdMinus1": 125.43,
        "median": 131.49,
        "sdPlus1": 137.55,
        "sdPlus2": 143.61,
        "sdPlus3": 149.67
    },
    {
        "month": 107,
        "sdMinus3": 113.74,
        "sdMinus2": 119.82,
        "sdMinus1": 125.91,
        "median": 131.99,
        "sdPlus1": 138.08,
        "sdPlus2": 144.16,
        "sdPlus3": 150.25
    },
    {
        "month": 108,
        "sdMinus3": 114.16,
        "sdMinus2": 120.27,
        "sdMinus1": 126.38,
        "median": 132.49,
        "sdPlus1": 138.61,
        "sdPlus2": 144.72,
        "sdPlus3": 150.83
    },
    {
        "month": 109,
        "sdMinus3": 114.59,
        "sdMinus2": 120.73,
        "sdMinus1": 126.86,
        "median": 133.0,
        "sdPlus1": 139.13,
        "sdPlus2": 145.27,
        "sdPlus3": 151.4
    },
    {
        "month": 110,
        "sdMinus3": 115.02,
        "sdMinus2": 121.18,
        "sdMinus1": 127.34,
        "median": 133.5,
        "sdPlus1": 139.66,
        "sdPlus2": 145.82,
        "sdPlus3": 151.98
    },
    {
        "month": 111,
        "sdMinus3": 115.46,
        "sdMinus2": 121.64,
        "sdMinus1": 127.83,
        "median": 134.01,
        "sdPlus1": 140.2,
        "sdPlus2": 146.38,
        "sdPlus3": 152.57
    },
    {
        "month": 112,
        "sdMinus3": 115.89,
        "sdMinus2": 122.1,
        "sdMinus1": 128.31,
        "median": 134.52,
        "sdPlus1": 140.73,
        "sdPlus2": 146.94,
        "sdPlus3": 153.15
    },
    {
        "month": 113,
        "sdMinus3": 116.33,
        "sdMinus2": 122.56,
        "sdMinus1": 128.8,
        "median": 135.03,
        "sdPlus1": 141.26,
        "sdPlus2": 147.5,
        "sdPlus3": 153.73
    },
    {
        "month": 114,
        "sdMinus3": 116.77,
        "sdMinus2": 123.03,
        "sdMinus1": 129.28,
        "median": 135.54,
        "sdPlus1": 141.8,
        "sdPlus2": 148.06,
        "sdPlus3": 154.31
    },
    {
        "month": 115,
        "sdMinus3": 117.21,
        "sdMinus2": 123.49,
        "sdMinus1": 129.77,
        "median": 136.05,
        "sdPlus1": 142.33,
        "sdPlus2": 148.62,
        "sdPlus3": 154.9
    },
    {
        "month": 116,
        "sdMinus3": 117.66,
        "sdMinus2": 123.96,
        "sdMinus1": 130.26,
        "median": 136.57,
        "sdPlus1": 142.87,
        "sdPlus2": 149.17,
        "sdPlus3": 155.48
    },
    {
        "month": 117,
        "sdMinus3": 118.1,
        "sdMinus2": 124.43,
        "sdMinus1": 130.75,
        "median": 137.08,
        "sdPlus1": 143.41,
        "sdPlus2": 149.74,
        "sdPlus3": 156.07
    },
    {
        "month": 118,
        "sdMinus3": 118.54,
        "sdMinus2": 124.9,
        "sdMinus1": 131.25,
        "median": 137.6,
        "sdPlus1": 143.95,
        "sdPlus2": 150.3,
        "sdPlus3": 156.65
    },
    {
        "month": 119,
        "sdMinus3": 118.99,
        "sdMinus2": 125.37,
        "sdMinus1": 131.74,
        "median": 138.12,
        "sdPlus1": 144.49,
        "sdPlus2": 150.86,
        "sdPlus3": 157.24
    },
    {
        "month": 120,
        "sdMinus3": 119.45,
        "sdMinus2": 125.84,
        "sdMinus1": 132.24,
        "median": 138.64,
        "sdPlus1": 145.03,
        "sdPlus2": 151.43,
        "sdPlus3": 157.83
    },
    {
        "month": 121,
        "sdMinus3": 119.9,
        "sdMinus2": 126.32,
        "sdMinus1": 132.74,
        "median": 139.16,
        "sdPlus1": 145.58,
        "sdPlus2": 151.99,
        "sdPlus3": 158.41
    },
    {
        "month": 122,
        "sdMinus3": 120.36,
        "sdMinus2": 126.8,
        "sdMinus1": 133.24,
        "median": 139.68,
        "sdPlus1": 146.12,
        "sdPlus2": 152.56,
        "sdPlus3": 159.0
    },
    {
        "month": 123,
        "sdMinus3": 120.82,
        "sdMinus2": 127.28,
        "sdMinus1": 133.74,
        "median": 140.2,
        "sdPlus1": 146.67,
        "sdPlus2": 153.13,
        "sdPlus3": 159.59
    },
    {
        "month": 124,
        "sdMinus3": 121.28,
        "sdMinus2": 127.76,
        "sdMinus1": 134.25,
        "median": 140.73,
        "sdPlus1": 147.21,
        "sdPlus2": 153.7,
        "sdPlus3": 160.18
    },
    {
        "month": 125,
        "sdMinus3": 121.74,
        "sdMinus2": 128.25,
        "sdMinus1": 134.75,
        "median": 141.26,
        "sdPlus1": 147.76,
        "sdPlus2": 154.27,
        "sdPlus3": 160.77
    },
    {
        "month": 126,
        "sdMinus3": 122.21,
        "sdMinus2": 128.74,
        "sdMinus1": 135.26,
        "median": 141.79,
        "sdPlus1": 148.32,
        "sdPlus2": 154.84,
        "sdPlus3": 161.37
    },
    {
        "month": 127,
        "sdMinus3": 122.68,
        "sdMinus2": 129.23,
        "sdMinus1": 135.77,
        "median": 142.32,
        "sdPlus1": 148.87,
        "sdPlus2": 155.41,
        "sdPlus3": 161.96
    },
    {
        "month": 128,
        "sdMinus3": 123.15,
        "sdMinus2": 129.72,
        "sdMinus1": 136.29,
        "median": 142.85,
        "sdPlus1": 149.42,
        "sdPlus2": 155.99,
        "sdPlus3": 162.55
    },
    {
        "month": 129,
        "sdMinus3": 123.63,
        "sdMinus2": 130.21,
        "sdMinus1": 136.8,
        "median": 143.39,
        "sdPlus1": 149.97,
        "sdPlus2": 156.56,
        "sdPlus3": 163.15
    },
    {
        "month": 130,
        "sdMinus3": 124.1,
        "sdMinus2": 130.71,
        "sdMinus1": 137.31,
        "median": 143.92,
        "sdPlus1": 150.53,
        "sdPlus2": 157.14,
        "sdPlus3": 163.74
    },
    {
        "month": 131,
        "sdMinus3": 124.57,
        "sdMinus2": 131.2,
        "sdMinus1": 137.83,
        "median": 144.46,
        "sdPlus1": 151.09,
        "sdPlus2": 157.71,
        "sdPlus3": 164.34
    },
    {
        "month": 132,
        "sdMinus3": 125.05,
        "sdMinus2": 131.7,
        "sdMinus1": 138.35,
        "median": 144.99,
        "sdPlus1": 151.64,
        "sdPlus2": 158.29,
        "sdPlus3": 164.93
    }
];

export const WHO_HEIGHT_BOYS_5_11 = [
    {
        "month": 60,
        "sdMinus3": 96.1,
        "sdMinus2": 100.7,
        "sdMinus1": 105.3,
        "median": 110.0,
        "sdPlus1": 114.6,
        "sdPlus2": 119.2,
        "sdPlus3": 123.9
    },
    {
        "month": 61,
        "sdMinus3": 96.49,
        "sdMinus2": 101.08,
        "sdMinus1": 105.67,
        "median": 110.26,
        "sdPlus1": 114.86,
        "sdPlus2": 119.45,
        "sdPlus3": 124.04
    },
    {
        "month": 62,
        "sdMinus3": 96.93,
        "sdMinus2": 101.56,
        "sdMinus1": 106.18,
        "median": 110.8,
        "sdPlus1": 115.42,
        "sdPlus2": 120.05,
        "sdPlus3": 124.67
    },
    {
        "month": 63,
        "sdMinus3": 97.37,
        "sdMinus2": 102.03,
        "sdMinus1": 106.68,
        "median": 111.33,
        "sdPlus1": 115.99,
        "sdPlus2": 120.64,
        "sdPlus3": 125.3
    },
    {
        "month": 64,
        "sdMinus3": 97.81,
        "sdMinus2": 102.5,
        "sdMinus1": 107.18,
        "median": 111.86,
        "sdPlus1": 116.55,
        "sdPlus2": 121.23,
        "sdPlus3": 125.91
    },
    {
        "month": 65,
        "sdMinus3": 98.25,
        "sdMinus2": 102.96,
        "sdMinus1": 107.67,
        "median": 112.39,
        "sdPlus1": 117.1,
        "sdPlus2": 121.82,
        "sdPlus3": 126.53
    },
    {
        "month": 66,
        "sdMinus3": 98.67,
        "sdMinus2": 103.42,
        "sdMinus1": 108.17,
        "median": 112.91,
        "sdPlus1": 117.66,
        "sdPlus2": 122.4,
        "sdPlus3": 127.15
    },
    {
        "month": 67,
        "sdMinus3": 99.1,
        "sdMinus2": 103.88,
        "sdMinus1": 108.65,
        "median": 113.43,
        "sdPlus1": 118.2,
        "sdPlus2": 122.98,
        "sdPlus3": 127.76
    },
    {
        "month": 68,
        "sdMinus3": 99.52,
        "sdMinus2": 104.33,
        "sdMinus1": 109.13,
        "median": 113.94,
        "sdPlus1": 118.75,
        "sdPlus2": 123.55,
        "sdPlus3": 128.36
    },
    {
        "month": 69,
        "sdMinus3": 99.94,
        "sdMinus2": 104.78,
        "sdMinus1": 109.61,
        "median": 114.45,
        "sdPlus1": 119.29,
        "sdPlus2": 124.12,
        "sdPlus3": 128.96
    },
    {
        "month": 70,
        "sdMinus3": 100.35,
        "sdMinus2": 105.22,
        "sdMinus1": 110.09,
        "median": 114.95,
        "sdPlus1": 119.82,
        "sdPlus2": 124.69,
        "sdPlus3": 129.56
    },
    {
        "month": 71,
        "sdMinus3": 100.77,
        "sdMinus2": 105.66,
        "sdMinus1": 110.56,
        "median": 115.45,
        "sdPlus1": 120.35,
        "sdPlus2": 125.25,
        "sdPlus3": 130.14
    },
    {
        "month": 72,
        "sdMinus3": 101.17,
        "sdMinus2": 106.1,
        "sdMinus1": 111.02,
        "median": 115.95,
        "sdPlus1": 120.88,
        "sdPlus2": 125.8,
        "sdPlus3": 130.73
    },
    {
        "month": 73,
        "sdMinus3": 101.57,
        "sdMinus2": 106.53,
        "sdMinus1": 111.49,
        "median": 116.44,
        "sdPlus1": 121.4,
        "sdPlus2": 126.36,
        "sdPlus3": 131.31
    },
    {
        "month": 74,
        "sdMinus3": 101.97,
        "sdMinus2": 106.96,
        "sdMinus1": 111.95,
        "median": 116.93,
        "sdPlus1": 121.92,
        "sdPlus2": 126.9,
        "sdPlus3": 131.89
    },
    {
        "month": 75,
        "sdMinus3": 102.37,
        "sdMinus2": 107.39,
        "sdMinus1": 112.4,
        "median": 117.42,
        "sdPlus1": 122.44,
        "sdPlus2": 127.45,
        "sdPlus3": 132.47
    },
    {
        "month": 76,
        "sdMinus3": 102.77,
        "sdMinus2": 107.81,
        "sdMinus1": 112.86,
        "median": 117.9,
        "sdPlus1": 122.95,
        "sdPlus2": 128.0,
        "sdPlus3": 133.04
    },
    {
        "month": 77,
        "sdMinus3": 103.16,
        "sdMinus2": 108.24,
        "sdMinus1": 113.31,
        "median": 118.39,
        "sdPlus1": 123.46,
        "sdPlus2": 128.54,
        "sdPlus3": 133.61
    },
    {
        "month": 78,
        "sdMinus3": 103.55,
        "sdMinus2": 108.66,
        "sdMinus1": 113.76,
        "median": 118.87,
        "sdPlus1": 123.98,
        "sdPlus2": 129.08,
        "sdPlus3": 134.19
    },
    {
        "month": 79,
        "sdMinus3": 103.94,
        "sdMinus2": 109.08,
        "sdMinus1": 114.22,
        "median": 119.35,
        "sdPlus1": 124.49,
        "sdPlus2": 129.62,
        "sdPlus3": 134.76
    },
    {
        "month": 80,
        "sdMinus3": 104.33,
        "sdMinus2": 109.5,
        "sdMinus1": 114.66,
        "median": 119.83,
        "sdPlus1": 125.0,
        "sdPlus2": 130.16,
        "sdPlus3": 135.33
    },
    {
        "month": 81,
        "sdMinus3": 104.72,
        "sdMinus2": 109.92,
        "sdMinus1": 115.11,
        "median": 120.31,
        "sdPlus1": 125.5,
        "sdPlus2": 130.7,
        "sdPlus3": 135.89
    },
    {
        "month": 82,
        "sdMinus3": 105.11,
        "sdMinus2": 110.33,
        "sdMinus1": 115.56,
        "median": 120.79,
        "sdPlus1": 126.01,
        "sdPlus2": 131.24,
        "sdPlus3": 136.46
    },
    {
        "month": 83,
        "sdMinus3": 105.49,
        "sdMinus2": 110.75,
        "sdMinus1": 116.0,
        "median": 121.26,
        "sdPlus1": 126.52,
        "sdPlus2": 131.77,
        "sdPlus3": 137.03
    },
    {
        "month": 84,
        "sdMinus3": 105.88,
        "sdMinus2": 111.16,
        "sdMinus1": 116.45,
        "median": 121.73,
        "sdPlus1": 127.02,
        "sdPlus2": 132.31,
        "sdPlus3": 137.59
    },
    {
        "month": 85,
        "sdMinus3": 106.26,
        "sdMinus2": 111.57,
        "sdMinus1": 116.89,
        "median": 122.21,
        "sdPlus1": 127.52,
        "sdPlus2": 132.84,
        "sdPlus3": 138.15
    },
    {
        "month": 86,
        "sdMinus3": 106.64,
        "sdMinus2": 111.98,
        "sdMinus1": 117.33,
        "median": 122.67,
        "sdPlus1": 128.02,
        "sdPlus2": 133.37,
        "sdPlus3": 138.71
    },
    {
        "month": 87,
        "sdMinus3": 107.01,
        "sdMinus2": 112.39,
        "sdMinus1": 117.77,
        "median": 123.14,
        "sdPlus1": 128.52,
        "sdPlus2": 133.9,
        "sdPlus3": 139.27
    },
    {
        "month": 88,
        "sdMinus3": 107.39,
        "sdMinus2": 112.8,
        "sdMinus1": 118.2,
        "median": 123.61,
        "sdPlus1": 129.02,
        "sdPlus2": 134.42,
        "sdPlus3": 139.83
    },
    {
        "month": 89,
        "sdMinus3": 107.76,
        "sdMinus2": 113.2,
        "sdMinus1": 118.64,
        "median": 124.07,
        "sdPlus1": 129.51,
        "sdPlus2": 134.95,
        "sdPlus3": 140.38
    },
    {
        "month": 90,
        "sdMinus3": 108.13,
        "sdMinus2": 113.6,
        "sdMinus1": 119.07,
        "median": 124.54,
        "sdPlus1": 130.0,
        "sdPlus2": 135.47,
        "sdPlus3": 140.94
    },
    {
        "month": 91,
        "sdMinus3": 108.5,
        "sdMinus2": 114.0,
        "sdMinus1": 119.5,
        "median": 125.0,
        "sdPlus1": 130.49,
        "sdPlus2": 135.99,
        "sdPlus3": 141.49
    },
    {
        "month": 92,
        "sdMinus3": 108.87,
        "sdMinus2": 114.4,
        "sdMinus1": 119.93,
        "median": 125.45,
        "sdPlus1": 130.98,
        "sdPlus2": 136.51,
        "sdPlus3": 142.04
    },
    {
        "month": 93,
        "sdMinus3": 109.24,
        "sdMinus2": 114.8,
        "sdMinus1": 120.35,
        "median": 125.91,
        "sdPlus1": 131.47,
        "sdPlus2": 137.03,
        "sdPlus3": 142.58
    },
    {
        "month": 94,
        "sdMinus3": 109.6,
        "sdMinus2": 115.19,
        "sdMinus1": 120.78,
        "median": 126.36,
        "sdPlus1": 131.95,
        "sdPlus2": 137.54,
        "sdPlus3": 143.13
    },
    {
        "month": 95,
        "sdMinus3": 109.96,
        "sdMinus2": 115.58,
        "sdMinus1": 121.2,
        "median": 126.82,
        "sdPlus1": 132.43,
        "sdPlus2": 138.05,
        "sdPlus3": 143.67
    },
    {
        "month": 96,
        "sdMinus3": 110.32,
        "sdMinus2": 115.97,
        "sdMinus1": 121.62,
        "median": 127.27,
        "sdPlus1": 132.91,
        "sdPlus2": 138.56,
        "sdPlus3": 144.21
    },
    {
        "month": 97,
        "sdMinus3": 110.68,
        "sdMinus2": 116.36,
        "sdMinus1": 122.03,
        "median": 127.71,
        "sdPlus1": 133.39,
        "sdPlus2": 139.07,
        "sdPlus3": 144.75
    },
    {
        "month": 98,
        "sdMinus3": 111.03,
        "sdMinus2": 116.74,
        "sdMinus1": 122.45,
        "median": 128.16,
        "sdPlus1": 133.87,
        "sdPlus2": 139.58,
        "sdPlus3": 145.28
    },
    {
        "month": 99,
        "sdMinus3": 111.39,
        "sdMinus2": 117.13,
        "sdMinus1": 122.87,
        "median": 128.6,
        "sdPlus1": 134.34,
        "sdPlus2": 140.08,
        "sdPlus3": 145.82
    },
    {
        "month": 100,
        "sdMinus3": 111.74,
        "sdMinus2": 117.51,
        "sdMinus1": 123.28,
        "median": 129.05,
        "sdPlus1": 134.81,
        "sdPlus2": 140.58,
        "sdPlus3": 146.35
    },
    {
        "month": 101,
        "sdMinus3": 112.09,
        "sdMinus2": 117.89,
        "sdMinus1": 123.69,
        "median": 129.49,
        "sdPlus1": 135.29,
        "sdPlus2": 141.09,
        "sdPlus3": 146.88
    },
    {
        "month": 102,
        "sdMinus3": 112.44,
        "sdMinus2": 118.27,
        "sdMinus1": 124.1,
        "median": 129.93,
        "sdPlus1": 135.76,
        "sdPlus2": 141.59,
        "sdPlus3": 147.42
    },
    {
        "month": 103,
        "sdMinus3": 112.79,
        "sdMinus2": 118.65,
        "sdMinus1": 124.51,
        "median": 130.37,
        "sdPlus1": 136.23,
        "sdPlus2": 142.09,
        "sdPlus3": 147.95
    },
    {
        "month": 104,
        "sdMinus3": 113.14,
        "sdMinus2": 119.03,
        "sdMinus1": 124.92,
        "median": 130.81,
        "sdPlus1": 136.7,
        "sdPlus2": 142.59,
        "sdPlus3": 148.48
    },
    {
        "month": 105,
        "sdMinus3": 113.49,
        "sdMinus2": 119.41,
        "sdMinus1": 125.33,
        "median": 131.25,
        "sdPlus1": 137.17,
        "sdPlus2": 143.09,
        "sdPlus3": 149.01
    },
    {
        "month": 106,
        "sdMinus3": 113.84,
        "sdMinus2": 119.79,
        "sdMinus1": 125.74,
        "median": 131.69,
        "sdPlus1": 137.64,
        "sdPlus2": 143.59,
        "sdPlus3": 149.54
    },
    {
        "month": 107,
        "sdMinus3": 114.18,
        "sdMinus2": 120.16,
        "sdMinus1": 126.15,
        "median": 132.13,
        "sdPlus1": 138.11,
        "sdPlus2": 144.09,
        "sdPlus3": 150.07
    },
    {
        "month": 108,
        "sdMinus3": 114.53,
        "sdMinus2": 120.54,
        "sdMinus1": 126.55,
        "median": 132.57,
        "sdPlus1": 138.58,
        "sdPlus2": 144.59,
        "sdPlus3": 150.6
    },
    {
        "month": 109,
        "sdMinus3": 114.88,
        "sdMinus2": 120.92,
        "sdMinus1": 126.96,
        "median": 133.0,
        "sdPlus1": 139.05,
        "sdPlus2": 145.09,
        "sdPlus3": 151.13
    },
    {
        "month": 110,
        "sdMinus3": 115.22,
        "sdMinus2": 121.29,
        "sdMinus1": 127.37,
        "median": 133.44,
        "sdPlus1": 139.51,
        "sdPlus2": 145.59,
        "sdPlus3": 151.66
    },
    {
        "month": 111,
        "sdMinus3": 115.57,
        "sdMinus2": 121.67,
        "sdMinus1": 127.77,
        "median": 133.88,
        "sdPlus1": 139.98,
        "sdPlus2": 146.08,
        "sdPlus3": 152.19
    },
    {
        "month": 112,
        "sdMinus3": 115.91,
        "sdMinus2": 122.05,
        "sdMinus1": 128.18,
        "median": 134.31,
        "sdPlus1": 140.45,
        "sdPlus2": 146.58,
        "sdPlus3": 152.71
    },
    {
        "month": 113,
        "sdMinus3": 116.26,
        "sdMinus2": 122.42,
        "sdMinus1": 128.58,
        "median": 134.75,
        "sdPlus1": 140.91,
        "sdPlus2": 147.08,
        "sdPlus3": 153.24
    },
    {
        "month": 114,
        "sdMinus3": 116.6,
        "sdMinus2": 122.79,
        "sdMinus1": 128.99,
        "median": 135.18,
        "sdPlus1": 141.38,
        "sdPlus2": 147.57,
        "sdPlus3": 153.77
    },
    {
        "month": 115,
        "sdMinus3": 116.95,
        "sdMinus2": 123.17,
        "sdMinus1": 129.39,
        "median": 135.62,
        "sdPlus1": 141.84,
        "sdPlus2": 148.06,
        "sdPlus3": 154.29
    },
    {
        "month": 116,
        "sdMinus3": 117.29,
        "sdMinus2": 123.54,
        "sdMinus1": 129.8,
        "median": 136.05,
        "sdPlus1": 142.3,
        "sdPlus2": 148.56,
        "sdPlus3": 154.81
    },
    {
        "month": 117,
        "sdMinus3": 117.63,
        "sdMinus2": 123.92,
        "sdMinus1": 130.2,
        "median": 136.48,
        "sdPlus1": 142.77,
        "sdPlus2": 149.05,
        "sdPlus3": 155.33
    },
    {
        "month": 118,
        "sdMinus3": 117.97,
        "sdMinus2": 124.29,
        "sdMinus1": 130.6,
        "median": 136.92,
        "sdPlus1": 143.23,
        "sdPlus2": 149.54,
        "sdPlus3": 155.86
    },
    {
        "month": 119,
        "sdMinus3": 118.32,
        "sdMinus2": 124.66,
        "sdMinus1": 131.0,
        "median": 137.35,
        "sdPlus1": 143.69,
        "sdPlus2": 150.04,
        "sdPlus3": 156.38
    },
    {
        "month": 120,
        "sdMinus3": 118.66,
        "sdMinus2": 125.03,
        "sdMinus1": 131.41,
        "median": 137.78,
        "sdPlus1": 144.15,
        "sdPlus2": 150.53,
        "sdPlus3": 156.9
    },
    {
        "month": 121,
        "sdMinus3": 119.0,
        "sdMinus2": 125.41,
        "sdMinus1": 131.81,
        "median": 138.21,
        "sdPlus1": 144.62,
        "sdPlus2": 151.02,
        "sdPlus3": 157.42
    },
    {
        "month": 122,
        "sdMinus3": 119.35,
        "sdMinus2": 125.78,
        "sdMinus1": 132.21,
        "median": 138.65,
        "sdPlus1": 145.08,
        "sdPlus2": 151.51,
        "sdPlus3": 157.94
    },
    {
        "month": 123,
        "sdMinus3": 119.69,
        "sdMinus2": 126.15,
        "sdMinus1": 132.62,
        "median": 139.08,
        "sdPlus1": 145.54,
        "sdPlus2": 152.01,
        "sdPlus3": 158.47
    },
    {
        "month": 124,
        "sdMinus3": 120.04,
        "sdMinus2": 126.53,
        "sdMinus1": 133.02,
        "median": 139.52,
        "sdPlus1": 146.01,
        "sdPlus2": 152.5,
        "sdPlus3": 158.99
    },
    {
        "month": 125,
        "sdMinus3": 120.38,
        "sdMinus2": 126.91,
        "sdMinus1": 133.43,
        "median": 139.95,
        "sdPlus1": 146.48,
        "sdPlus2": 153.0,
        "sdPlus3": 159.52
    },
    {
        "month": 126,
        "sdMinus3": 120.74,
        "sdMinus2": 127.29,
        "sdMinus1": 133.84,
        "median": 140.39,
        "sdPlus1": 146.95,
        "sdPlus2": 153.5,
        "sdPlus3": 160.05
    },
    {
        "month": 127,
        "sdMinus3": 121.09,
        "sdMinus2": 127.67,
        "sdMinus1": 134.26,
        "median": 140.84,
        "sdPlus1": 147.42,
        "sdPlus2": 154.0,
        "sdPlus3": 160.59
    },
    {
        "month": 128,
        "sdMinus3": 121.45,
        "sdMinus2": 128.06,
        "sdMinus1": 134.67,
        "median": 141.29,
        "sdPlus1": 147.9,
        "sdPlus2": 154.51,
        "sdPlus3": 161.12
    },
    {
        "month": 129,
        "sdMinus3": 121.81,
        "sdMinus2": 128.45,
        "sdMinus1": 135.1,
        "median": 141.74,
        "sdPlus1": 148.38,
        "sdPlus2": 155.02,
        "sdPlus3": 161.66
    },
    {
        "month": 130,
        "sdMinus3": 122.18,
        "sdMinus2": 128.85,
        "sdMinus1": 135.52,
        "median": 142.19,
        "sdPlus1": 148.86,
        "sdPlus2": 155.53,
        "sdPlus3": 162.21
    },
    {
        "month": 131,
        "sdMinus3": 122.54,
        "sdMinus2": 129.25,
        "sdMinus1": 135.95,
        "median": 142.65,
        "sdPlus1": 149.35,
        "sdPlus2": 156.05,
        "sdPlus3": 162.76
    },
    {
        "month": 132,
        "sdMinus3": 122.92,
        "sdMinus2": 129.65,
        "sdMinus1": 136.38,
        "median": 143.11,
        "sdPlus1": 149.84,
        "sdPlus2": 156.57,
        "sdPlus3": 163.3
    }
];

export const WHO_BMI_GIRLS_5_11 = [
    {
        "month": 60,
        "sdMinus3": 11.6,
        "sdMinus2": 12.7,
        "sdMinus1": 13.9,
        "median": 15.3,
        "sdPlus1": 16.9,
        "sdPlus2": 18.8,
        "sdPlus3": 21.1
    },
    {
        "month": 61,
        "sdMinus3": 11.77,
        "sdMinus2": 12.75,
        "sdMinus1": 13.89,
        "median": 15.24,
        "sdPlus1": 16.87,
        "sdPlus2": 18.86,
        "sdPlus3": 21.34
    },
    {
        "month": 62,
        "sdMinus3": 11.76,
        "sdMinus2": 12.74,
        "sdMinus1": 13.89,
        "median": 15.24,
        "sdPlus1": 16.88,
        "sdPlus2": 18.89,
        "sdPlus3": 21.4
    },
    {
        "month": 63,
        "sdMinus3": 11.76,
        "sdMinus2": 12.73,
        "sdMinus1": 13.88,
        "median": 15.24,
        "sdPlus1": 16.89,
        "sdPlus2": 18.92,
        "sdPlus3": 21.47
    },
    {
        "month": 64,
        "sdMinus3": 11.75,
        "sdMinus2": 12.73,
        "sdMinus1": 13.88,
        "median": 15.24,
        "sdPlus1": 16.9,
        "sdPlus2": 18.95,
        "sdPlus3": 21.53
    },
    {
        "month": 65,
        "sdMinus3": 11.75,
        "sdMinus2": 12.72,
        "sdMinus1": 13.87,
        "median": 15.24,
        "sdPlus1": 16.91,
        "sdPlus2": 18.98,
        "sdPlus3": 21.6
    },
    {
        "month": 66,
        "sdMinus3": 11.74,
        "sdMinus2": 12.72,
        "sdMinus1": 13.87,
        "median": 15.25,
        "sdPlus1": 16.92,
        "sdPlus2": 19.01,
        "sdPlus3": 21.67
    },
    {
        "month": 67,
        "sdMinus3": 11.74,
        "sdMinus2": 12.71,
        "sdMinus1": 13.87,
        "median": 15.25,
        "sdPlus1": 16.94,
        "sdPlus2": 19.04,
        "sdPlus3": 21.75
    },
    {
        "month": 68,
        "sdMinus3": 11.73,
        "sdMinus2": 12.71,
        "sdMinus1": 13.86,
        "median": 15.25,
        "sdPlus1": 16.95,
        "sdPlus2": 19.08,
        "sdPlus3": 21.82
    },
    {
        "month": 69,
        "sdMinus3": 11.73,
        "sdMinus2": 12.71,
        "sdMinus1": 13.86,
        "median": 15.26,
        "sdPlus1": 16.96,
        "sdPlus2": 19.11,
        "sdPlus3": 21.89
    },
    {
        "month": 70,
        "sdMinus3": 11.73,
        "sdMinus2": 12.7,
        "sdMinus1": 13.86,
        "median": 15.26,
        "sdPlus1": 16.98,
        "sdPlus2": 19.15,
        "sdPlus3": 21.97
    },
    {
        "month": 71,
        "sdMinus3": 11.73,
        "sdMinus2": 12.7,
        "sdMinus1": 13.86,
        "median": 15.26,
        "sdPlus1": 16.99,
        "sdPlus2": 19.19,
        "sdPlus3": 22.05
    },
    {
        "month": 72,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.86,
        "median": 15.27,
        "sdPlus1": 17.01,
        "sdPlus2": 19.22,
        "sdPlus3": 22.13
    },
    {
        "month": 73,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.86,
        "median": 15.28,
        "sdPlus1": 17.03,
        "sdPlus2": 19.26,
        "sdPlus3": 22.22
    },
    {
        "month": 74,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.86,
        "median": 15.28,
        "sdPlus1": 17.05,
        "sdPlus2": 19.3,
        "sdPlus3": 22.3
    },
    {
        "month": 75,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.87,
        "median": 15.29,
        "sdPlus1": 17.07,
        "sdPlus2": 19.35,
        "sdPlus3": 22.39
    },
    {
        "month": 76,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.87,
        "median": 15.3,
        "sdPlus1": 17.09,
        "sdPlus2": 19.39,
        "sdPlus3": 22.48
    },
    {
        "month": 77,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.87,
        "median": 15.31,
        "sdPlus1": 17.11,
        "sdPlus2": 19.44,
        "sdPlus3": 22.57
    },
    {
        "month": 78,
        "sdMinus3": 11.72,
        "sdMinus2": 12.7,
        "sdMinus1": 13.88,
        "median": 15.32,
        "sdPlus1": 17.13,
        "sdPlus2": 19.48,
        "sdPlus3": 22.67
    },
    {
        "month": 79,
        "sdMinus3": 11.73,
        "sdMinus2": 12.71,
        "sdMinus1": 13.88,
        "median": 15.33,
        "sdPlus1": 17.15,
        "sdPlus2": 19.53,
        "sdPlus3": 22.77
    },
    {
        "month": 80,
        "sdMinus3": 11.73,
        "sdMinus2": 12.71,
        "sdMinus1": 13.89,
        "median": 15.34,
        "sdPlus1": 17.18,
        "sdPlus2": 19.58,
        "sdPlus3": 22.86
    },
    {
        "month": 81,
        "sdMinus3": 11.73,
        "sdMinus2": 12.72,
        "sdMinus1": 13.9,
        "median": 15.36,
        "sdPlus1": 17.2,
        "sdPlus2": 19.63,
        "sdPlus3": 22.97
    },
    {
        "month": 82,
        "sdMinus3": 11.74,
        "sdMinus2": 12.72,
        "sdMinus1": 13.91,
        "median": 15.37,
        "sdPlus1": 17.23,
        "sdPlus2": 19.68,
        "sdPlus3": 23.07
    },
    {
        "month": 83,
        "sdMinus3": 11.74,
        "sdMinus2": 12.73,
        "sdMinus1": 13.92,
        "median": 15.39,
        "sdPlus1": 17.26,
        "sdPlus2": 19.73,
        "sdPlus3": 23.18
    },
    {
        "month": 84,
        "sdMinus3": 11.75,
        "sdMinus2": 12.73,
        "sdMinus1": 13.93,
        "median": 15.4,
        "sdPlus1": 17.29,
        "sdPlus2": 19.79,
        "sdPlus3": 23.29
    },
    {
        "month": 85,
        "sdMinus3": 11.76,
        "sdMinus2": 12.74,
        "sdMinus1": 13.94,
        "median": 15.42,
        "sdPlus1": 17.32,
        "sdPlus2": 19.85,
        "sdPlus3": 23.4
    },
    {
        "month": 86,
        "sdMinus3": 11.77,
        "sdMinus2": 12.75,
        "sdMinus1": 13.95,
        "median": 15.44,
        "sdPlus1": 17.35,
        "sdPlus2": 19.9,
        "sdPlus3": 23.51
    },
    {
        "month": 87,
        "sdMinus3": 11.77,
        "sdMinus2": 12.76,
        "sdMinus1": 13.96,
        "median": 15.46,
        "sdPlus1": 17.38,
        "sdPlus2": 19.96,
        "sdPlus3": 23.63
    },
    {
        "month": 88,
        "sdMinus3": 11.78,
        "sdMinus2": 12.77,
        "sdMinus1": 13.98,
        "median": 15.48,
        "sdPlus1": 17.42,
        "sdPlus2": 20.02,
        "sdPlus3": 23.75
    },
    {
        "month": 89,
        "sdMinus3": 11.79,
        "sdMinus2": 12.78,
        "sdMinus1": 13.99,
        "median": 15.5,
        "sdPlus1": 17.45,
        "sdPlus2": 20.09,
        "sdPlus3": 23.87
    },
    {
        "month": 90,
        "sdMinus3": 11.8,
        "sdMinus2": 12.8,
        "sdMinus1": 14.01,
        "median": 15.52,
        "sdPlus1": 17.49,
        "sdPlus2": 20.15,
        "sdPlus3": 23.99
    },
    {
        "month": 91,
        "sdMinus3": 11.81,
        "sdMinus2": 12.81,
        "sdMinus1": 14.02,
        "median": 15.55,
        "sdPlus1": 17.53,
        "sdPlus2": 20.21,
        "sdPlus3": 24.12
    },
    {
        "month": 92,
        "sdMinus3": 11.83,
        "sdMinus2": 12.82,
        "sdMinus1": 14.04,
        "median": 15.57,
        "sdPlus1": 17.56,
        "sdPlus2": 20.28,
        "sdPlus3": 24.25
    },
    {
        "month": 93,
        "sdMinus3": 11.84,
        "sdMinus2": 12.84,
        "sdMinus1": 14.06,
        "median": 15.6,
        "sdPlus1": 17.6,
        "sdPlus2": 20.35,
        "sdPlus3": 24.38
    },
    {
        "month": 94,
        "sdMinus3": 11.85,
        "sdMinus2": 12.85,
        "sdMinus1": 14.08,
        "median": 15.62,
        "sdPlus1": 17.64,
        "sdPlus2": 20.42,
        "sdPlus3": 24.51
    },
    {
        "month": 95,
        "sdMinus3": 11.86,
        "sdMinus2": 12.87,
        "sdMinus1": 14.1,
        "median": 15.65,
        "sdPlus1": 17.69,
        "sdPlus2": 20.49,
        "sdPlus3": 24.64
    },
    {
        "month": 96,
        "sdMinus3": 11.88,
        "sdMinus2": 12.88,
        "sdMinus1": 14.12,
        "median": 15.68,
        "sdPlus1": 17.73,
        "sdPlus2": 20.56,
        "sdPlus3": 24.78
    },
    {
        "month": 97,
        "sdMinus3": 11.89,
        "sdMinus2": 12.9,
        "sdMinus1": 14.14,
        "median": 15.71,
        "sdPlus1": 17.77,
        "sdPlus2": 20.63,
        "sdPlus3": 24.92
    },
    {
        "month": 98,
        "sdMinus3": 11.91,
        "sdMinus2": 12.92,
        "sdMinus1": 14.16,
        "median": 15.74,
        "sdPlus1": 17.82,
        "sdPlus2": 20.71,
        "sdPlus3": 25.06
    },
    {
        "month": 99,
        "sdMinus3": 11.93,
        "sdMinus2": 12.94,
        "sdMinus1": 14.19,
        "median": 15.77,
        "sdPlus1": 17.87,
        "sdPlus2": 20.78,
        "sdPlus3": 25.2
    },
    {
        "month": 100,
        "sdMinus3": 11.94,
        "sdMinus2": 12.96,
        "sdMinus1": 14.21,
        "median": 15.81,
        "sdPlus1": 17.91,
        "sdPlus2": 20.86,
        "sdPlus3": 25.35
    },
    {
        "month": 101,
        "sdMinus3": 11.96,
        "sdMinus2": 12.98,
        "sdMinus1": 14.24,
        "median": 15.84,
        "sdPlus1": 17.96,
        "sdPlus2": 20.94,
        "sdPlus3": 25.49
    },
    {
        "month": 102,
        "sdMinus3": 11.98,
        "sdMinus2": 13.0,
        "sdMinus1": 14.26,
        "median": 15.87,
        "sdPlus1": 18.01,
        "sdPlus2": 21.02,
        "sdPlus3": 25.64
    },
    {
        "month": 103,
        "sdMinus3": 12.0,
        "sdMinus2": 13.02,
        "sdMinus1": 14.29,
        "median": 15.91,
        "sdPlus1": 18.06,
        "sdPlus2": 21.1,
        "sdPlus3": 25.79
    },
    {
        "month": 104,
        "sdMinus3": 12.02,
        "sdMinus2": 13.05,
        "sdMinus1": 14.32,
        "median": 15.95,
        "sdPlus1": 18.11,
        "sdPlus2": 21.18,
        "sdPlus3": 25.93
    },
    {
        "month": 105,
        "sdMinus3": 12.04,
        "sdMinus2": 13.07,
        "sdMinus1": 14.35,
        "median": 15.98,
        "sdPlus1": 18.17,
        "sdPlus2": 21.26,
        "sdPlus3": 26.09
    },
    {
        "month": 106,
        "sdMinus3": 12.06,
        "sdMinus2": 13.09,
        "sdMinus1": 14.38,
        "median": 16.02,
        "sdPlus1": 18.22,
        "sdPlus2": 21.35,
        "sdPlus3": 26.24
    },
    {
        "month": 107,
        "sdMinus3": 12.08,
        "sdMinus2": 13.12,
        "sdMinus1": 14.4,
        "median": 16.06,
        "sdPlus1": 18.27,
        "sdPlus2": 21.43,
        "sdPlus3": 26.39
    },
    {
        "month": 108,
        "sdMinus3": 12.1,
        "sdMinus2": 13.14,
        "sdMinus1": 14.43,
        "median": 16.1,
        "sdPlus1": 18.33,
        "sdPlus2": 21.51,
        "sdPlus3": 26.54
    },
    {
        "month": 109,
        "sdMinus3": 12.12,
        "sdMinus2": 13.16,
        "sdMinus1": 14.46,
        "median": 16.14,
        "sdPlus1": 18.38,
        "sdPlus2": 21.6,
        "sdPlus3": 26.69
    },
    {
        "month": 110,
        "sdMinus3": 12.14,
        "sdMinus2": 13.19,
        "sdMinus1": 14.5,
        "median": 16.18,
        "sdPlus1": 18.44,
        "sdPlus2": 21.68,
        "sdPlus3": 26.85
    },
    {
        "month": 111,
        "sdMinus3": 12.16,
        "sdMinus2": 13.22,
        "sdMinus1": 14.53,
        "median": 16.22,
        "sdPlus1": 18.49,
        "sdPlus2": 21.77,
        "sdPlus3": 27.0
    },
    {
        "month": 112,
        "sdMinus3": 12.19,
        "sdMinus2": 13.24,
        "sdMinus1": 14.56,
        "median": 16.26,
        "sdPlus1": 18.55,
        "sdPlus2": 21.86,
        "sdPlus3": 27.15
    },
    {
        "month": 113,
        "sdMinus3": 12.21,
        "sdMinus2": 13.27,
        "sdMinus1": 14.59,
        "median": 16.3,
        "sdPlus1": 18.61,
        "sdPlus2": 21.94,
        "sdPlus3": 27.31
    },
    {
        "month": 114,
        "sdMinus3": 12.23,
        "sdMinus2": 13.3,
        "sdMinus1": 14.63,
        "median": 16.34,
        "sdPlus1": 18.67,
        "sdPlus2": 22.03,
        "sdPlus3": 27.46
    },
    {
        "month": 115,
        "sdMinus3": 12.25,
        "sdMinus2": 13.32,
        "sdMinus1": 14.66,
        "median": 16.39,
        "sdPlus1": 18.73,
        "sdPlus2": 22.12,
        "sdPlus3": 27.61
    },
    {
        "month": 116,
        "sdMinus3": 12.28,
        "sdMinus2": 13.35,
        "sdMinus1": 14.69,
        "median": 16.43,
        "sdPlus1": 18.79,
        "sdPlus2": 22.21,
        "sdPlus3": 27.76
    },
    {
        "month": 117,
        "sdMinus3": 12.3,
        "sdMinus2": 13.38,
        "sdMinus1": 14.73,
        "median": 16.47,
        "sdPlus1": 18.85,
        "sdPlus2": 22.3,
        "sdPlus3": 27.92
    },
    {
        "month": 118,
        "sdMinus3": 12.33,
        "sdMinus2": 13.41,
        "sdMinus1": 14.76,
        "median": 16.52,
        "sdPlus1": 18.91,
        "sdPlus2": 22.39,
        "sdPlus3": 28.07
    },
    {
        "month": 119,
        "sdMinus3": 12.35,
        "sdMinus2": 13.44,
        "sdMinus1": 14.8,
        "median": 16.57,
        "sdPlus1": 18.97,
        "sdPlus2": 22.48,
        "sdPlus3": 28.23
    },
    {
        "month": 120,
        "sdMinus3": 12.38,
        "sdMinus2": 13.47,
        "sdMinus1": 14.84,
        "median": 16.61,
        "sdPlus1": 19.03,
        "sdPlus2": 22.57,
        "sdPlus3": 28.38
    },
    {
        "month": 121,
        "sdMinus3": 12.4,
        "sdMinus2": 13.5,
        "sdMinus1": 14.88,
        "median": 16.66,
        "sdPlus1": 19.1,
        "sdPlus2": 22.66,
        "sdPlus3": 28.53
    },
    {
        "month": 122,
        "sdMinus3": 12.43,
        "sdMinus2": 13.53,
        "sdMinus1": 14.91,
        "median": 16.71,
        "sdPlus1": 19.16,
        "sdPlus2": 22.76,
        "sdPlus3": 28.68
    },
    {
        "month": 123,
        "sdMinus3": 12.46,
        "sdMinus2": 13.56,
        "sdMinus1": 14.95,
        "median": 16.76,
        "sdPlus1": 19.23,
        "sdPlus2": 22.85,
        "sdPlus3": 28.83
    },
    {
        "month": 124,
        "sdMinus3": 12.49,
        "sdMinus2": 13.6,
        "sdMinus1": 14.99,
        "median": 16.81,
        "sdPlus1": 19.29,
        "sdPlus2": 22.94,
        "sdPlus3": 28.99
    },
    {
        "month": 125,
        "sdMinus3": 12.51,
        "sdMinus2": 13.63,
        "sdMinus1": 15.03,
        "median": 16.86,
        "sdPlus1": 19.36,
        "sdPlus2": 23.04,
        "sdPlus3": 29.14
    },
    {
        "month": 126,
        "sdMinus3": 12.54,
        "sdMinus2": 13.67,
        "sdMinus1": 15.08,
        "median": 16.91,
        "sdPlus1": 19.43,
        "sdPlus2": 23.13,
        "sdPlus3": 29.29
    },
    {
        "month": 127,
        "sdMinus3": 12.57,
        "sdMinus2": 13.7,
        "sdMinus1": 15.12,
        "median": 16.97,
        "sdPlus1": 19.5,
        "sdPlus2": 23.23,
        "sdPlus3": 29.44
    },
    {
        "month": 128,
        "sdMinus3": 12.6,
        "sdMinus2": 13.74,
        "sdMinus1": 15.16,
        "median": 17.02,
        "sdPlus1": 19.57,
        "sdPlus2": 23.33,
        "sdPlus3": 29.59
    },
    {
        "month": 129,
        "sdMinus3": 12.63,
        "sdMinus2": 13.77,
        "sdMinus1": 15.21,
        "median": 17.08,
        "sdPlus1": 19.64,
        "sdPlus2": 23.43,
        "sdPlus3": 29.74
    },
    {
        "month": 130,
        "sdMinus3": 12.66,
        "sdMinus2": 13.81,
        "sdMinus1": 15.25,
        "median": 17.13,
        "sdPlus1": 19.71,
        "sdPlus2": 23.52,
        "sdPlus3": 29.89
    },
    {
        "month": 131,
        "sdMinus3": 12.7,
        "sdMinus2": 13.85,
        "sdMinus1": 15.3,
        "median": 17.19,
        "sdPlus1": 19.78,
        "sdPlus2": 23.62,
        "sdPlus3": 30.04
    },
    {
        "month": 132,
        "sdMinus3": 12.73,
        "sdMinus2": 13.89,
        "sdMinus1": 15.34,
        "median": 17.25,
        "sdPlus1": 19.86,
        "sdPlus2": 23.72,
        "sdPlus3": 30.19
    }
];

export const WHO_BMI_BOYS_5_11 = [
    {
        "month": 60,
        "sdMinus3": 12.0,
        "sdMinus2": 12.9,
        "sdMinus1": 14.0,
        "median": 15.2,
        "sdPlus1": 16.6,
        "sdPlus2": 18.3,
        "sdPlus3": 20.3
    },
    {
        "month": 61,
        "sdMinus3": 12.12,
        "sdMinus2": 13.03,
        "sdMinus1": 14.07,
        "median": 15.26,
        "sdPlus1": 16.65,
        "sdPlus2": 18.26,
        "sdPlus3": 20.17
    },
    {
        "month": 62,
        "sdMinus3": 12.12,
        "sdMinus2": 13.03,
        "sdMinus1": 14.07,
        "median": 15.26,
        "sdPlus1": 16.65,
        "sdPlus2": 18.27,
        "sdPlus3": 20.2
    },
    {
        "month": 63,
        "sdMinus3": 12.11,
        "sdMinus2": 13.02,
        "sdMinus1": 14.06,
        "median": 15.26,
        "sdPlus1": 16.65,
        "sdPlus2": 18.29,
        "sdPlus3": 20.24
    },
    {
        "month": 64,
        "sdMinus3": 12.11,
        "sdMinus2": 13.02,
        "sdMinus1": 14.06,
        "median": 15.26,
        "sdPlus1": 16.66,
        "sdPlus2": 18.31,
        "sdPlus3": 20.28
    },
    {
        "month": 65,
        "sdMinus3": 12.11,
        "sdMinus2": 13.02,
        "sdMinus1": 14.06,
        "median": 15.26,
        "sdPlus1": 16.67,
        "sdPlus2": 18.33,
        "sdPlus3": 20.32
    },
    {
        "month": 66,
        "sdMinus3": 12.12,
        "sdMinus2": 13.02,
        "sdMinus1": 14.06,
        "median": 15.26,
        "sdPlus1": 16.68,
        "sdPlus2": 18.35,
        "sdPlus3": 20.36
    },
    {
        "month": 67,
        "sdMinus3": 12.12,
        "sdMinus2": 13.02,
        "sdMinus1": 14.06,
        "median": 15.27,
        "sdPlus1": 16.69,
        "sdPlus2": 18.37,
        "sdPlus3": 20.41
    },
    {
        "month": 68,
        "sdMinus3": 12.12,
        "sdMinus2": 13.02,
        "sdMinus1": 14.06,
        "median": 15.27,
        "sdPlus1": 16.7,
        "sdPlus2": 18.4,
        "sdPlus3": 20.46
    },
    {
        "month": 69,
        "sdMinus3": 12.12,
        "sdMinus2": 13.03,
        "sdMinus1": 14.07,
        "median": 15.28,
        "sdPlus1": 16.71,
        "sdPlus2": 18.43,
        "sdPlus3": 20.52
    },
    {
        "month": 70,
        "sdMinus3": 12.13,
        "sdMinus2": 13.03,
        "sdMinus1": 14.07,
        "median": 15.29,
        "sdPlus1": 16.73,
        "sdPlus2": 18.46,
        "sdPlus3": 20.57
    },
    {
        "month": 71,
        "sdMinus3": 12.13,
        "sdMinus2": 13.04,
        "sdMinus1": 14.08,
        "median": 15.3,
        "sdPlus1": 16.74,
        "sdPlus2": 18.49,
        "sdPlus3": 20.63
    },
    {
        "month": 72,
        "sdMinus3": 12.14,
        "sdMinus2": 13.04,
        "sdMinus1": 14.08,
        "median": 15.31,
        "sdPlus1": 16.76,
        "sdPlus2": 18.52,
        "sdPlus3": 20.69
    },
    {
        "month": 73,
        "sdMinus3": 12.15,
        "sdMinus2": 13.05,
        "sdMinus1": 14.09,
        "median": 15.32,
        "sdPlus1": 16.78,
        "sdPlus2": 18.55,
        "sdPlus3": 20.75
    },
    {
        "month": 74,
        "sdMinus3": 12.16,
        "sdMinus2": 13.05,
        "sdMinus1": 14.1,
        "median": 15.33,
        "sdPlus1": 16.8,
        "sdPlus2": 18.59,
        "sdPlus3": 20.82
    },
    {
        "month": 75,
        "sdMinus3": 12.16,
        "sdMinus2": 13.06,
        "sdMinus1": 14.11,
        "median": 15.34,
        "sdPlus1": 16.82,
        "sdPlus2": 18.63,
        "sdPlus3": 20.88
    },
    {
        "month": 76,
        "sdMinus3": 12.17,
        "sdMinus2": 13.07,
        "sdMinus1": 14.12,
        "median": 15.35,
        "sdPlus1": 16.84,
        "sdPlus2": 18.66,
        "sdPlus3": 20.95
    },
    {
        "month": 77,
        "sdMinus3": 12.18,
        "sdMinus2": 13.08,
        "sdMinus1": 14.13,
        "median": 15.37,
        "sdPlus1": 16.86,
        "sdPlus2": 18.7,
        "sdPlus3": 21.02
    },
    {
        "month": 78,
        "sdMinus3": 12.19,
        "sdMinus2": 13.09,
        "sdMinus1": 14.14,
        "median": 15.38,
        "sdPlus1": 16.89,
        "sdPlus2": 18.75,
        "sdPlus3": 21.1
    },
    {
        "month": 79,
        "sdMinus3": 12.2,
        "sdMinus2": 13.1,
        "sdMinus1": 14.15,
        "median": 15.4,
        "sdPlus1": 16.91,
        "sdPlus2": 18.79,
        "sdPlus3": 21.17
    },
    {
        "month": 80,
        "sdMinus3": 12.21,
        "sdMinus2": 13.1,
        "sdMinus1": 14.16,
        "median": 15.41,
        "sdPlus1": 16.94,
        "sdPlus2": 18.83,
        "sdPlus3": 21.25
    },
    {
        "month": 81,
        "sdMinus3": 12.22,
        "sdMinus2": 13.12,
        "sdMinus1": 14.17,
        "median": 15.43,
        "sdPlus1": 16.96,
        "sdPlus2": 18.88,
        "sdPlus3": 21.33
    },
    {
        "month": 82,
        "sdMinus3": 12.23,
        "sdMinus2": 13.13,
        "sdMinus1": 14.18,
        "median": 15.45,
        "sdPlus1": 16.99,
        "sdPlus2": 18.92,
        "sdPlus3": 21.41
    },
    {
        "month": 83,
        "sdMinus3": 12.24,
        "sdMinus2": 13.14,
        "sdMinus1": 14.2,
        "median": 15.46,
        "sdPlus1": 17.02,
        "sdPlus2": 18.97,
        "sdPlus3": 21.5
    },
    {
        "month": 84,
        "sdMinus3": 12.25,
        "sdMinus2": 13.15,
        "sdMinus1": 14.21,
        "median": 15.48,
        "sdPlus1": 17.05,
        "sdPlus2": 19.02,
        "sdPlus3": 21.58
    },
    {
        "month": 85,
        "sdMinus3": 12.26,
        "sdMinus2": 13.16,
        "sdMinus1": 14.22,
        "median": 15.5,
        "sdPlus1": 17.08,
        "sdPlus2": 19.07,
        "sdPlus3": 21.67
    },
    {
        "month": 86,
        "sdMinus3": 12.27,
        "sdMinus2": 13.17,
        "sdMinus1": 14.24,
        "median": 15.52,
        "sdPlus1": 17.11,
        "sdPlus2": 19.12,
        "sdPlus3": 21.76
    },
    {
        "month": 87,
        "sdMinus3": 12.28,
        "sdMinus2": 13.18,
        "sdMinus1": 14.25,
        "median": 15.54,
        "sdPlus1": 17.14,
        "sdPlus2": 19.17,
        "sdPlus3": 21.86
    },
    {
        "month": 88,
        "sdMinus3": 12.3,
        "sdMinus2": 13.2,
        "sdMinus1": 14.27,
        "median": 15.56,
        "sdPlus1": 17.17,
        "sdPlus2": 19.22,
        "sdPlus3": 21.95
    },
    {
        "month": 89,
        "sdMinus3": 12.31,
        "sdMinus2": 13.21,
        "sdMinus1": 14.28,
        "median": 15.58,
        "sdPlus1": 17.2,
        "sdPlus2": 19.27,
        "sdPlus3": 22.05
    },
    {
        "month": 90,
        "sdMinus3": 12.32,
        "sdMinus2": 13.22,
        "sdMinus1": 14.3,
        "median": 15.6,
        "sdPlus1": 17.23,
        "sdPlus2": 19.33,
        "sdPlus3": 22.15
    },
    {
        "month": 91,
        "sdMinus3": 12.33,
        "sdMinus2": 13.23,
        "sdMinus1": 14.31,
        "median": 15.62,
        "sdPlus1": 17.26,
        "sdPlus2": 19.38,
        "sdPlus3": 22.25
    },
    {
        "month": 92,
        "sdMinus3": 12.34,
        "sdMinus2": 13.25,
        "sdMinus1": 14.33,
        "median": 15.65,
        "sdPlus1": 17.3,
        "sdPlus2": 19.44,
        "sdPlus3": 22.35
    },
    {
        "month": 93,
        "sdMinus3": 12.36,
        "sdMinus2": 13.26,
        "sdMinus1": 14.34,
        "median": 15.67,
        "sdPlus1": 17.33,
        "sdPlus2": 19.5,
        "sdPlus3": 22.46
    },
    {
        "month": 94,
        "sdMinus3": 12.37,
        "sdMinus2": 13.27,
        "sdMinus1": 14.36,
        "median": 15.69,
        "sdPlus1": 17.37,
        "sdPlus2": 19.56,
        "sdPlus3": 22.56
    },
    {
        "month": 95,
        "sdMinus3": 12.38,
        "sdMinus2": 13.29,
        "sdMinus1": 14.38,
        "median": 15.71,
        "sdPlus1": 17.4,
        "sdPlus2": 19.61,
        "sdPlus3": 22.67
    },
    {
        "month": 96,
        "sdMinus3": 12.39,
        "sdMinus2": 13.3,
        "sdMinus1": 14.39,
        "median": 15.74,
        "sdPlus1": 17.44,
        "sdPlus2": 19.67,
        "sdPlus3": 22.78
    },
    {
        "month": 97,
        "sdMinus3": 12.41,
        "sdMinus2": 13.32,
        "sdMinus1": 14.41,
        "median": 15.76,
        "sdPlus1": 17.47,
        "sdPlus2": 19.74,
        "sdPlus3": 22.9
    },
    {
        "month": 98,
        "sdMinus3": 12.42,
        "sdMinus2": 13.33,
        "sdMinus1": 14.43,
        "median": 15.78,
        "sdPlus1": 17.51,
        "sdPlus2": 19.8,
        "sdPlus3": 23.02
    },
    {
        "month": 99,
        "sdMinus3": 12.43,
        "sdMinus2": 13.35,
        "sdMinus1": 14.45,
        "median": 15.81,
        "sdPlus1": 17.55,
        "sdPlus2": 19.86,
        "sdPlus3": 23.13
    },
    {
        "month": 100,
        "sdMinus3": 12.45,
        "sdMinus2": 13.36,
        "sdMinus1": 14.47,
        "median": 15.83,
        "sdPlus1": 17.59,
        "sdPlus2": 19.93,
        "sdPlus3": 23.25
    },
    {
        "month": 101,
        "sdMinus3": 12.46,
        "sdMinus2": 13.38,
        "sdMinus1": 14.48,
        "median": 15.86,
        "sdPlus1": 17.62,
        "sdPlus2": 19.99,
        "sdPlus3": 23.38
    },
    {
        "month": 102,
        "sdMinus3": 12.47,
        "sdMinus2": 13.39,
        "sdMinus1": 14.5,
        "median": 15.89,
        "sdPlus1": 17.66,
        "sdPlus2": 20.06,
        "sdPlus3": 23.5
    },
    {
        "month": 103,
        "sdMinus3": 12.49,
        "sdMinus2": 13.41,
        "sdMinus1": 14.52,
        "median": 15.91,
        "sdPlus1": 17.7,
        "sdPlus2": 20.12,
        "sdPlus3": 23.63
    },
    {
        "month": 104,
        "sdMinus3": 12.5,
        "sdMinus2": 13.42,
        "sdMinus1": 14.54,
        "median": 15.94,
        "sdPlus1": 17.74,
        "sdPlus2": 20.19,
        "sdPlus3": 23.75
    },
    {
        "month": 105,
        "sdMinus3": 12.52,
        "sdMinus2": 13.44,
        "sdMinus1": 14.56,
        "median": 15.97,
        "sdPlus1": 17.78,
        "sdPlus2": 20.26,
        "sdPlus3": 23.88
    },
    {
        "month": 106,
        "sdMinus3": 12.53,
        "sdMinus2": 13.46,
        "sdMinus1": 14.58,
        "median": 15.99,
        "sdPlus1": 17.82,
        "sdPlus2": 20.33,
        "sdPlus3": 24.02
    },
    {
        "month": 107,
        "sdMinus3": 12.55,
        "sdMinus2": 13.47,
        "sdMinus1": 14.6,
        "median": 16.02,
        "sdPlus1": 17.87,
        "sdPlus2": 20.4,
        "sdPlus3": 24.15
    },
    {
        "month": 108,
        "sdMinus3": 12.56,
        "sdMinus2": 13.49,
        "sdMinus1": 14.62,
        "median": 16.05,
        "sdPlus1": 17.91,
        "sdPlus2": 20.47,
        "sdPlus3": 24.29
    },
    {
        "month": 109,
        "sdMinus3": 12.58,
        "sdMinus2": 13.51,
        "sdMinus1": 14.65,
        "median": 16.08,
        "sdPlus1": 17.95,
        "sdPlus2": 20.54,
        "sdPlus3": 24.43
    },
    {
        "month": 110,
        "sdMinus3": 12.59,
        "sdMinus2": 13.53,
        "sdMinus1": 14.67,
        "median": 16.11,
        "sdPlus1": 18.0,
        "sdPlus2": 20.61,
        "sdPlus3": 24.57
    },
    {
        "month": 111,
        "sdMinus3": 12.61,
        "sdMinus2": 13.54,
        "sdMinus1": 14.69,
        "median": 16.14,
        "sdPlus1": 18.04,
        "sdPlus2": 20.69,
        "sdPlus3": 24.71
    },
    {
        "month": 112,
        "sdMinus3": 12.63,
        "sdMinus2": 13.56,
        "sdMinus1": 14.71,
        "median": 16.17,
        "sdPlus1": 18.09,
        "sdPlus2": 20.76,
        "sdPlus3": 24.85
    },
    {
        "month": 113,
        "sdMinus3": 12.64,
        "sdMinus2": 13.58,
        "sdMinus1": 14.74,
        "median": 16.2,
        "sdPlus1": 18.13,
        "sdPlus2": 20.84,
        "sdPlus3": 25.0
    },
    {
        "month": 114,
        "sdMinus3": 12.66,
        "sdMinus2": 13.6,
        "sdMinus1": 14.76,
        "median": 16.23,
        "sdPlus1": 18.18,
        "sdPlus2": 20.92,
        "sdPlus3": 25.15
    },
    {
        "month": 115,
        "sdMinus3": 12.68,
        "sdMinus2": 13.62,
        "sdMinus1": 14.79,
        "median": 16.27,
        "sdPlus1": 18.23,
        "sdPlus2": 20.99,
        "sdPlus3": 25.3
    },
    {
        "month": 116,
        "sdMinus3": 12.7,
        "sdMinus2": 13.65,
        "sdMinus1": 14.81,
        "median": 16.3,
        "sdPlus1": 18.28,
        "sdPlus2": 21.07,
        "sdPlus3": 25.45
    },
    {
        "month": 117,
        "sdMinus3": 12.72,
        "sdMinus2": 13.67,
        "sdMinus1": 14.84,
        "median": 16.34,
        "sdPlus1": 18.33,
        "sdPlus2": 21.15,
        "sdPlus3": 25.6
    },
    {
        "month": 118,
        "sdMinus3": 12.74,
        "sdMinus2": 13.69,
        "sdMinus1": 14.87,
        "median": 16.37,
        "sdPlus1": 18.38,
        "sdPlus2": 21.23,
        "sdPlus3": 25.76
    },
    {
        "month": 119,
        "sdMinus3": 12.75,
        "sdMinus2": 13.71,
        "sdMinus1": 14.9,
        "median": 16.41,
        "sdPlus1": 18.43,
        "sdPlus2": 21.32,
        "sdPlus3": 25.91
    },
    {
        "month": 120,
        "sdMinus3": 12.78,
        "sdMinus2": 13.74,
        "sdMinus1": 14.92,
        "median": 16.44,
        "sdPlus1": 18.48,
        "sdPlus2": 21.4,
        "sdPlus3": 26.07
    },
    {
        "month": 121,
        "sdMinus3": 12.8,
        "sdMinus2": 13.76,
        "sdMinus1": 14.95,
        "median": 16.48,
        "sdPlus1": 18.53,
        "sdPlus2": 21.48,
        "sdPlus3": 26.23
    },
    {
        "month": 122,
        "sdMinus3": 12.82,
        "sdMinus2": 13.78,
        "sdMinus1": 14.98,
        "median": 16.52,
        "sdPlus1": 18.59,
        "sdPlus2": 21.57,
        "sdPlus3": 26.39
    },
    {
        "month": 123,
        "sdMinus3": 12.84,
        "sdMinus2": 13.81,
        "sdMinus1": 15.01,
        "median": 16.56,
        "sdPlus1": 18.64,
        "sdPlus2": 21.65,
        "sdPlus3": 26.55
    },
    {
        "month": 124,
        "sdMinus3": 12.86,
        "sdMinus2": 13.83,
        "sdMinus1": 15.04,
        "median": 16.6,
        "sdPlus1": 18.7,
        "sdPlus2": 21.74,
        "sdPlus3": 26.71
    },
    {
        "month": 125,
        "sdMinus3": 12.88,
        "sdMinus2": 13.86,
        "sdMinus1": 15.07,
        "median": 16.64,
        "sdPlus1": 18.75,
        "sdPlus2": 21.83,
        "sdPlus3": 26.88
    },
    {
        "month": 126,
        "sdMinus3": 12.91,
        "sdMinus2": 13.89,
        "sdMinus1": 15.11,
        "median": 16.68,
        "sdPlus1": 18.81,
        "sdPlus2": 21.91,
        "sdPlus3": 27.04
    },
    {
        "month": 127,
        "sdMinus3": 12.93,
        "sdMinus2": 13.91,
        "sdMinus1": 15.14,
        "median": 16.72,
        "sdPlus1": 18.87,
        "sdPlus2": 22.0,
        "sdPlus3": 27.2
    },
    {
        "month": 128,
        "sdMinus3": 12.95,
        "sdMinus2": 13.94,
        "sdMinus1": 15.17,
        "median": 16.76,
        "sdPlus1": 18.92,
        "sdPlus2": 22.09,
        "sdPlus3": 27.37
    },
    {
        "month": 129,
        "sdMinus3": 12.98,
        "sdMinus2": 13.97,
        "sdMinus1": 15.21,
        "median": 16.81,
        "sdPlus1": 18.98,
        "sdPlus2": 22.18,
        "sdPlus3": 27.53
    },
    {
        "month": 130,
        "sdMinus3": 13.0,
        "sdMinus2": 14.0,
        "sdMinus1": 15.24,
        "median": 16.85,
        "sdPlus1": 19.04,
        "sdPlus2": 22.27,
        "sdPlus3": 27.7
    },
    {
        "month": 131,
        "sdMinus3": 13.03,
        "sdMinus2": 14.03,
        "sdMinus1": 15.28,
        "median": 16.89,
        "sdPlus1": 19.1,
        "sdPlus2": 22.36,
        "sdPlus3": 27.86
    },
    {
        "month": 132,
        "sdMinus3": 13.05,
        "sdMinus2": 14.06,
        "sdMinus1": 15.31,
        "median": 16.94,
        "sdPlus1": 19.16,
        "sdPlus2": 22.45,
        "sdPlus3": 28.03
    }
];
